webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__http__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(15);


var LOGIN_URL = '/auth/login/';




var auth = {
  authenticated: false,
  login: function login(credentials) {
    var _this = this;

    var payload = {
      email: credentials.email,
      password: credentials.password
    };
    var headers = {
      'X-Consumer-ID': credentials.clientId
    };
    if (credentials.clientId === 'digiteka') {
      LOGIN_URL = '/auth/digiteka-login/';
    }
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(LOGIN_URL, headers, payload).then(function (response) {
        localStorage.setItem('auth_token', response.key);
        localStorage.setItem('client_id', credentials.clientId);
        _this.authenticated = true;
        __WEBPACK_IMPORTED_MODULE_2__store__["b" /* store */].commit('SET_AUTHENTICATED', true);
        resolve();
      }, function (error) {
        reject(error);
      });
    });
  },
  logout: function logout() {
    localStorage.removeItem('auth_token');

    this.authenticated = false;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__store__["f" /* reset */])(__WEBPACK_IMPORTED_MODULE_2__store__["b" /* store */]);
  },
  checkAuth: function checkAuth() {
    var token = localStorage.getItem('auth_token');
    var clientId = localStorage.getItem('client_id');
    console.log(localStorage.getItem('client_id'));
    if (token && clientId) {
      this.authenticated = true;
    } else {
      this.authenticated = false;
    }
    __WEBPACK_IMPORTED_MODULE_2__store__["b" /* store */].commit('SET_AUTHENTICATED', this.authenticated);
  },
  getAuthHeader: function getAuthHeader() {
    return {
      'Authorization': 'Token ' + localStorage.getItem('auth_token'),
      'X-Consumer-Id': localStorage.getItem('client_id')
    };
  }
};

/* harmony default export */ __webpack_exports__["a"] = (auth);

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(27);




var bus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();

/* harmony default export */ __webpack_exports__["a"] = ({
  bus: bus,
  emit: function emit() {
    var _bus;

    (_bus = this.bus).$emit.apply(_bus, arguments);
  }
});

/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return buildUrl; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(27);





var bus = new __WEBPACK_IMPORTED_MODULE_3_vue__["default"]();

var API_URL = "https://api.look-app.net/api/v1";

/* harmony default export */ __webpack_exports__["a"] = ({
  baseUrl: API_URL,
  bus: bus,
  get: function get(url, headers, payload, silent) {
    return this.fetchWrapper('GET', url, headers, payload, silent);
  },
  post: function post(url, headers, payload, silent) {
    return this.fetchWrapper('POST', url, headers, payload, silent);
  },
  patch: function patch(url, headers, payload, silent) {
    return this.fetchWrapper('PATCH', url, headers, payload, silent);
  },
  delete: function _delete(url, headers, silent) {
    return this.fetchWrapper('DELETE', url, headers, undefined, silent);
  },
  fetchWrapper: function fetchWrapper(method, url, headers, payload, silent) {
    var opts = {
      method: method,
      url: buildUrl(url),
      headers: buildHeaders(headers),
      payload: payload,
      silent: silent
    };
    bus.$emit('outbound-request', opts);
    return makeRequestPromise.bind(this)(opts);
  }
});

function buildUrl(url) {
  return API_URL + url;
}

function buildHeaders(extraHeaders) {
  var baseHeaders = {
    Accept: 'application/json'
  };
  var result = {};
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(result, baseHeaders, extraHeaders);
  return result;
}

function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  } else {
    var error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
}

function queryParams(params) {
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(params).map(function (k) {
    return encodeURIComponent(k) + '=' + encodeURIComponent(params[k]);
  }).join('&');
}

function makeRequestPromise(opts) {
  var _this = this;

  var options = {
    method: opts.method,
    headers: opts.headers
  };
  if (options.method === 'POST' || options.method === 'PATCH') {
    options.body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(opts.payload);
    options.headers['Content-Type'] = 'application/json';
  }
  var url = void 0;
  if ((options.method === 'GET' || options.method === 'DELETE') && typeof opts.payload !== 'undefined') {
    url = opts.url + '?' + queryParams(opts.payload);
  } else {
    url = opts.url;
  }
  return fetch(url, options).then(checkStatus).then(function (response) {
    _this.bus.$emit('request-success', response);
    return response.json().catch(function () {
      return {};
    });
  }).catch(function (error) {
    _this.bus.$emit('request-error', error);
    throw error;
  });
}



/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return store; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return initGlobalState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return refreshGlobalState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return refreshGroups; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return reset; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__i18n__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__repositories_BrandRepository__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__repositories_TeamRepository__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__repositories_GroupRepository__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__snackbar__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__repositories_MarkerRepository__ = __webpack_require__(56);







__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* default */]);







var state = {
  brands: null,
  authenticated: false,
  teamId: null,
  consumerName: null,
  consumerLogo: null,
  is_manager: false,
  groups: null,
  consumerHasDescriptionField: null,
  consumerGroup: null,
  editorConsumers: []
};

var mutations = {
  SET_BRANDS: function SET_BRANDS(state, brands) {
    state.brands = brands;
  },
  SET_TEAM: function SET_TEAM(state, data) {
    if (data === null) {
      data = { id: null, consumer: null, is_manager: false, consumer_logo: null, has_description_field: null };
    }
    state.teamId = data.id;
    state.consumerName = data.consumer;
    state.is_manager = data.is_manager;
    state.consumerLogo = data.consumer_logo;
    state.consumerHasDescriptionField = data.has_description_field;
  },
  SET_GROUPS: function SET_GROUPS(state, groups) {
    state.groups = groups;
  },
  SET_AUTHENTICATED: function SET_AUTHENTICATED(state, authenticated) {
    state.authenticated = authenticated;
  },
  SET_CONSUMER_GROUP: function SET_CONSUMER_GROUP(state, consumerGroup) {
    state.consumerGroup = consumerGroup;
  },
  SET_EDITOR_CONSUMERS: function SET_EDITOR_CONSUMERS(state, editorConsumers) {
    state.editorConsumers = editorConsumers;
  }
};

function initGlobalState(store) {
  if (store.state.teamId === null && store.state.authenticated) {
    refreshGlobalState(store);
  }
}

function refreshBrands(store) {
  __WEBPACK_IMPORTED_MODULE_4__repositories_BrandRepository__["a" /* default */].fetchTeamBrands(store.state.teamId).then(function (brands) {
    store.commit('SET_BRANDS', brands);
  });
}

function refreshGroups(store) {
  __WEBPACK_IMPORTED_MODULE_6__repositories_GroupRepository__["a" /* default */].fetchGroups().then(function (groups) {
    store.commit('SET_GROUPS', groups);
  });
}

function refreshGlobalState(store) {
  return __WEBPACK_IMPORTED_MODULE_5__repositories_TeamRepository__["a" /* default */].fetchTeam().then(function (teamData) {
    store.commit('SET_TEAM', teamData);
    refreshBrands(store);
    refreshGroups(store);
    return teamData;
  });
}

function reset(store) {
  store.commit('SET_AUTHENTICATED', false);
  store.commit('SET_BRANDS', null);
  store.commit('SET_TEAM', null);
  store.commit('SET_GROUPS', null);
  store.commit('SET_CONSUMER_GROUP', null);
}

var getters = {
  isLmrConsumer: function isLmrConsumer(store) {
    return true;
  }
};

var actions = {
  syncFtp: function syncFtp(_ref, _ref2) {
    var commit = _ref.commit;
    var markerId = _ref2.markerId,
        showLink = _ref2.showLink;

    return __WEBPACK_IMPORTED_MODULE_8__repositories_MarkerRepository__["a" /* default */].triggerFTPSync(markerId).then(function (response) {
      var dataLink = response.path_to_marker_data;
      var message = __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('marker.ftp.records_link');
      if (showLink !== false) commit('snackbar/show', { href: dataLink, message: message });
    }, function (error) {
      var response = error.response;

      response.json().then(function (json) {
        return json;
      }).catch(function () {}).then(function (json) {
        var nonFieldErrors = json.non_field_errors,
            detail = json.detail;

        var message = nonFieldErrors || detail || __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('marker.ftp.sync_error');
        commit('snackbar/show', { message: message, color: 'error' });
      });
    });
  },
  syncImagesFtp: function syncImagesFtp(_ref3) {
    var commit = _ref3.commit;

    return __WEBPACK_IMPORTED_MODULE_8__repositories_MarkerRepository__["a" /* default */].triggerFTPImagesSync().then(function (response) {}, function (error) {
      error.response.json().then(function (json) {
        var nonFieldErrors = json.non_field_errors,
            detail = json.detail;

        var message = nonFieldErrors || detail || __WEBPACK_IMPORTED_MODULE_3__i18n__["a" /* default */].t('marker.ftp.sync_error');
        commit('snackbar/show', { message: message, color: 'error' });
      });
    });
  },
  getDigitekaXml: function getDigitekaXml(context, record) {
    if (!record.groups.length) return '';
    var mdtk = record.groups[0].mdtk;
    var ownerId = record.groups[0].owner_id;
    var zone = record.groups[0].zone;
    return fetch('https://www.ultimedia.com/api/search/getvideoinfos/mdtk/' + mdtk + '/zone/' + zone + '/owner_id/' + ownerId + '/external_id/' + record.name).then(function (response) {
      return response.text();
    });
  },
  getDigitekaIframe: function getDigitekaIframe(_ref4, recordName) {
    var dispatch = _ref4.dispatch;

    return dispatch('getdigitekaXml', recordName).then(function (text) {
      return text.match(/<iframe[^[\]]+iframe>/);
    });
  },
  getDigitekaLink: function getDigitekaLink(_ref5, record) {
    var dispatch = _ref5.dispatch;

    if (record.digiteka_id) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        resolve(buildDigitakeLink(record));
      });
    } else {
      return dispatch('getDigitekaXml', record).then(function (text) {
        var groups = text.match(/video_id><!\[CDATA\[(\w+)/);
        if (groups && groups.length > 0) {
          var dgId = groups[1];
          record.digiteka_id = dgId;
          return buildDigitakeLink(record);
        }
      });
    }
  },
  buildDigitekaDirectLink: function buildDigitekaDirectLink(context, record) {
    var mdtk = record.groups[0].mdtk;
    var zone = record.groups[0].zone;
    var digitekaId = record.digiteka_id;
    return 'https://www.ultimedia.com/deliver/generic/iframe/mdtk/' + mdtk + '/zone/' + zone + '/src/' + digitekaId;
  }
};

function buildDigitakeLink(record) {
  var mdtk = record.groups[0].mdtk;
  var id = record.digiteka_id;
  var zone = record.groups[0].zone;
  return 'https://www.ultimedia.com/default/index/videogeneric/id/' + id + '/showtitle/1/viewnc/1/mdtk/' + mdtk + '/zone/' + zone;
}

var modules = {
  snackbar: __WEBPACK_IMPORTED_MODULE_7__snackbar__["a" /* default */]
};
var store = new __WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* default */].Store({ state: state, actions: actions, mutations: mutations, getters: getters, modules: modules });

/* harmony default export */ __webpack_exports__["c"] = (store);



/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__events__ = __webpack_require__(9);





var DATETIME_API_INPUT_FORMAT = 'YYYY-MM-DDTHH:mm:ss';

/* harmony default export */ __webpack_exports__["a"] = ({
  longFormat: function longFormat(datetime) {
    return this.updateInstanceLocale(datetime).format('lll');
  },
  dateFormat: function dateFormat(datetime) {
    return this.updateInstanceLocale(datetime).format('ll');
  },
  timeFormat: function timeFormat(datetime) {
    return this.updateInstanceLocale(datetime).format('LT');
  },
  tzFormat: function tzFormat(datetime) {
    return this.updateInstanceLocale(datetime).format('z');
  },
  parseDate: function parseDate(timestamp) {
    return __WEBPACK_IMPORTED_MODULE_0_moment___default.a.utc(timestamp).local();
  },
  toApiFormat: function toApiFormat(datetime) {
    return datetime.utc().format(DATETIME_API_INPUT_FORMAT);
  },
  fromNow: function fromNow(timestamp) {
    return this.parseDate(timestamp).fromNow(true);
  },
  now: function now() {
    return __WEBPACK_IMPORTED_MODULE_0_moment___default()();
  },
  updateInstanceLocale: function updateInstanceLocale(m) {
    return m.locale(__WEBPACK_IMPORTED_MODULE_0_moment___default.a.locale());
  },
  updateLocale: function updateLocale(l) {
    __WEBPACK_IMPORTED_MODULE_0_moment___default.a.locale(l);
    __WEBPACK_IMPORTED_MODULE_1__events__["a" /* default */].bus.$emit('locale-changed', l);
  },

  bus: __WEBPACK_IMPORTED_MODULE_1__events__["a" /* default */].bus
});

/***/ }),
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_http__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_auth__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(15);








var BASE_ROUTE = '/marker';
var BASE_RECORD_ROUTE = '/record';

/* harmony default export */ __webpack_exports__["a"] = ({
  fetchMarkerRecords: function fetchMarkerRecords(marker, page, pageSize, ordering, department) {
    var filters = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
    var recordType = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '';
    var activeTab = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 'new';
    var ids = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];

    var query = '';
    var offset = (page - 1) * pageSize;
    var isDeleted = 'False';

    if (activeTab === 'deleted' || activeTab === 1) isDeleted = 'True';
    var approved = null;
    if (activeTab === 'approved') approved = 'True';else approved = 'False';
    var getParams = {
      'tags': filters.tags || [],
      'record_type': recordType,
      'is_deleted': isDeleted,
      'limit': pageSize,
      'offset': offset,
      'ids': ids,
      'ordering': ordering,
      'department': department
    };
    if (approved) getParams.approved_ghosts = approved;
    if (filters.lmr_category) getParams.lmr_category = filters.lmr_category;
    if (filters.lmr_cities.length) getParams.lmr_cities = filters.lmr_cities;
    if (filters.editor_consumers.length) getParams.editor_consumers = filters.editor_consumers;
    if (filters.user) getParams.source__user = filters.user.pk;
    if (filters.sdk_record) getParams.sdk_record = filters.sdk_record;
    if (recordType === 'VIDEO') {
      if (filters.inappropriate === 'only') {
        getParams.is_inappropriate = 'True';
      } else if (filters.inappropriate === 'hide') {
        getParams.is_inappropriate = 'False';
      }
    }
    query = encodeQueryData(getParams);

    var baseUrl = markerRecordsBaseUrl(marker && marker.id);
    var url = baseUrl + '/?' + query;
    return __WEBPACK_IMPORTED_MODULE_2__services_http__["a" /* default */].get(url, __WEBPACK_IMPORTED_MODULE_3__services_auth__["a" /* default */].getAuthHeader(), undefined, true).then(apiListToModels).then(function (records) {
      if (marker && recordType === 'VIDEO' && records.count > 0) {
        fetchMLData(records, marker);
      }
      return records;
    });
  },

  fetchMarkerRecordsByIds: function fetchMarkerRecordsByIds(marker, recordType) {
    var ids = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    var query = encodeQueryData({ 'ids': ids });
    var baseUrl = markerRecordsBaseUrl(marker.id);
    var url = baseUrl + '/?' + query;
    return __WEBPACK_IMPORTED_MODULE_2__services_http__["a" /* default */].get(url, __WEBPACK_IMPORTED_MODULE_3__services_auth__["a" /* default */].getAuthHeader(), undefined, true).then(apiListToModels).then(function (records) {
      if (marker && recordType === 'VIDEO' && records.count > 0) {
        fetchMLData(records, marker);
      }
      return records;
    });
  },

  fetchMarkerRecordCoords: function fetchMarkerRecordCoords(markerId) {
    var filters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var recordType = arguments[2];
    var activeTab = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

    var query = '';
    var isDeleted = 'False';
    if (activeTab === 0) isDeleted = 'False';else isDeleted = 'True';
    var getParams = {
      'tags': filters.tags || [],
      'record_type': recordType,
      'is_deleted': isDeleted
    };
    if (filters.lmr_category) {
      getParams.lmr_category = filters.lmr_category;
    }
    if (filters.lmr_cities.length) {
      getParams.lmr_cities = filters.lmr_cities;
    }
    if (recordType === 'VIDEO') {
      if (filters.inappropriate === 'only') {
        getParams.is_inappropriate = 'True';
      } else if (filters.inappropriate === 'hide') {
        getParams.is_inappropriate = 'False';
      }
    }
    query = encodeQueryData(getParams);
    var baseUrl = markerRecordCoordsBaseUrl(markerId);
    var url = baseUrl + '/?' + query;
    return __WEBPACK_IMPORTED_MODULE_2__services_http__["a" /* default */].get(url, __WEBPACK_IMPORTED_MODULE_3__services_auth__["a" /* default */].getAuthHeader(), undefined, true);
  },

  fetchMarkerRecordTags: function fetchMarkerRecordTags(markerId) {
    var baseUrl = markerRecordsBaseUrl(markerId);
    var url = baseUrl + '/tags/';
    return __WEBPACK_IMPORTED_MODULE_2__services_http__["a" /* default */].get(url, __WEBPACK_IMPORTED_MODULE_3__services_auth__["a" /* default */].getAuthHeader(), undefined, true);
  },

  fetchMarkerRelatedRecords: function fetchMarkerRelatedRecords(markerId) {
    var activeTab = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    var isDeleted = 'False';
    if (activeTab === 0) isDeleted = 'False';else isDeleted = 'True';
    var query = encodeQueryData({ 'is_deleted': isDeleted });
    var baseUrl = BASE_ROUTE + '/' + markerId + '/record/vod/related';
    var url = baseUrl + '/?' + query;
    return __WEBPACK_IMPORTED_MODULE_2__services_http__["a" /* default */].get(url, __WEBPACK_IMPORTED_MODULE_3__services_auth__["a" /* default */].getAuthHeader(), undefined, true);
  },

  fetchSimilarRecords: function fetchSimilarRecords(markerId, recordId) {
    return __WEBPACK_IMPORTED_MODULE_2__services_http__["a" /* default */].get(BASE_ROUTE + '/' + markerId + '/record/vod/' + recordId + '/similar/', __WEBPACK_IMPORTED_MODULE_3__services_auth__["a" /* default */].getAuthHeader(), undefined, true);
  },

  fetchMarkerRecordsDiversityTree: function fetchMarkerRecordsDiversityTree(markerId) {
    return __WEBPACK_IMPORTED_MODULE_2__services_http__["a" /* default */].get(BASE_ROUTE + '/' + markerId + '/record/vod/diversity/', __WEBPACK_IMPORTED_MODULE_3__services_auth__["a" /* default */].getAuthHeader(), undefined, true);
  },

  deleteRecord: function deleteRecord(markerId, record) {
    var baseUrl = markerRecordsBaseUrl(markerId);
    return __WEBPACK_IMPORTED_MODULE_2__services_http__["a" /* default */].delete(baseUrl + '/' + record.id + '/', __WEBPACK_IMPORTED_MODULE_3__services_auth__["a" /* default */].getAuthHeader());
  },

  restoreRecord: function restoreRecord(markerId, record) {
    var payload = {
      'mldata': {
        'deleted_at': null
      }
    };
    return this.patchRecord(markerId, record, payload);
  },
  rejectRecords: function rejectRecords(recordIds) {
    var baseUrl = markerRecordsBaseUrl();
    return __WEBPACK_IMPORTED_MODULE_2__services_http__["a" /* default */].post(baseUrl + '/reject/', __WEBPACK_IMPORTED_MODULE_3__services_auth__["a" /* default */].getAuthHeader(), {
      records: recordIds
    });
  },
  approveRecords: function approveRecords(recordIds) {
    var baseUrl = markerRecordsBaseUrl();
    return __WEBPACK_IMPORTED_MODULE_2__services_http__["a" /* default */].post(baseUrl + '/approve/', __WEBPACK_IMPORTED_MODULE_3__services_auth__["a" /* default */].getAuthHeader(), {
      records: recordIds
    });
  },
  mergeRecords: function mergeRecords(recordIds, mergeData) {
    var data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({ records: recordIds }, mergeData);
    return __WEBPACK_IMPORTED_MODULE_2__services_http__["a" /* default */].post('/record/mp/merge/', __WEBPACK_IMPORTED_MODULE_3__services_auth__["a" /* default */].getAuthHeader(), data);
  },
  restoreRecords: function restoreRecords(recordIds) {
    var baseUrl = markerRecordsBaseUrl();
    return __WEBPACK_IMPORTED_MODULE_2__services_http__["a" /* default */].post(baseUrl + '/restore/', __WEBPACK_IMPORTED_MODULE_3__services_auth__["a" /* default */].getAuthHeader(), {
      records: recordIds
    });
  },

  patchRecordRelevance: function patchRecordRelevance(markerId, record, relevance) {
    var payload = {
      'mldata': {
        'marked_as_relevant': relevance
      }
    };
    return this.patchRecord(markerId, record, payload);
  },

  patchRecordNotes: function patchRecordNotes(markerId, record, notes) {
    var payload = {
      'mldata': {
        'notes': notes
      }
    };
    return this.patchRecord(markerId, record, payload);
  },
  patchRecordComment: function patchRecordComment(record, payload) {
    return __WEBPACK_IMPORTED_MODULE_2__services_http__["a" /* default */].patch('/record/feedback/' + record.id + '/comment/', __WEBPACK_IMPORTED_MODULE_3__services_auth__["a" /* default */].getAuthHeader(), payload);
  },
  patchRecord: function patchRecord(markerId, record, payload) {
    var baseUrl = markerRecordsBaseUrl(markerId);
    return __WEBPACK_IMPORTED_MODULE_2__services_http__["a" /* default */].patch(baseUrl + '/' + record.id + '/', __WEBPACK_IMPORTED_MODULE_3__services_auth__["a" /* default */].getAuthHeader(), payload);
  },
  fetchUserRecords: function fetchUserRecords(userId, page, pageSize, recordType, activeTab) {
    var isDeleted = void 0;
    var offset = (page - 1) * pageSize;
    if (activeTab === 0) isDeleted = 'False';else isDeleted = 'True';
    var getParams = {
      'record_type': recordType,
      'is_deleted': isDeleted,
      'limit': pageSize,
      'offset': offset
    };
    var query = encodeQueryData(getParams);
    var baseUrl = userRecordsBaseUrl(userId);
    var url = baseUrl + '/?' + query;
    return __WEBPACK_IMPORTED_MODULE_2__services_http__["a" /* default */].get(url, __WEBPACK_IMPORTED_MODULE_3__services_auth__["a" /* default */].getAuthHeader()).then(apiListToModels);
  },

  restoreUserRecord: function restoreUserRecord(userId, recordId) {
    var payload = {
      'mldata': {
        'deleted_at': null
      }
    };
    return this.patchUserRecord(userId, recordId, payload);
  },
  deleteUserRecord: function deleteUserRecord(userId, recordId) {
    var baseUrl = userRecordsBaseUrl(userId);
    var url = baseUrl + '/' + recordId + '/';
    return __WEBPACK_IMPORTED_MODULE_2__services_http__["a" /* default */].delete(url, __WEBPACK_IMPORTED_MODULE_3__services_auth__["a" /* default */].getAuthHeader());
  },

  patchUserRecordRelevance: function patchUserRecordRelevance(userId, recordId, relevance) {
    var payload = {
      'mldata': {
        'marked_as_relevant': relevance
      }
    };
    this.patchUserRecord(userId, recordId, payload);
  },
  patchUserRecord: function patchUserRecord(userId, recordId, payload) {
    var baseUrl = userRecordsBaseUrl(userId);
    var url = baseUrl + '/' + recordId + '/';
    return __WEBPACK_IMPORTED_MODULE_2__services_http__["a" /* default */].patch(url, __WEBPACK_IMPORTED_MODULE_3__services_auth__["a" /* default */].getAuthHeader(), payload);
  },
  requestMoreVideos: function requestMoreVideos(recordId, message) {
    var url = '/record/mp/' + recordId + '/request_more/';
    return __WEBPACK_IMPORTED_MODULE_2__services_http__["a" /* default */].post(url, __WEBPACK_IMPORTED_MODULE_3__services_auth__["a" /* default */].getAuthHeader(), { message: message });
  },
  cutVideo: function cutVideo(recordId, start, stop) {
    return __WEBPACK_IMPORTED_MODULE_2__services_http__["a" /* default */].post('/record/mp/' + recordId + '/cut/', __WEBPACK_IMPORTED_MODULE_3__services_auth__["a" /* default */].getAuthHeader(), {
      start: start, stop: stop
    });
  },
  getRecordCutState: function getRecordCutState(recordId) {
    return __WEBPACK_IMPORTED_MODULE_2__services_http__["a" /* default */].get('/record/mp/' + recordId + '/cut_state/', __WEBPACK_IMPORTED_MODULE_3__services_auth__["a" /* default */].getAuthHeader());
  },
  updateRecordTags: function updateRecordTags(recordId, tagNames) {
    return __WEBPACK_IMPORTED_MODULE_2__services_http__["a" /* default */].post('/record/mp/' + recordId + '/update_tags/', __WEBPACK_IMPORTED_MODULE_3__services_auth__["a" /* default */].getAuthHeader(), {
      tags: tagNames
    });
  },
  patchRecordEdition: function patchRecordEdition(recordId, payload) {
    var url = BASE_RECORD_ROUTE + '/' + recordId + '/change_edition/';
    return __WEBPACK_IMPORTED_MODULE_2__services_http__["a" /* default */].patch(url, __WEBPACK_IMPORTED_MODULE_3__services_auth__["a" /* default */].getAuthHeader(), payload);
  },
  getRecordsStatuses: function getRecordsStatuses(recordIds) {
    return __WEBPACK_IMPORTED_MODULE_2__services_http__["a" /* default */].get('/process_statuses/', __WEBPACK_IMPORTED_MODULE_3__services_auth__["a" /* default */].getAuthHeader(), { record: recordIds });
  },
  downloadRecordsZip: function downloadRecordsZip(recordIds) {
    var data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({ records: recordIds });
    return __WEBPACK_IMPORTED_MODULE_2__services_http__["a" /* default */].post('/images/download/zip', __WEBPACK_IMPORTED_MODULE_3__services_auth__["a" /* default */].getAuthHeader(), data);
  }
});

function encodeQueryData(data) {
  var ret = [];
  for (var d in data) {
    if (!isEmpty(data[d])) {
      ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
    }
  }
  return ret.join('&');
}

function userRecordsBaseUrl(userId) {
  return '/media_platform/user/' + userId + '/record/vod';
}

function markerRecordsBaseUrl(markerId) {
  return markerId ? BASE_ROUTE + '/' + markerId + '/record/vod' : '/self_initiated_records';
}
function isEmpty(value) {
  return value == null || value.length === 0;
}

function markerRecordCoordsBaseUrl(markerId) {
  return BASE_ROUTE + '/' + markerId + '/record/vod_coords';
}

function apiListToModels(payload) {
  var result = payload['results'];
  result.count = payload['count'];
  return result;
}

function fetchMLData(records, marker) {
  var payload = records.reduce(function (acc, cur) {
    acc[cur.id] = cur.mltags;
    return acc;
  }, {});
  payload.event_id = marker.id;
  payload.request_title = marker.ml_keyword;
  var options = {
    method: 'POST',
    body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload)
  };

  if (!payload.request_title) return;
  if (__WEBPACK_IMPORTED_MODULE_4__store__["c" /* default */].state.consumerName !== __WEBPACK_IMPORTED_MODULE_4__store__["c" /* default */].state.CONSUMERS.roularta) return;
  fetch('https://veriflix-ml-api.look-app.net', options).then(function (response) {
    if (response.status === 500) {
      console.warn('ml failed. request_title: ' + payload.request_title + ';', response.statusText);
      return null;
    } else return response.json();
  }).then(function (payload) {
    if (payload === null) return;
    records.map(function (record) {
      var videos = payload.videos;
      if (videos[record.id] !== undefined) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(record.mldata, videos[record.id]);
      }
    });
  });
}

/***/ }),
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_http__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_auth__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_dates__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(27);







var BASE_ROUTE = '/marker';


var bus = new __WEBPACK_IMPORTED_MODULE_4_vue__["default"]();

/* harmony default export */ __webpack_exports__["a"] = ({
  triggerFTPSync: function triggerFTPSync(markerId) {
    var baseUrl = markerId ? BASE_ROUTE + '/' + markerId : '/self_initiated_records';
    var url = baseUrl + '/export/ftp/';
    return __WEBPACK_IMPORTED_MODULE_1__services_http__["a" /* default */].post(url, __WEBPACK_IMPORTED_MODULE_2__services_auth__["a" /* default */].getAuthHeader());
  },
  triggerFTPImagesSync: function triggerFTPImagesSync() {
    return __WEBPACK_IMPORTED_MODULE_1__services_http__["a" /* default */].post('/self_initiated_records/export/ftp_images/', __WEBPACK_IMPORTED_MODULE_2__services_auth__["a" /* default */].getAuthHeader());
  },
  fetchTeamMarkers: function fetchTeamMarkers(teamId, page, pageSize) {
    var offset = (page - 1) * pageSize;
    return __WEBPACK_IMPORTED_MODULE_1__services_http__["a" /* default */].get(BASE_ROUTE + '/', __WEBPACK_IMPORTED_MODULE_2__services_auth__["a" /* default */].getAuthHeader(), { team: teamId, offset: offset, limit: pageSize }).then(apiListToModels);
  },
  fetchMarkerDetails: function fetchMarkerDetails(markerId) {
    return __WEBPACK_IMPORTED_MODULE_1__services_http__["a" /* default */].get(BASE_ROUTE + '/' + markerId + '/', __WEBPACK_IMPORTED_MODULE_2__services_auth__["a" /* default */].getAuthHeader()).then(apiToModel);
  },
  save: function save(marker) {
    var payload = modelToApi(marker);
    return __WEBPACK_IMPORTED_MODULE_1__services_http__["a" /* default */].post(BASE_ROUTE + '/', __WEBPACK_IMPORTED_MODULE_2__services_auth__["a" /* default */].getAuthHeader(), payload);
  },
  update: function update(marker) {
    var payload = modelToApi(marker);
    return __WEBPACK_IMPORTED_MODULE_1__services_http__["a" /* default */].patch(BASE_ROUTE + '/' + marker.id + '/', __WEBPACK_IMPORTED_MODULE_2__services_auth__["a" /* default */].getAuthHeader(), payload);
  },
  delete: function _delete(marker) {
    return __WEBPACK_IMPORTED_MODULE_1__services_http__["a" /* default */].delete(BASE_ROUTE + '/' + marker.id + '/', __WEBPACK_IMPORTED_MODULE_2__services_auth__["a" /* default */].getAuthHeader());
  },
  patch: function patch(markerId, updatedProps) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1__services_http__["a" /* default */].patch(BASE_ROUTE + '/' + markerId + '/', __WEBPACK_IMPORTED_MODULE_2__services_auth__["a" /* default */].getAuthHeader(), updatedProps).then(function (response) {
      _this.bus.$emit('marker-updated', markerId);
      return response;
    });
  },
  bus: bus
});

function modelToApi(marker) {
  var payload = {
    location: {
      type: 'Point',
      coordinates: [marker.position.long, marker.position.lat]
    },
    radius_meter: marker.radius,
    starts_at: __WEBPACK_IMPORTED_MODULE_3__services_dates__["a" /* default */].toApiFormat(marker.starts_at),
    reveal_at: __WEBPACK_IMPORTED_MODULE_3__services_dates__["a" /* default */].toApiFormat(marker.reveal_at),
    ends_at: __WEBPACK_IMPORTED_MODULE_3__services_dates__["a" /* default */].toApiFormat(marker.ends_at),
    brand: marker.brand,
    team: marker.team,
    ml_keyword: marker.ml_keyword,
    targeted_groups: marker.targeted_groups,
    is_push_forced: marker.is_push_forced,
    qwe: 'qeqe'
  };
  if (!payload.hasOwnProperty('translations')) {
    payload.translations = {};
  }

  var _loop = function _loop(prop) {
    var field = marker[prop];
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(field).forEach(function (locale) {
      if (field[locale]) {
        if (typeof payload.translations[locale] === 'undefined') {
          payload.translations[locale] = {};
        }
        payload.translations[locale][prop] = field[locale];
      }
    });
  };

  var _arr = ['name', 'description', 'long_description'];

  for (var _i = 0; _i < _arr.length; _i++) {
    var prop = _arr[_i];
    _loop(prop);
  }
  return payload;
}

function apiTranslationsToModelField(translations, fieldname) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(translations).reduce(function (result, locale) {
    result[locale] = translations[locale][fieldname];
    return result;
  }, {});
}

function apiToModel(payload) {
  var marker = {
    id: payload.id,
    starts_at: __WEBPACK_IMPORTED_MODULE_3__services_dates__["a" /* default */].parseDate(payload.starts_at),
    ends_at: __WEBPACK_IMPORTED_MODULE_3__services_dates__["a" /* default */].parseDate(payload.ends_at),
    reveal_at: payload.reveal_at && __WEBPACK_IMPORTED_MODULE_3__services_dates__["a" /* default */].parseDate(payload.reveal_at),
    info_link: payload.info_link,
    thanks_link: payload.thanks_link,
    brand: payload.brand,
    team: payload.team,
    position: {
      long: payload.location.coordinates[0],
      lat: payload.location.coordinates[1]
    },
    media: payload.media,
    radius: payload.radius_meter,
    is_active: payload.is_active,
    records_count: payload.records_count,
    ml_keyword: payload.ml_keyword,
    targeted_groups: payload.targeted_groups,
    name: apiTranslationsToModelField(payload.translations, 'name'),
    description: apiTranslationsToModelField(payload.translations, 'description'),
    long_description: apiTranslationsToModelField(payload.translations, 'long_description'),
    is_push_forced: payload.is_push_forced
  };
  return marker;
}

function apiListToModels(payload) {
  var result = payload['results'].map(apiToModel);
  result.count = payload['count'];
  return result;
}

/***/ }),
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BASE_ROUTE */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_http__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_auth__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(27);





var BASE_ROUTE = '/media_platform/user';
var USER_URL = '/auth/user/';


var bus = new __WEBPACK_IMPORTED_MODULE_3_vue__["default"]();
var FileSaver = __webpack_require__(101);

/* harmony default export */ __webpack_exports__["a"] = ({
  fetchUsersList: function fetchUsersList() {
    var getParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var queryData = encodeQueryData(getParams);
    var url = BASE_ROUTE + '/?' + queryData;
    return __WEBPACK_IMPORTED_MODULE_0__services_http__["a" /* default */].get(url, __WEBPACK_IMPORTED_MODULE_1__services_auth__["a" /* default */].getAuthHeader()).then(apiListToModels);
  },
  fetchUserDetails: function fetchUserDetails(userId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_http__["a" /* default */].get(BASE_ROUTE + '/' + userId + '/', __WEBPACK_IMPORTED_MODULE_1__services_auth__["a" /* default */].getAuthHeader()).then(apiToDetailModel);
  },
  fetchMyUserDetails: function fetchMyUserDetails(userId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_http__["a" /* default */].get('' + USER_URL, __WEBPACK_IMPORTED_MODULE_1__services_auth__["a" /* default */].getAuthHeader()).then(apiToDetailMyUserModel);
  },
  exportAllUsers: function exportAllUsers() {
    var _this = this;

    var opts = {
      headers: __WEBPACK_IMPORTED_MODULE_1__services_auth__["a" /* default */].getAuthHeader()
    };
    var url = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__services_http__["b" /* buildUrl */])('/accounts/export/csv/');
    return fetch(url, opts).then(function (response) {
      if (response.ok) {
        return response.text();
      }
      throw response.status;
    }).then(downloadCSV).catch(function (error) {
      console.log(error);
      _this.bus.$emit('request-error', error);
    });
  },
  bus: bus
});

function downloadCSV(payload) {
  var blob = new Blob([payload], { type: 'text/csv;charset=utf-8' });
  FileSaver.saveAs(blob, 'users.csv');
}

function apiToListModel(payload) {
  var marker = {
    id: payload.pk,
    first_name: payload.first_name,
    last_name: payload.last_name,
    valid_records_amt: payload.valid_records_amt,
    all_records_amt: payload.all_records_amt,
    user_groups: payload.user_groups
  };
  return marker;
}

function apiToDetailMyUserModel(payload) {
  var userData = {
    user_group_list: payload.user_group_list,
    consumer_group: payload.consumer_group,
    departments: payload.departments
  };
  __WEBPACK_IMPORTED_MODULE_2__store__["c" /* default */].commit('SET_CONSUMER_GROUP', payload.consumer_group);
  __WEBPACK_IMPORTED_MODULE_2__store__["c" /* default */].commit('SET_EDITOR_CONSUMERS', payload.editor_consumer_list);
  return userData;
}

function apiToDetailModel(payload) {
  var marker = {
    id: payload.pk,
    first_name: payload.first_name,
    last_name: payload.last_name,
    email: payload.last_name,
    birthdate: payload.birthdate,
    place: payload.place,
    date_joined: payload.date_joined,
    picture: payload.picture,
    user_groups: payload.user_groups,
    valid_records_amt: payload.valid_records_amt,
    all_records_amt: payload.all_records_amt,
    events_amt: payload.events_amt
  };
  return marker;
}

function apiListToModels(payload) {
  return payload.map(apiToListModel);
}

function encodeQueryData(data) {
  var ret = [];
  for (var d in data) {
    ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
  }
  return ret.join('&');
}



/***/ }),
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(446),
  /* template */
  __webpack_require__(1068),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(921)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(468),
  /* template */
  __webpack_require__(1047),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(471),
  /* template */
  __webpack_require__(1044),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_i18n__ = __webpack_require__(969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(27);




__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_0_vue_i18n__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue_i18n__["a" /* default */]({
  locale: localStorage.getItem('preferred_locale') ? localStorage.getItem('preferred_locale') : 'fr',
  messages: {
    en: __webpack_require__(1082),
    fr: __webpack_require__(1083)
  }
}));

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_http__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_auth__ = __webpack_require__(8);





var BASE_ROUTE = '/marker';

/* harmony default export */ __webpack_exports__["a"] = ({
  fetchMarkerMessages: function fetchMarkerMessages(markerId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_http__["a" /* default */].get(BASE_ROUTE + '/' + markerId + '/message/', __WEBPACK_IMPORTED_MODULE_1__services_auth__["a" /* default */].getAuthHeader(), undefined, true);
  },

  fetchServiceMessages: function fetchServiceMessages() {
    return __WEBPACK_IMPORTED_MODULE_0__services_http__["a" /* default */].get('/mp/service_messages/', __WEBPACK_IMPORTED_MODULE_1__services_auth__["a" /* default */].getAuthHeader());
  }
});

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getRecordPlayerOptions;

function getRecordPlayerOptions(record) {
  var options = {
    url: record.play_link,
    mimetype: 'video/mp4',
    thumbnail: record.thumbnail_link
  };
  if (record.record_type === 'IMAGE' && record.media) {
    var original = record.media.find(function (el) {
      return el.name === 'original';
    });
    return {
      url: original.url,
      mimetype: original.mimetype,
      thumbnail: record.thumbnail_link
    };
  }
  if (record.media) {
    var vod = record.media.find(function (el) {
      return el.name === 'vod';
    });
    var sprite = record.media.find(function (el) {
      return el.name === 'thumbspritehoriz';
    });
    if (vod) {
      options = {
        url: vod.url,
        mimetype: vod.mimetype,
        thumbnail: record.thumbnail_link,
        width: vod.width,
        height: vod.height
      };
      if (sprite) {
        options.sprite = {
          url: sprite.url,
          h_interval: sprite.sprite_interval_h,
          height: sprite.height,
          width: sprite.width
        };
      }
    }
  }
  return options;
}

/***/ }),
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 277 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(440),
  /* template */
  __webpack_require__(1024),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(444),
  /* template */
  __webpack_require__(1022),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(909)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(452),
  /* template */
  __webpack_require__(1015),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(923)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(453),
  /* template */
  __webpack_require__(1059),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(460),
  /* template */
  __webpack_require__(1054),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(930)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(461),
  /* template */
  __webpack_require__(1069),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(919)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(462),
  /* template */
  __webpack_require__(1043),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(932)
__webpack_require__(931)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(464),
  /* template */
  __webpack_require__(1071),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(470),
  /* template */
  __webpack_require__(1048),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(913)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(473),
  /* template */
  __webpack_require__(1028),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(477),
  /* template */
  __webpack_require__(1057),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(928)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(478),
  /* template */
  __webpack_require__(1065),
  /* scopeId */
  "data-v-96ba037e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(1077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Home__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Login_vue__ = __webpack_require__(974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Login_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_DigitekaLogin_vue__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_DigitekaLogin_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_DigitekaLogin_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_MarkersList_vue__ = __webpack_require__(977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_MarkersList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_MarkersList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Marker_vue__ = __webpack_require__(975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Marker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Marker_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_MarkerEdit_vue__ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_MarkerEdit_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_MarkerEdit_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_individual_records_IndividualRecords_vue__ = __webpack_require__(985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_individual_records_IndividualRecords_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_individual_records_IndividualRecords_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_user_UsersList_vue__ = __webpack_require__(1014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_user_UsersList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_user_UsersList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_user_UserDetails_vue__ = __webpack_require__(1010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_user_UserDetails_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_user_UserDetails_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_settings_ConsumerSettings_vue__ = __webpack_require__(1009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_settings_ConsumerSettings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_settings_ConsumerSettings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_AuthByToken__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_AuthByToken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_AuthByToken__);



















__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

function managerGuard(to, from, next) {
  if (__WEBPACK_IMPORTED_MODULE_13__store__["b" /* store */].state.is_manager) return next();
  next(false);
}

var managerRoutes = [{
  path: '/marker',
  component: __WEBPACK_IMPORTED_MODULE_6__components_MarkersList_vue___default.a,
  meta: {
    auth: true
  }
}, {
  path: '/marker/edit',
  meta: {
    auth: true,
    existingMarker: false
  },
  component: __WEBPACK_IMPORTED_MODULE_8__components_MarkerEdit_vue___default.a,
  canReuse: false
}, {
  path: '/marker/:markerId/edit',
  meta: {
    auth: true,
    existingMarker: true
  },
  component: __WEBPACK_IMPORTED_MODULE_8__components_MarkerEdit_vue___default.a,
  canReuse: false
}, {
  path: '/marker/:markerId',
  name: 'marker',
  meta: {
    auth: true
  },
  component: __WEBPACK_IMPORTED_MODULE_7__components_Marker_vue___default.a
}, {
  path: '/user',
  component: __WEBPACK_IMPORTED_MODULE_10__components_user_UsersList_vue___default.a,
  meta: {
    auth: true
  }
}, {
  path: '/user/:userId',
  name: 'user',
  component: __WEBPACK_IMPORTED_MODULE_11__components_user_UserDetails_vue___default.a,
  meta: {
    auth: true
  }
}, {
  path: '/settings',
  component: __WEBPACK_IMPORTED_MODULE_12__components_settings_ConsumerSettings_vue___default.a,
  meta: {
    auth: true
  }
}];
managerRoutes = managerRoutes.map(function (route) {
  route.beforeEnter = managerGuard;
  return route;
});

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home___default.a
  }, {
    path: '/login',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Login_vue___default.a
  }, {
    path: '/digiteka/login',
    component: __WEBPACK_IMPORTED_MODULE_5__components_DigitekaLogin_vue___default.a
  }, {
    path: '/videos/:tab?',
    component: __WEBPACK_IMPORTED_MODULE_9__components_individual_records_IndividualRecords_vue___default.a,
    name: 'videos',
    props: {
      recordType: 'VIDEO'
    },
    meta: {
      auth: true
    }
  }, {
    path: '/images/:tab?',
    component: __WEBPACK_IMPORTED_MODULE_9__components_individual_records_IndividualRecords_vue___default.a,
    name: 'images',
    props: {
      recordType: 'IMAGE'
    },
    meta: {
      auth: true
    }
  }, {
    path: '/auth/:consumer/:token/',
    component: __WEBPACK_IMPORTED_MODULE_14__components_AuthByToken___default.a,
    meta: {
      auth: false
    }
  }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(managerRoutes), [{
    path: '*',
    redirect: '/'
  }])
}));

/***/ }),
/* 412 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 413 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 414 */,
/* 415 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(912)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(430),
  /* template */
  __webpack_require__(1027),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(442),
  /* template */
  __webpack_require__(1055),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_sign__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_sign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_sign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_leaflet__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_leaflet__);





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.Circle.extend({

  options: {
    icon: new __WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.DivIcon({
      iconSize: null,
      className: 'marker-edit-center-icon marker-edit-icon leaflet-div-icon leaflet-editing-icon'
    }),
    iconEdit: new __WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.DivIcon({
      iconSize: null,
      className: 'marker-edit-resize-icon marker-edit-icon leaflet-div-icon leaflet-editing-icon'
    }),
    extendedIconClass: 'extend-icon',
    overlappingIconClass: 'overlapping'
  },

  onAdd: function onAdd(map) {
    __WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.Path.prototype.onAdd.call(this, map);

    this.addHooks();
  },

  onRemove: function onRemove(map) {
    this.removeHooks();

    __WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.Path.prototype.onRemove.call(this, map);
  },

  addHooks: function addHooks() {
    if (this._map) {
      if (!this._markerGroup) {
        this._initMarkers();
      }
      this._map.addLayer(this._markerGroup);
    }
  },

  removeHooks: function removeHooks() {
    if (this._map) {
      this._map.removeLayer(this._markerGroup);
      delete this._markerGroup;
      delete this._markers;
    }
  },

  resetMarkers: function resetMarkers() {
    this.removeHooks();
    this.addHooks();
    this.detectOverlappingMakers();
  },

  updateMarkers: function updateMarkers() {
    this._markerGroup.clearLayers();
    this._initMarkers();
  },

  _initMarkers: function _initMarkers() {
    this._markerGroup = new __WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.LayerGroup();
    this._markers = [];

    var markerCenter = this._createMarker(this._latlng, 0, true, 'icon');
    this._markers.push(markerCenter);

    var circleBounds = this.getBounds();
    var center = circleBounds.getCenter();
    var neCoord = circleBounds.getNorthEast();
    var northCenterCoord = new __WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.LatLng(center.lat, neCoord.lng, true);
    var markerNorthCenter = this._createMarker(northCenterCoord, 1, false, 'iconEdit');
    this._markers.push(markerNorthCenter);
  },

  _createMarker: function _createMarker(latlng, index, isCenter, icon) {
    if (isCenter === undefined) {
      isCenter = false;
    }

    var zoffset = isCenter ? 1000 : 0;

    var marker = new __WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.Marker(latlng, {
      draggable: true,
      icon: this.options[icon],
      zIndexOffset: zoffset
    });

    marker._origLatLng = latlng;
    marker._index = index;
    marker._isCenter = isCenter;

    if (isCenter) {
      marker.on('drag', this._onCenterMove, this).on('dragend', this._onCenterMoveEnd, this);
    } else {
      marker.on('drag', this._onMarkerDrag, this);
    }
    marker.on('dragend', this._fireEdit, this).on('mouseover', this._onMouseOver, this).on('mouseout', this._onMouseOut, this);

    this._markerGroup.addLayer(marker);

    return marker;
  },
  _onMouseOver: function _onMouseOver(e) {
    var target = e.target;
    var icon = target._icon;
    var classValues = icon.getAttribute('class');

    icon.setAttribute('class', this.options.extendedIconClass + ' ' + classValues);
  },
  _onMouseOut: function _onMouseOut(e) {
    var target = e.target;
    var icon = target._icon;
    var classValues = icon.getAttribute('class');

    icon.setAttribute('class', classValues.replace(this.options.extendedIconClass, ''));
  },

  _fireEdit: function _fireEdit() {
    this.fire('edit');
  },

  _onCenterMove: function _onCenterMove(e) {
    var marker = e.target;


    __WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.Util.extend(marker._origLatLng, marker._latlng);

    var mm = this._markers[1];
    mm.setOpacity(0.01);

    this.redraw();
  },

  _onCenterMoveEnd: function _onCenterMoveEnd(e) {
    var circleBounds = this.getBounds();
    var center = circleBounds.getCenter();
    var neCoord = circleBounds.getNorthEast();
    var northCenterCoord = new __WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.LatLng(center.lat, neCoord.lng, true);
    var mm = this._markers[1];
    mm.setLatLng(northCenterCoord);
    mm.setOpacity(1);

    this.fire('centerchange');
  },

  _onMarkerDrag: function _onMarkerDrag(e) {
    var marker = e.target;

    var center = this._markers[0].getLatLng();
    var axis = marker._latlng;
    var distance = center.distanceTo(axis);

    this.setRadius(distance);

    this.redraw();


    this.fire('radiuschange');
  },

  updateRadius: function updateRadius(radius) {
    this.setRadius(radius);
    this.redraw();
    this.orientGizmo();
    this.detectOverlappingMakers();
  },

  orientGizmo: function orientGizmo() {
    var cm = this._markers[0];
    var gm = this._markers[1];
    var radius = this.getRadius();

    var centerCoords = cm.getLatLng();
    var gizmoCoords = gm.getLatLng();

    var x = new __WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.LatLng(centerCoords.lat, centerCoords.lng).distanceTo(new __WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.LatLng(gizmoCoords.lat, centerCoords.lng));
    var y = new __WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.LatLng(centerCoords.lat, centerCoords.lng).distanceTo(new __WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.LatLng(centerCoords.lat, gizmoCoords.lng));

    x = x * __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_sign___default()(gizmoCoords.lat - centerCoords.lat);
    y = y * __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_sign___default()(gizmoCoords.lng - centerCoords.lng);

    var a = Math.atan2(y, x);

    var xm = Math.cos(a) * radius;
    var ym = Math.sin(a) * radius;

    var earth = 6378137;

    var newLat = centerCoords.lat + xm / earth * (180 / Math.PI);
    var newLng = centerCoords.lng + ym / earth * (180 / Math.PI) / Math.cos(centerCoords.lat * Math.PI / 180);

    var newLatLng = new __WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.LatLng(newLat, newLng, true);

    gm.setLatLng(newLatLng);
    gm._icon.style.transform = gm._icon.style.transform + ' rotate(' + (a + 1.5708) + 'rad)';
    gm.setOpacity(1);
  },

  detectOverlappingMakers: function detectOverlappingMakers() {
    var cm = this._markers[0];
    var gm = this._markers[1];

    var cmr = cm._icon.getBoundingClientRect();
    var gmr = gm._icon.getBoundingClientRect();

    var classValues = gm._icon.getAttribute('class');
    classValues = classValues.replace(new RegExp(this.options.overlappingIconClass, 'g'), '');

    if (!(cmr.right < gmr.left || cmr.left > gmr.right || cmr.bottom < gmr.top || cmr.top > gmr.bottom)) {
      gm._icon.setAttribute('class', this.options.overlappingIconClass + ' ' + classValues);
    } else {
      gm._icon.setAttribute('class', classValues);
    }
  },

  centerchange: function centerchange() {},
  radiuschange: function radiuschange() {}
}));

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_video_js__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_video_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_video_js__);











var Plugin = __WEBPACK_IMPORTED_MODULE_7_video_js___default.a.getPlugin('plugin');

var defaults = {
  0: {
    src: ''
  }
};
var extend = function extend() {
  var args, target, i, object, property;
  args = Array.prototype.slice.call(arguments);
  target = args.shift() || {};
  for (i in args) {
    object = args[i];
    for (property in object) {
      if (object.hasOwnProperty(property)) {
        if (__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_typeof___default()(object[property]) === 'object') {
          target[property] = extend(target[property], object[property]);
        } else {
          target[property] = object[property];
        }
      }
    }
  }
  return target;
};
var getComputedStyle = function getComputedStyle(el, pseudo) {
  return function (prop) {
    if (window.getComputedStyle) {
      return window.getComputedStyle(el, pseudo)[prop];
    } else {
      return el.currentStyle[prop];
    }
  };
};
var offsetParent = function offsetParent(el) {
  if (el.nodeName !== 'HTML' && getComputedStyle(el)('position') === 'static') {
    return offsetParent(el.offsetParent);
  }
  return el;
};
var getVisibleWidth = function getVisibleWidth(el, width) {
  var clip;

  if (width) {
    return parseFloat(width);
  }

  clip = getComputedStyle(el)('clip');
  if (clip !== 'auto' && clip !== 'inherit') {
    clip = clip.split(/(?:\(|\))/)[1].split(/(?:,| )/);
    if (clip.length === 4) {
      return parseFloat(clip[1]) - parseFloat(clip[3]);
    }
  }
  return 0;
};
var getScrollOffset = function getScrollOffset() {
  if (window.pageXOffset) {
    return {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
  return {
    x: document.documentElement.scrollLeft,
    y: document.documentElement.scrollTop
  };
};

var Thumbnails = function (_Plugin) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Thumbnails, _Plugin);

  function Thumbnails(player, options) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Thumbnails);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Thumbnails.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Thumbnails)).call(this, player, options));

    var div, settings, img, progressControl, duration, moveListener, moveCancel;
    settings = extend({}, defaults, options);

    (function () {
      var progressControl, addFakeActive, removeFakeActive;

      if (navigator.userAgent.toLowerCase().indexOf('android') !== -1) {
        progressControl = player.controlBar.progressControl;

        addFakeActive = function addFakeActive() {
          progressControl.addClass('fake-active');
        };
        removeFakeActive = function removeFakeActive() {
          progressControl.removeClass('fake-active');
        };

        progressControl.on('touchstart', addFakeActive);
        progressControl.on('touchend', removeFakeActive);
        progressControl.on('touchcancel', removeFakeActive);
      }
    })();

    var createDiv = function createDiv() {
      div = document.createElement('div');
      div.className = 'vjs-thumbnail-holder';
      img = document.createElement('img');
      div.appendChild(img);
      img.src = settings['0'].src;
      img.className = 'vjs-thumbnail';
      extend(img.style, settings['0'].style);

      if (!img.style.left && !img.style.right) {
        img.onload = function () {
          img.style.left = -(img.naturalWidth / 2) + 'px';
        };
      }
    };
    createDiv();

    progressControl = player.controlBar.progressControl;

    var appendDiv = function appendDiv() {
      var el = progressControl.el();

      var els = el.querySelectorAll('.vjs-thumbnail-holder');
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(els), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var e = _step.value;

          el.removeChild(e);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      el.appendChild(div);
    };
    appendDiv();

    duration = player.duration();

    player.on('durationchange', function (event) {
      duration = player.duration();
    });

    player.on('loadedmetadata', function (event) {
      duration = player.duration();
    });

    _this.on('statechanged', function (event) {
      if (event.changes) {
        options = event.changes.options ? event.changes.options.to : {};
        settings = extend({}, defaults, options);
        createDiv();
        appendDiv();
      }
    });

    moveListener = function moveListener(event) {
      var mouseTime, time, active, left, setting, pageX, right, width, halfWidth, pageXOffset, clientRect;
      active = 0;
      pageXOffset = getScrollOffset().x;
      clientRect = offsetParent(progressControl.el()).getBoundingClientRect();
      right = (clientRect.width || clientRect.right) + pageXOffset;

      pageX = event.pageX;
      if (event.changedTouches) {
        pageX = event.changedTouches[0].pageX;
      }

      left = pageX || event.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;

      left -= offsetParent(progressControl.el()).getBoundingClientRect().left + pageXOffset;

      mouseTime = Math.floor(left / progressControl.width() * duration);
      for (time in settings) {
        if (mouseTime >= time) {
          active = Math.max(active, time);
        }
      }
      setting = settings[active];
      if (setting.src && img.src !== setting.src) {
        img.src = setting.src;
      }
      if (setting.style && img.style !== setting.style) {
        extend(img.style, setting.style);
      }

      width = getVisibleWidth(img, setting.width || settings[0].width);
      halfWidth = width / 2;

      if (left + halfWidth > right) {
        left -= left + halfWidth - right;
      } else if (left < halfWidth) {
        left = halfWidth;
      }

      div.style.left = left + 'px';
    };

    progressControl.on('mousemove', moveListener);
    progressControl.on('touchmove', moveListener);

    moveCancel = function moveCancel(event) {
      div.style.left = '-1000px';
    };

    progressControl.on('mouseout', moveCancel);
    progressControl.on('touchcancel', moveCancel);
    progressControl.on('touchend', moveCancel);
    player.on('userinactive', moveCancel);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Thumbnails, [{
    key: 'updateState',
    value: function updateState(options) {
      this.setState({ options: options });
    }
  }]);

  return Thumbnails;
}(Plugin);

/* harmony default export */ __webpack_exports__["a"] = (Thumbnails);

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_promise_polyfill_src_polyfill__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_whatwg_fetch__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_whatwg_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify_dist_vuetify_min_css__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_design_icons_iconfont_dist_material_design_icons_css__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_design_icons_iconfont_dist_material_design_icons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_design_icons_iconfont_dist_material_design_icons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_auth__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuetify__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_generic_Datetime_vue__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_generic_Datetime_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_generic_Datetime_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store__ = __webpack_require__(15);













__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vuetify___default.a, {
  iconfont: 'md'
});


__WEBPACK_IMPORTED_MODULE_4_vue__["default"].config.productionTip = false;


__WEBPACK_IMPORTED_MODULE_4_vue__["default"].component('date', __WEBPACK_IMPORTED_MODULE_10__components_generic_Datetime_vue___default.a);

__WEBPACK_IMPORTED_MODULE_7__services_auth__["a" /* default */].checkAuth();



__WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].beforeEach(function (to, from, next) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__store__["a" /* initGlobalState */])(__WEBPACK_IMPORTED_MODULE_11__store__["b" /* store */]);

  if (to.meta.auth && !__WEBPACK_IMPORTED_MODULE_7__services_auth__["a" /* default */].authenticated) {
    next('/login');
  } else {
    next();
  }
});

new __WEBPACK_IMPORTED_MODULE_4_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */],
  i18n: __WEBPACK_IMPORTED_MODULE_9__i18n__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_5__App___default.a }
});

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_http__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_auth__ = __webpack_require__(8);





var BASE_ROUTE = '/brand';

/* harmony default export */ __webpack_exports__["a"] = ({
  fetchTeamBrands: function fetchTeamBrands(teamId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_http__["a" /* default */].get(BASE_ROUTE + '/', __WEBPACK_IMPORTED_MODULE_1__services_auth__["a" /* default */].getAuthHeader(), { team: teamId });
  }
});

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_http__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_auth__ = __webpack_require__(8);






var BASE_ROUTE = '/settings/consumer';

/* harmony default export */ __webpack_exports__["a"] = ({
  fetchSettings: function fetchSettings() {
    return __WEBPACK_IMPORTED_MODULE_1__services_http__["a" /* default */].get(BASE_ROUTE + '/', __WEBPACK_IMPORTED_MODULE_2__services_auth__["a" /* default */].getAuthHeader()).then(apiToModel);
  },
  patchSettings: function patchSettings(payload) {
    payload.localized_thank_you = modelFieldTranslationsToAPI(payload.localized_thank_you);
    payload.localized_marker_request = modelFieldTranslationsToAPI(payload.localized_marker_request);
    return __WEBPACK_IMPORTED_MODULE_1__services_http__["a" /* default */].patch(BASE_ROUTE + '/', __WEBPACK_IMPORTED_MODULE_2__services_auth__["a" /* default */].getAuthHeader(), payload);
  }
});

function apiToModel(payload) {
  var data = {
    export_type: payload.export_type,
    export_individual_format: payload.export_individual_format,
    ftp: payload.ftp,
    film_something_now_enabled: payload.film_something_now_enabled,
    localized_thank_you: apiTranslationsToModelField(payload.localized_thank_you),
    localized_marker_request: apiTranslationsToModelField(payload.localized_marker_request),
    ios_app_version: payload.ios_app_version,
    video_quality: payload.video_quality
  };
  return data;
}

function apiTranslationsToModelField(field) {
  var res = {};
  field.forEach(function (element) {
    res[element['lang']] = element['translation'];
  });
  return res;
}

function modelFieldTranslationsToAPI(field) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(field).reduce(function (total, el) {
    total.push({ 'lang': el[0], 'translation': el[1] });
    return total;
  }, []);
}

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_http__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_auth__ = __webpack_require__(8);





var BASE_ROUTE = '/available_usergroups';

/* harmony default export */ __webpack_exports__["a"] = ({
  fetchGroups: function fetchGroups() {
    return __WEBPACK_IMPORTED_MODULE_0__services_http__["a" /* default */].get(BASE_ROUTE + '/', __WEBPACK_IMPORTED_MODULE_1__services_auth__["a" /* default */].getAuthHeader());
  }
});

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_http__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_auth__ = __webpack_require__(8);





/* harmony default export */ __webpack_exports__["a"] = ({
  fetchTeam: function fetchTeam() {
    return __WEBPACK_IMPORTED_MODULE_0__services_http__["a" /* default */].get('/team/', __WEBPACK_IMPORTED_MODULE_1__services_auth__["a" /* default */].getAuthHeader(), undefined, true).then(function (teams) {
      if (!teams.length) {
        return null;
      }
      return teams[0];
    });
  }
});

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__http__ = __webpack_require__(14);





/* harmony default export */ __webpack_exports__["a"] = ({
  autocomplete: function autocomplete(input) {
    return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get('/places/autocomplete/', __WEBPACK_IMPORTED_MODULE_0__auth__["a" /* default */].getAuthHeader(), { query: input }, true);
  },
  details: function details(placeId) {
    return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].get('/places/place/', __WEBPACK_IMPORTED_MODULE_0__auth__["a" /* default */].getAuthHeader(), { place_id: placeId }, true);
  }
});

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  lastCheck: Date.now() - 301e3,
  checkInterval: 300e3, checkForUpdate: function checkForUpdate(callback) {
    if (Date.now() - this.lastCheck > this.checkInterval) {
      this.lastCheck = Date.now();
      var elems = document.querySelectorAll('script[src*="app"]');
      var currentAppSourceUrl = elems[elems.length - 1].getAttribute('src');
      fetch('/').then(function (response) {
        if (response.status >= 200 && response.status < 300) {
          response.text().then(function (body) {
            if (body.indexOf(currentAppSourceUrl) < 0) {
              callback();
            }
          });
        }
      });
    }
  }
});

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    show: false,
    message: '',
    href: '',
    timeout: 0,
    color: undefined
  },
  mutations: {
    show: function show(state, _ref) {
      var message = _ref.message,
          href = _ref.href,
          timeout = _ref.timeout,
          color = _ref.color;

      state.show = true;
      state.message = message;
      state.href = href;
      state.timeout = timeout || 0;
      state.color = color;
    },
    hide: function hide(state) {
      state.show = false;
      state.message = '';
      state.href = '';
      state.timeout = 0;
      state.color = undefined;
    },
    setShow: function setShow(state, value) {
      state.show = value;
    }
  }
});

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_auth__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_dates__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_http__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_update__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Error_vue__ = __webpack_require__(972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_UpdatePrompt_vue__ = __webpack_require__(978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_UpdatePrompt_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_UpdatePrompt_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_marker_record_ModalRecordPlayer_vue__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_marker_record_ModalRecordPlayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_marker_record_ModalRecordPlayer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_generic_SnackBar_vue__ = __webpack_require__(983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_generic_SnackBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_generic_SnackBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_generic_ServiceMessage__ = __webpack_require__(982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_generic_ServiceMessage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_generic_ServiceMessage__);














/* harmony default export */ __webpack_exports__["default"] = ({
  store: __WEBPACK_IMPORTED_MODULE_8__store__["c" /* default */],
  components: {
    ErrorDisplay: __WEBPACK_IMPORTED_MODULE_5__components_Error_vue___default.a,
    ModalRecordPlayer: __WEBPACK_IMPORTED_MODULE_7__components_marker_record_ModalRecordPlayer_vue___default.a,
    UpdatePrompt: __WEBPACK_IMPORTED_MODULE_6__components_UpdatePrompt_vue___default.a,
    SnackBar: __WEBPACK_IMPORTED_MODULE_9__components_generic_SnackBar_vue___default.a,
    ServiceMessage: __WEBPACK_IMPORTED_MODULE_11__components_generic_ServiceMessage___default.a
  },
  data: function data() {
    return {
      dropdownToggle: false,
      updateAvailable: false,
      clientId: ''
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.checkForUpdate();
    window.addEventListener('focus', this.checkForUpdate, false);
    __WEBPACK_IMPORTED_MODULE_3__services_http__["a" /* default */].bus.$on('request-error', function (error) {
      if (error.response && error.response.status === 401) {
        _this.logout();
      }
      return true;
    });
    __WEBPACK_IMPORTED_MODULE_3__services_http__["a" /* default */].bus.$on('outbound-request', function (opts) {
      if (opts.silent !== true) {
        Pace.restart();
      }
    });
    this.clientId = localStorage.getItem('client_id') || '';
  },
  methods: {
    logout: function logout() {
      __WEBPACK_IMPORTED_MODULE_1__services_auth__["a" /* default */].logout();
      this.$router.push('/login');
    },
    updateLocale: function updateLocale(l) {
      this.setAppLocale(l);
      this.dropdownToggle = false;
    },
    setAppLocale: function setAppLocale(l) {
      this.$i18n.locale = l;
      __WEBPACK_IMPORTED_MODULE_2__services_dates__["a" /* default */].updateLocale(l);
      localStorage.setItem('preferred_locale', l);
    },
    checkForUpdate: function checkForUpdate() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_4__services_update__["a" /* default */].checkForUpdate(function () {
        _this2.updateAvailable = true;
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["a" /* mapGetters */])(['isLmrConsumer']), {
    currentLocale: function currentLocale() {
      return this.$i18n.locale;
    }
  })
});

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_auth__ = __webpack_require__(8);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AuthByToken',
  mounted: function mounted() {
    var consumer = this.$route.params.consumer;
    var token = this.$route.params.token;
    localStorage.setItem('auth_token', token);
    localStorage.setItem('client_id', consumer);
    this.authenticated = true;
    __WEBPACK_IMPORTED_MODULE_0__services_auth__["a" /* default */].checkAuth();
    this.$router.push({ path: '/' });
  }
});

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_auth__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_events__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(15);








var getQueryStringParameter = function getQueryStringParameter(parameter) {
  var qd = {};
  if (location.search) {
    location.search.substr(1).split('&').forEach(function (item) {
      var s = item.split('=');
      var k = s[0];
      var v = s[1] && decodeURIComponent(s[1]);
      (qd[k] = qd[k] || []).push(v);
    });
  }
  return qd[parameter];
};

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      credentials: {
        clientId: 'digiteka',
        email: '',
        password: ''
      },
      errors: ''
    };
  },
  mounted: function mounted() {
    if (!this.credentials.clientId) {
      this.credentials.clientId = getQueryStringParameter('clientid') || localStorage.getItem('client_id') || '';
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['isLmrConsumer'])),
  methods: {
    submit: function submit() {
      var _this = this;

      this.errors = '';
      __WEBPACK_IMPORTED_MODULE_1__services_auth__["a" /* default */].login(this.credentials).then(function (success) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__store__["e" /* refreshGlobalState */])(__WEBPACK_IMPORTED_MODULE_4__store__["b" /* store */]).then(function () {
          if (_this.isLmrConsumer) _this.$router.push('/videos');else _this.$router.push('/marker');
        });
      }).catch(function (error) {
        if (error.response && error.response.status === 400) {
          _this.errors = 'Unable to log in with the provided credentials.';
        } else {
          __WEBPACK_IMPORTED_MODULE_2__services_events__["a" /* default */].emit('error', error, '', { modal: false });
        }
      });
    }
  }
});

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_events__ = __webpack_require__(9);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      show: false,
      error: '',
      modal: true
    };
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0__services_events__["a" /* default */].bus.$on('error', this.handleError);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_0__services_events__["a" /* default */].bus.$off('error', this.handleError);
  },
  methods: {
    handleError: function handleError(error, message, options) {
      console.log(error, message, options);
      this.error = error.response ? error.response.status : 0;
      if (options && options.modal === false) {
        this.modal = false;
      } else {
        this.modal = true;
      }
      if (parseInt(this.error) !== 401) {
        this.show = true;
      }
    }
  },
  computed: {
    errorCode: function errorCode() {
      return parseInt(this.error);
    },
    isForbidden: function isForbidden() {
      return this.errorCode === 403;
    },
    isServerError: function isServerError() {
      return this.errorCode >= 500;
    },
    isConnectionError: function isConnectionError() {
      return this.errorCode === 0;
    }
  }
});

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(26);





/* harmony default export */ __webpack_exports__["default"] = ({
  beforeMount: function beforeMount() {
    if (this.consumerName) this.redirect();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(['consumerName']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['isLmrConsumer'])),
  watch: {
    consumerName: function consumerName(val) {
      if (val) this.redirect();
    }
  },
  methods: {
    redirect: function redirect() {
      this.$router.push('/videos/new');
    }
  }
});

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_auth__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_events__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(15);








var getQueryStringParameter = function getQueryStringParameter(parameter) {
  var qd = {};
  if (location.search) {
    location.search.substr(1).split('&').forEach(function (item) {
      var s = item.split('=');
      var k = s[0];
      var v = s[1] && decodeURIComponent(s[1]);
      (qd[k] = qd[k] || []).push(v);
    });
  }
  return qd[parameter];
};

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      credentials: {
        clientId: '',
        email: '',
        password: ''
      },
      errors: ''
    };
  },
  mounted: function mounted() {
    if (!this.credentials.clientId) {
      var clientId = localStorage.getItem('client_id') || '';
      if (clientId === 'digiteka') {
        clientId = '';
        localStorage.setItem('client_id', '');
      }
      this.credentials.clientId = getQueryStringParameter('clientid') || clientId;
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['isLmrConsumer'])),
  methods: {
    submit: function submit() {
      var _this = this;

      this.errors = '';
      __WEBPACK_IMPORTED_MODULE_1__services_auth__["a" /* default */].login(this.credentials).then(function (success) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__store__["e" /* refreshGlobalState */])(__WEBPACK_IMPORTED_MODULE_4__store__["b" /* store */]).then(function () {
          if (_this.isLmrConsumer) _this.$router.push('/videos');else _this.$router.push('/marker');
        });
      }).catch(function (error) {
        if (error.response && error.response.status === 400) {
          _this.errors = 'Unable to log in with the provided credentials.';
        } else {
          __WEBPACK_IMPORTED_MODULE_2__services_events__["a" /* default */].emit('error', error, '', { modal: false });
        }
      });
    }
  }
});

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__repositories_MarkerRepository_js__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__marker_MarkerDetails_vue__ = __webpack_require__(987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__marker_MarkerDetails_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__marker_MarkerDetails_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__marker_MarkerRecords_vue__ = __webpack_require__(990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__marker_MarkerRecords_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__marker_MarkerRecords_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__marker_MarkerMessages_vue__ = __webpack_require__(989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__marker_MarkerMessages_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__marker_MarkerMessages_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_events__ = __webpack_require__(9);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    MarkerDetails: __WEBPACK_IMPORTED_MODULE_1__marker_MarkerDetails_vue___default.a,
    MarkerRecords: __WEBPACK_IMPORTED_MODULE_2__marker_MarkerRecords_vue___default.a,
    MarkerMessages: __WEBPACK_IMPORTED_MODULE_3__marker_MarkerMessages_vue___default.a
  },
  data: function data() {
    return {
      marker: '',
      loading: ''
    };
  },
  mounted: function mounted() {
    this.fetchMarkerData();
  },
  methods: {
    fetchMarkerData: function fetchMarkerData() {
      var _this = this;

      var markerId = this.$route.params.markerId;
      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_0__repositories_MarkerRepository_js__["a" /* default */].fetchMarkerDetails(markerId).then(function (marker) {
        _this.marker = marker;
        _this.loading = false;
      }, function (error) {
        _this.loading = false;
        __WEBPACK_IMPORTED_MODULE_4__services_events__["a" /* default */].emit('error', error);
      });
    }
  }
});

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__repositories_MarkerRepository_js__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_events__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__markerEdit_MapPreview_vue__ = __webpack_require__(1004);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__markerEdit_MapPreview_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__markerEdit_MapPreview_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__markerEdit_MapEditor_vue__ = __webpack_require__(1003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__markerEdit_MapEditor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__markerEdit_MapEditor_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__generic_InputNumber_vue__ = __webpack_require__(981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__generic_InputNumber_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__generic_InputNumber_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__markerEdit_InputDatetime_vue__ = __webpack_require__(1001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__markerEdit_InputDatetime_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__markerEdit_InputDatetime_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__markerEdit_InputLocalizedText_vue__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__markerEdit_InputLocalizedText_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__markerEdit_InputLocalizedText_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__markerEdit_InputPlaces_vue__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__markerEdit_InputPlaces_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__markerEdit_InputPlaces_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__markerEdit_SelectBrand_vue__ = __webpack_require__(1005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__markerEdit_SelectBrand_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__markerEdit_SelectBrand_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__markerEdit_SelectGroups_vue__ = __webpack_require__(1006);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__markerEdit_SelectGroups_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__markerEdit_SelectGroups_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__markerEdit_InputRevealAt_vue__ = __webpack_require__(1002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__markerEdit_InputRevealAt_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__markerEdit_InputRevealAt_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__markerEdit_DurationHelper_vue__ = __webpack_require__(1000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__markerEdit_DurationHelper_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__markerEdit_DurationHelper_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_moment__);







__webpack_require__(276);















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    MapPreview: __WEBPACK_IMPORTED_MODULE_4__markerEdit_MapPreview_vue___default.a,
    MapEditor: __WEBPACK_IMPORTED_MODULE_5__markerEdit_MapEditor_vue___default.a,
    InputNumber: __WEBPACK_IMPORTED_MODULE_6__generic_InputNumber_vue___default.a,
    InputDatetime: __WEBPACK_IMPORTED_MODULE_7__markerEdit_InputDatetime_vue___default.a,
    InputLocalizedTextarea: __WEBPACK_IMPORTED_MODULE_8__markerEdit_InputLocalizedText_vue___default.a,
    InputPlaces: __WEBPACK_IMPORTED_MODULE_9__markerEdit_InputPlaces_vue___default.a,
    InputRevealAt: __WEBPACK_IMPORTED_MODULE_12__markerEdit_InputRevealAt_vue___default.a,
    BrandSelector: __WEBPACK_IMPORTED_MODULE_10__markerEdit_SelectBrand_vue___default.a,
    GroupSelector: __WEBPACK_IMPORTED_MODULE_11__markerEdit_SelectGroups_vue___default.a,
    DurationHelper: __WEBPACK_IMPORTED_MODULE_13__markerEdit_DurationHelper_vue___default.a
  },
  data: function data() {
    var data = {
      edit: false,
      loading: false,
      disabled: false,
      currentEditLocale: 'en',
      locales: ['en', 'fr', 'nl'],
      maxRadius: 200000,
      revealAtChoice: 'immediate',
      marker: {
        name: {},
        description: {},
        long_description: {},
        position: {
          lat: 0,
          long: 0,
          address: '',
          initial: true
        },
        radius: 1000,
        starts_at: __WEBPACK_IMPORTED_MODULE_14_moment___default()().seconds(0),
        ends_at: __WEBPACK_IMPORTED_MODULE_14_moment___default()().seconds(0).add(15, 'minutes'),
        brand: null,
        targeted_groups: [],
        ml_keyword: '',
        is_push_forced: false
      }
    };
    data.marker.reveal_at = data.marker.starts_at;
    data.locales.forEach(function (l) {
      data.marker.name[l] = '';
      data.marker.description[l] = '';
      data.marker.long_description[l] = '';
    });
    return data;
  },
  mounted: function mounted() {
    var _this = this;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__store__["e" /* refreshGlobalState */])(__WEBPACK_IMPORTED_MODULE_3__store__["b" /* store */]);

    if (this.$route.meta.existingMarker) {
      this.disabled = true;
      var markerId = this.$route.params.markerId;
      __WEBPACK_IMPORTED_MODULE_1__repositories_MarkerRepository_js__["a" /* default */].fetchMarkerDetails(markerId).then(function (marker) {
        marker.position.address = '';
        marker.position.initial = false;

        if (marker.reveal_at) {
          _this.revealAtChoice = Math.abs(marker.reveal_at.diff(marker.starts_at)) <= 60 ? 'eventstart' : 'immediate';
        } else {
          _this.revealAtChoice = 'immediate';
        }

        _this.marker = marker;
        _this.disabled = false;
      });
    }
  },
  computed: {
    position: function position() {
      return {
        lat: this.marker.position.lat,
        long: this.marker.position.long,
        address: this.marker.position.address,
        radius: this.marker.radius,
        initial: this.marker.position.initial
      };
    },
    brands: function brands() {
      return __WEBPACK_IMPORTED_MODULE_3__store__["b" /* store */].state.brands ? __WEBPACK_IMPORTED_MODULE_3__store__["b" /* store */].state.brands : [];
    },
    groups: function groups() {
      return __WEBPACK_IMPORTED_MODULE_3__store__["b" /* store */].state.groups ? __WEBPACK_IMPORTED_MODULE_3__store__["b" /* store */].state.groups : [];
    },
    duration: function duration() {
      return this.marker.ends_at - this.marker.starts_at;
    },
    startsInTheFuture: function startsInTheFuture() {
      return this.marker.starts_at.isAfter();
    },

    existingMarker: function existingMarker() {
      return this.$route.meta.existingMarker;
    }
  },
  methods: {
    submit: function submit() {
      var _this2 = this;

      var validationResult = this.extraValidation();
      if (!validationResult) {
        return false;
      }
      this.loading = true;
      this.cleanMarkerData();

      this.marker.team = __WEBPACK_IMPORTED_MODULE_3__store__["b" /* store */].state.teamId;

      this.marker.reveal_at = this.revealAtChoice === 'immediate' ? __WEBPACK_IMPORTED_MODULE_14_moment___default()().seconds(0) : this.marker.starts_at;

      var method = void 0;
      if (this.$route.meta.existingMarker) {
        method = __WEBPACK_IMPORTED_MODULE_1__repositories_MarkerRepository_js__["a" /* default */].update;
      } else {
        method = __WEBPACK_IMPORTED_MODULE_1__repositories_MarkerRepository_js__["a" /* default */].save;
      }
      method(this.marker).then(function () {
        _this2.loading = false;
        _this2.$router.push('/marker');
      }).catch(function (error) {
        _this2.loading = false;
        __WEBPACK_IMPORTED_MODULE_2__services_events__["a" /* default */].emit('error', error, '', { modal: false });
      });
    },
    updateMarkerPosition: function updateMarkerPosition(position) {
      this.marker.position.initial = false;
      this.marker.position.lat = position.lat;
      this.marker.position.long = position.long;
      this.marker.position.address = position.address;
      this.marker.radius = position.radius ? position.radius : this.marker.radius;
    },
    cleanMarkerData: function cleanMarkerData() {
      var _this3 = this;

      if (this.brands.length === 0 && this.marker.brand !== null) {
        this.marker.brand = null;
      }
      var pickedBrand = this.brands.find(function (brand) {
        return brand.id === _this3.marker.brand;
      });

      if (this.brands.length > 0 && pickedBrand === undefined) {
        this.marker.brand = this.brands[0].id;
      }
    },

    extraValidation: function extraValidation() {
      var validDescriptions = [this.marker.name, this.marker.description, this.marker.long_description].every(this.validateLocalizedField);
      var validDates = this.duration > 0;
      return validDescriptions && validDates;
    },

    validateLocalizedField: function validateLocalizedField(field) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(field).some(function (val) {
        return field[val];
      });
    }
  }
});

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__markersList_MarkersTable_vue__ = __webpack_require__(1008);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__markersList_MarkersTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__markersList_MarkersTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__repositories_MarkerRepository_js__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_dates__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_events__ = __webpack_require__(9);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    MarkersTable: __WEBPACK_IMPORTED_MODULE_0__markersList_MarkersTable_vue___default.a
  },
  data: function data() {
    return {
      markers: [],
      timer: '',
      loading: true,
      pageSize: 20,
      page: 1
    };
  },
  mounted: function mounted() {
    var _this = this;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__store__["e" /* refreshGlobalState */])(__WEBPACK_IMPORTED_MODULE_2__store__["b" /* store */]).then(function () {
      _this.fetchMarkersData();
    });
  },

  methods: {
    fetchMarkersData: function fetchMarkersData() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__repositories_MarkerRepository_js__["a" /* default */].fetchTeamMarkers(__WEBPACK_IMPORTED_MODULE_2__store__["b" /* store */].state.teamId, this.page, this.pageSize).then(function (markers) {
        _this2.markers = markers;
        _this2.loading = false;
      }).catch(function (error) {
        _this2.loading = false;
        __WEBPACK_IMPORTED_MODULE_4__services_events__["a" /* default */].emit('error', error);
      });
    },
    deleteMarker: function deleteMarker(marker) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1__repositories_MarkerRepository_js__["a" /* default */].delete(marker).then(function () {
        setTimeout(function () {
          _this3.fetchMarkersData();
        }, 50);
      });
    }
  },
  computed: {
    sortedActiveMarkers: function sortedActiveMarkers() {
      return this.markers.slice().filter(function (m) {
        return m.is_active;
      }).sort(sortMarkersStartAsc);
    },
    sortedFutureMarkers: function sortedFutureMarkers() {
      return this.markers.slice().filter(function (m) {
        return __WEBPACK_IMPORTED_MODULE_3__services_dates__["a" /* default */].parseDate(m.starts_at) > __WEBPACK_IMPORTED_MODULE_3__services_dates__["a" /* default */].now();
      }).sort(sortMarkersStartAsc);
    },
    sortedPastMarkers: function sortedPastMarkers() {
      return this.markers.slice().filter(function (m) {
        return __WEBPACK_IMPORTED_MODULE_3__services_dates__["a" /* default */].parseDate(m.ends_at) < __WEBPACK_IMPORTED_MODULE_3__services_dates__["a" /* default */].now();
      }).sort(sortMarkersEndDesc);
    },
    amountPages: function amountPages() {
      return Math.ceil(this.markers.count / this.pageSize) || 1;
    }
  }
});

function sortMarkersEndDesc(a, b) {
  return Date.parse(b.ends_at) - Date.parse(a.ends_at);
}
function sortMarkersStartAsc(a, b) {
  return Date.parse(a.starts_at) - Date.parse(b.starts_at);
}

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    reload: function reload() {
      window.location = '/';
    }
  }
});

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['cancelLabel', 'confirmLabel'],
  data: function data() {
    return {
      showModal: false
    };
  },
  methods: {
    ok: function ok() {
      this.showModal = false;
      this.$emit('confirm');
    },
    cancel: function cancel() {
      this.showModal = false;
      this.$emit('cancel');
    }
  }
});

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    ok: function ok() {
      this.$emit('ok');
    },
    cancel: function cancel() {
      this.$emit('cancel');
    },
    keypressed: function keypressed(event) {
      var esc = 27;
      if (event.keyCode === esc) {
        this.cancel();
      }
    }
  },
  mounted: function mounted() {
    window.addEventListener('keyup', this.keypressed);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('keyup', this.keypressed);
  }
});

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_dates__ = __webpack_require__(28);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['value'],
  computed: {
    formatted: function formatted() {
      return __WEBPACK_IMPORTED_MODULE_0__services_dates__["a" /* default */].longFormat(this.value, this.$i18n.locale);
    }
  }
});

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_dates__ = __webpack_require__(28);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['value'],
  data: function data() {
    return {
      now: Date.now()
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.interval = setInterval(function () {
      _this.now = Date.now();
    }, 1000);
  },
  destroyed: function destroyed() {
    clearInterval(this.interval);
  },
  computed: {
    formatted: function formatted() {
      return __WEBPACK_IMPORTED_MODULE_0__services_dates__["a" /* default */].fromNow(this.value, this.$i18n.locale, this.now);
    }
  }
});

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      showOptions: false
    };
  },
  mounted: function mounted() {
    document.body.addEventListener('click', this.hide);
  },
  beforeDestroy: function beforeDestroy() {
    document.body.removeEventListener('click', this.hide);
  },

  methods: {
    hide: function hide() {
      this.showOptions = false;
    }
  }
});

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  inheritAttrs: false,
  props: ['value', 'min-value', 'max-value', 'increment-by'],
  methods: {
    increment: function increment() {
      if (this.value + this.incr <= Number(this.maxValue)) {
        this.$emit('input', this.value + this.incr);
      }
    },
    decrement: function decrement() {
      if (this.value - this.incr >= Number(this.minValue)) {
        this.$emit('input', this.value - this.incr);
      }
    },
    updateValue: function updateValue(event) {
      var validatedValue = this.validate(event.target.value);
      event.target.value = validatedValue;
      this.$emit('input', validatedValue);
    },
    updateValueWithBoundaries: function updateValueWithBoundaries(event) {
      var validatedValue = this.validateBounds(event.target.value);
      event.target.value = validatedValue;
      this.$emit('input', validatedValue);
    },
    validate: function validate(inputValue) {
      var newValue = Number(inputValue.replace(/\D/g, ''));
      if (!isNaN(newValue)) {
        return newValue;
      }
    },
    validateBounds: function validateBounds(inputValue) {
      var newValue = Number(inputValue.replace(/\D/g, ''));
      if (isNaN(newValue) || newValue < Number(this.minValue)) {
        return Number(this.minValue);
      } else if (newValue > Number(this.maxValue)) {
        return Number(this.maxValue);
      } else {
        return newValue;
      }
    }
  },
  computed: {
    incr: function incr() {
      return Number(this.incrementBy);
    }
  }
});

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    show: {
      type: Boolean,
      required: true
    },
    okBtnText: String,
    disableOkBtn: false
  },
  mounted: function mounted() {
    window.addEventListener('keyup', this.keypressed);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('keyup', this.keypressed);
  },
  methods: {
    keypressed: function keypressed(event) {
      var esc = 27;
      if (event.keyCode === esc) {
        this.hide();
      }
    },
    hide: function hide() {
      this.$emit('hide');
    },
    ok: function ok() {
      this.$emit('ok');
      this.hide();
    }
  }
});

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__repositories_MessageRepository_js__ = __webpack_require__(169);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ServiceMessage',
  data: function data() {
    return {
      messages: [],
      fetchInterval: null
    };
  },
  mounted: function mounted() {
    this.fetchMessages();
    this.fetchInterval = setInterval(this.fetchMessages.bind(this), 30000);
  },


  computed: {
    openedMessages: function openedMessages() {
      return this.messages.filter(function (m) {
        return !m.closed;
      });
    }
  },

  methods: {
    fetchMessages: function fetchMessages() {
      var _this = this;

      if (this.$store.state.authenticated) {
        __WEBPACK_IMPORTED_MODULE_1__repositories_MessageRepository_js__["a" /* default */].fetchServiceMessages().then(function (messages) {
          var _loop = function _loop(message) {
            if (_this.messages.find(function (m) {
              return m.text === message;
            })) return 'continue';
            _this.messages.push({ text: message, closed: false });
          };

          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(messages), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var message = _step.value;

              var _ret = _loop(message);

              if (_ret === 'continue') continue;
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          var _loop2 = function _loop2(m) {
            if (messages.find(function (message) {
              return message === m.text;
            })) return 'continue';
            console.log('remvoe', m.text);
            _this.messages = _this.messages.filter(function (msg) {
              return msg.text !== m.text;
            });
          };

          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this.messages), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var m = _step2.value;

              var _ret2 = _loop2(m);

              if (_ret2 === 'continue') continue;
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }, function (error) {
          console.log('errr', error);
          clearInterval(_this.fetchInterval);
        });
      }
    },
    close: function close(message) {
      message.closed = true;
    }
  }
});

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(26);





/* harmony default export */ __webpack_exports__["default"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    show: {
      get: function get() {
        return this.$store.state.snackbar.show;
      },
      set: function set(value) {
        this.$store.commit('snackbar/setShow', value);
      }
    },
    timeout: function timeout() {
      return this.$store.state.snackbar.timeout;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])('snackbar', ['message', 'href', 'color'])),
  methods: {
    hide: function hide() {
      this.$store.commit('snackbar/hide');
    }
  }
});

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Menu_vue__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Menu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Menu_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Menu: __WEBPACK_IMPORTED_MODULE_0__Menu_vue___default.a
  }
});

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_entries__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Details_vue__ = __webpack_require__(984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Details_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Details_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__marker_MarkerDendrogram_vue__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__marker_MarkerDendrogram_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__marker_MarkerDendrogram_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_events__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__marker_record_MarkerTagsSelector__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__marker_record_MarkerTagsSelector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__marker_record_MarkerTagsSelector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__marker_record_InappropriateFilter__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__marker_record_InappropriateFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__marker_record_InappropriateFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__marker_record_RecordDetails_vue__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__marker_record_RecordDetails_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__marker_record_RecordDetails_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__repositories_RecordRepository_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__marker_record_RecordsList_vue__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__marker_record_RecordsList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__marker_record_RecordsList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__marker_record_LmrCategoryFilter__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__marker_record_LmrCategoryFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__marker_record_LmrCategoryFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__marker_record_LmrCityReportFilter__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__marker_record_LmrCityReportFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__marker_record_LmrCityReportFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__marker_record_SdkFilter__ = __webpack_require__(998);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__marker_record_SdkFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__marker_record_SdkFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_generic_Modal_vue__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_generic_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_generic_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__services_auth__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__services_http__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__repositories_UserRepository__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__marker_record_EditorConsumerFilter__ = __webpack_require__(992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__marker_record_EditorConsumerFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__marker_record_EditorConsumerFilter__);




























/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Details: __WEBPACK_IMPORTED_MODULE_8__Details_vue___default.a,
    RecordsList: __WEBPACK_IMPORTED_MODULE_15__marker_record_RecordsList_vue___default.a,
    Dendrogram: __WEBPACK_IMPORTED_MODULE_9__marker_MarkerDendrogram_vue___default.a,
    MarkerTagsSelector: __WEBPACK_IMPORTED_MODULE_11__marker_record_MarkerTagsSelector___default.a,
    InappropriateFilter: __WEBPACK_IMPORTED_MODULE_12__marker_record_InappropriateFilter___default.a,
    RecordDetails: __WEBPACK_IMPORTED_MODULE_13__marker_record_RecordDetails_vue___default.a,
    LmrCategoryFilter: __WEBPACK_IMPORTED_MODULE_16__marker_record_LmrCategoryFilter___default.a,
    LmrCityReportFilter: __WEBPACK_IMPORTED_MODULE_17__marker_record_LmrCityReportFilter___default.a,
    SdkFilter: __WEBPACK_IMPORTED_MODULE_18__marker_record_SdkFilter___default.a,
    Modal: __WEBPACK_IMPORTED_MODULE_19__components_generic_Modal_vue___default.a,
    EditorConsumerFilter: __WEBPACK_IMPORTED_MODULE_24__marker_record_EditorConsumerFilter___default.a
  },
  props: ['markerId', 'recordType'],
  data: function data() {
    return {
      records: [],
      newVideosCount: 0,
      relatedRecords: [],
      diversityTree: null,
      showTree: false,
      timer: '',
      processStatusInterval: null,
      mergeRecordTimeout: null,
      loading: true,
      recordFilters: {
        tags: [],

        lmr_category: '',
        sdk_record: '',
        lmr_cities: [],
        user: null,
        editor_consumers: []
      },
      recordOrdering: '',
      itemsOrdering: [],
      recordTabs: {
        new: 0,
        approved: 1,
        deleted: 2
      },
      activeTabIndex: null,
      newTabRecordsCount: 0,
      pageSize: 20,
      currentPage: 1,
      selectedRecord: null,
      approveMode: false,
      mergeMode: false,
      downloadMode: false,
      selectedRecords: [],
      pageLoadDate: null,
      showPremergeModal: false,
      mergeData: {
        approve: false,
        title: '',
        description: ''
      },
      dialog: false,
      uploadingVideoFile: '',
      dragging: false,
      titleVideoUpload: '',
      authorVideoUpload: '',
      descriptionVideoUpload: '',
      typeVideoUpload: 'sport',
      uploadVideoFormHasErrors: false,
      videoFileUploading: false,
      videoUploadTypes: [{ value: 'sport', name: 'Sports' }, { value: 'general', name: 'Infos locales' }],
      isLoadingAuthors: false,
      uploadVideoAuthor: null,
      search: null,
      searchFilteredUser: null,
      filtersAuthors: [],
      entriesAuthors: [],
      bufferVideoUploading: 0,
      user_groups: [],
      consumer_group: '',
      departments: [],
      department: ''
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    var tabEntries = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_entries___default()(this.recordTabs);
    var tab = tabEntries.find(function (_ref) {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
          name = _ref2[0],
          index = _ref2[1];

      return name === _this.$route.params.tab;
    }) || tabEntries[0];
    this.activeTabIndex = tab[1];
  },
  mounted: function mounted() {
    var _this2 = this;

    this.fetchRecords();
    this.setPageLoadDate();
    this.setupInterval();
    this.processStatusInterval = setInterval(this.updateRecordProcessStatus, 10000);

    __WEBPACK_IMPORTED_MODULE_23__repositories_UserRepository__["a" /* default */].fetchMyUserDetails().then(function (data) {
      _this2.user_groups = data.user_group_list;
      _this2.consumer_group = data.consumer_group;
      if (data.consumer_group === 'ebra') {
        _this2.videoUploadTypes.push({ value: 'magazine', name: 'Magazine' });
      }
      if (_this2.$store.state.consumerName === 'lng') {
        _this2.videoUploadTypes.push({ value: 'faits_divers', name: 'Faits Divers' });
      }
      if (data.consumer_group === 'ebra') {
        _this2.departments = data.departments.map(function (department) {
          return { text: department.name, value: department.slug };
        });
        var d = [{ text: _this2.$t('departments.all'), value: '0' }];
        _this2.departments = d.concat(_this2.departments);
      }
    });
  },


  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_vuex__["a" /* mapGetters */])(['isLmrConsumer']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_vuex__["b" /* mapState */])(['consumerName', 'consumerHasDescriptionField']), {
    showVideos: function showVideos() {
      return this.recordType === 'VIDEO';
    },
    showImages: function showImages() {
      return this.recordType === 'IMAGE';
    },
    amountOfPages: function amountOfPages() {
      return Math.ceil(this.records.count / this.pageSize) || 1;
    },
    activeTabName: function activeTabName() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_entries___default()(this.recordTabs).find(function (name, index) {
        return index === _this3.activeTabIndex;
      })[0];
    },
    extension: function extension() {
      return this.uploadingVideoFile ? this.uploadingVideoFile.name.split('.').pop() : '';
    },
    uploadVideoForm: function uploadVideoForm() {
      return {
        titleVideoUpload: this.titleVideoUpload,
        uploadVideoAuthor: this.uploadVideoAuthor,

        typeVideoUpload: this.typeVideoUpload
      };
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_vuex__["d" /* mapActions */])(['syncFtp', 'syncImagesFtp']), {
    setupInterval: function setupInterval() {
      clearInterval(this.timer);
      this.timer = setInterval(this.updateRecords.bind(this), 30000);
    },
    handleRecordDelete: function handleRecordDelete(record, recordType) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_14__repositories_RecordRepository_js__["a" /* default */].deleteRecord(this.markerId, record).then(function () {
        _this4.fetchRecords(recordType);
      }, function (error) {
        __WEBPACK_IMPORTED_MODULE_10__services_events__["a" /* default */].emit('error', error, '', { modal: false });
      });
    },
    handleRecordRestore: function handleRecordRestore(record, recordType) {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_14__repositories_RecordRepository_js__["a" /* default */].restoreRecord(this.markerId, record).then(function () {
        _this5.fetchRecords();
      }, function (error) {
        __WEBPACK_IMPORTED_MODULE_10__services_events__["a" /* default */].emit('error', error, '', { modal: false });
      });
    },
    handleTagsSelected: function handleTagsSelected(tags) {
      this.recordFilters.tags = tags;
      this.fetchRecords();
    },
    handleLmrCitySelected: function handleLmrCitySelected(cities) {
      this.recordFilters.lmr_cities = cities;
      this.fetchRecords();
    },
    handleEditorConsumerSelected: function handleEditorConsumerSelected(consumers) {
      this.recordFilters.editor_consumers = consumers;
      this.fetchRecords();
    },
    fetchRecordsFromRepository: function fetchRecordsFromRepository(recordType, page, tabName) {
      return __WEBPACK_IMPORTED_MODULE_14__repositories_RecordRepository_js__["a" /* default */].fetchMarkerRecords(this.markerId, page || this.currentPage, this.pageSize, this.recordOrdering, this.department, this.recordFilters, recordType || this.recordType, tabName || this.activeTabName);
    },
    updateRecords: function updateRecords() {
      var _this6 = this;

      var route = this.$route.path;
      var page = this.showVideos ? this.currentPage : 1;
      var tabName = this.showVideos ? this.activeTabName : 'new';

      this.fetchRecordsFromRepository('VIDEO', page, tabName).then(function (records) {
        if (_this6.$route.path !== route || page !== (_this6.showVideos ? _this6.currentPage : 1)) return;

        var newVideosCount = records.filter(function (record) {
          if (record.transcoding_complete_date) {
            var timestamp = new Date(record.transcoding_complete_date).getTime();
            return timestamp > _this6.pageLoadDate;
          }
        }).length;

        if (_this6.showImages) {
          if (newVideosCount) _this6.newVideosCount = newVideosCount;
          return;
        }

        if (_this6.records.length === 0) {
          _this6.records = records;
          if (_this6.activeTabIndex === _this6.recordTabs.new) {
            _this6.newTabRecordsCount = records.count;
            _this6.setPageLoadDate();
          }
          _this6.$refs.tagsFilter.fetchTags();
          return;
        }

        if (newVideosCount > 0) {
          _this6.newVideosCount = newVideosCount;

          _this6.records.forEach(function (record, index) {
            var freshRecord = records.find(function (rec) {
              return rec.id === record.id;
            });
            if (!freshRecord.digiteka_id) freshRecord.digiteka_id = _this6.records[index].digiteka_id;
            if (freshRecord) _this6.records[index] = freshRecord;
            _this6.records = _this6.records.slice();
          });
        } else {
          _this6.records.forEach(function (record, index) {
            var freshRecord = records.find(function (rec) {
              return rec.id === record.id;
            });
            if (!freshRecord.digiteka_id) freshRecord.digiteka_id = record.digiteka_id;
            if (freshRecord) _this6.records[index] = freshRecord;
          });
          if (_this6.activeTabIndex === _this6.recordTabs.new) {
            _this6.newTabRecordsCount = records.count;
          }
        }
      });
    },
    swapInNewRecords: function swapInNewRecords() {
      if (this.showImages) {
        this.$router.push('/videos/new');
      } else if (this.activeTabIndex !== this.recordTabs.new) {
        this.activeTabIndex = 0;
      } else {
        this.fetchRecords();
      }
      this.newVideosCount = 0;
    },
    fetchRecords: function fetchRecords() {
      var _this7 = this;

      this.loading = true;
      var route = this.$route.path;
      var page = this.currentPage;

      this.fetchRecordsFromRepository().then(function (records) {
        if (_this7.$route.path !== route || _this7.currentPage !== page) return;
        _this7.records = records;
        if (_this7.activeTabIndex === _this7.recordTabs.new) {
          _this7.newTabRecordsCount = records.count;
          if (_this7.showVideos && _this7.currentPage === 1) {
            _this7.setPageLoadDate();
          }
        }
        _this7.loading = false;
      }, function (error) {
        _this7.loading = false;
        __WEBPACK_IMPORTED_MODULE_10__services_events__["a" /* default */].emit('error', error);
      });
      if (this.activeTabIndex === this.recordTabs.approved) {
        this.itemsOrdering = [{ text: this.$t('ordering.by_shooting_date_new_old'), value: '-shooting_date' }, { text: this.$t('ordering.by_shooting_date_old_new'), value: 'shooting_date' }, { text: this.$t('ordering.by_approve_date_new_old'), value: '-approved_date' }, { text: this.$t('ordering.by_approve_date_old_new'), value: 'approved_date' }];
      } else {
        this.itemsOrdering = [{ text: this.$t('ordering.by_shooting_date_new_old'), value: '-shooting_date' }, { text: this.$t('ordering.by_shooting_date_old_new'), value: 'shooting_date' }];
      }
    },
    markRecordRelevance: function markRecordRelevance(record, relevance, recordType) {
      var r = this.getRecords(recordType).find(function (r) {
        return r.id === record.id;
      });
      if (r && r.mldata) {
        r.mldata.marked_as_relevant = relevance;
      }
      __WEBPACK_IMPORTED_MODULE_14__repositories_RecordRepository_js__["a" /* default */].patchRecordRelevance(this.markerId, record, relevance).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_10__services_events__["a" /* default */].emit('error', error, '', { modal: false });
      });
    },
    getRecords: function getRecords(recordType) {
      var typeMapping = {
        'VIDEO': this.records,
        'IMAGE': this.imageRecords
      };
      return typeMapping[recordType];
    },
    showRecordDetails: function showRecordDetails(record) {
      this.selectedRecord = record;
    },
    recordClicked: function recordClicked(record) {
      if (this.approveMode || this.mergeMode || this.downloadMode) {
        if (!this.selectedRecords.some(function (rec) {
          return rec.id === record.id;
        })) {
          this.selectedRecords.push(record);
        } else {
          this.selectedRecords = this.selectedRecords.filter(function (rec) {
            return rec.id !== record.id;
          });
        }
      } else {
        this.showRecordDetails(record);
      }
    },
    isChoosingMode: function isChoosingMode() {
      return this.approveMode || this.mergeMode || this.downloadMode;
    },
    toggleApproveMode: function toggleApproveMode() {
      this.selectedRecords = [];
      this.approveMode = !this.approveMode;
      this.mergeMode = false;
      this.downloadMode = false;
      if (!this.approveMode) document.activeElement.blur();
    },
    toggleMergeMode: function toggleMergeMode() {
      this.selectedRecords = [];
      this.mergeMode = !this.mergeMode;
      this.approveMode = false;
      this.downloadMode = false;
      this.showPremergeModal = false;
      this.mergeData.approve = false;
      this.mergeData.title = '';
      this.mergeData.description = '';
      if (!this.mergeMode) document.activeElement.blur();
    },
    rejectRecords: function rejectRecords() {
      var _this8 = this;

      var ids = this.selectedRecords.map(function (rec) {
        return rec.id;
      });
      __WEBPACK_IMPORTED_MODULE_14__repositories_RecordRepository_js__["a" /* default */].rejectRecords(ids).then(function () {
        _this8.toggleApproveMode();
        _this8.fetchRecords();
      }, function (error) {
        __WEBPACK_IMPORTED_MODULE_10__services_events__["a" /* default */].emit('error', error, '', { modal: false });
      });
    },
    approveRecords: function approveRecords() {
      var _this9 = this;

      var ids = this.selectedRecords.map(function (rec) {
        return rec.id;
      });
      __WEBPACK_IMPORTED_MODULE_14__repositories_RecordRepository_js__["a" /* default */].approveRecords(ids).then(function () {
        _this9.toggleApproveMode();
        if (_this9.$root.$children[0].$data.clientId === 'digiteka') {
          _this9.$store.commit('snackbar/show', {
            message: _this9.$t('approve_msg'),
            color: '#0fd3bd',
            href: 'https://www.ultimedia.com/central/video/list/',
            timeout: 30000
          });
        }
        _this9.fetchRecords();
      }, function (error) {
        __WEBPACK_IMPORTED_MODULE_10__services_events__["a" /* default */].emit('error', error, '', { modal: false });
      });
    },
    downloadRecord: function downloadRecord(record) {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        var FileSaver, res, blob;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                FileSaver = __webpack_require__(101);
                _context.next = 3;
                return fetch(record.play_link);

              case 3:
                res = _context.sent;
                _context.next = 6;
                return res.blob();

              case 6:
                blob = _context.sent;

                FileSaver.saveAs(blob, record.verbose_filename);

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this10);
      }))();
    },
    downloadRecords: function downloadRecords() {
      var _this11 = this;

      this.selectedRecords.forEach(function (value, index) {
        return _this11.downloadRecord(value);
      });
      this.toggleApproveMode();
    },
    downloadRecordsZip: function downloadRecordsZip() {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var ids;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                ids = _this12.selectedRecords.map(function (rec) {
                  return rec.id;
                });

                if (ids.length === 1) {
                  _this12.downloadRecords();
                } else {
                  __WEBPACK_IMPORTED_MODULE_14__repositories_RecordRepository_js__["a" /* default */].downloadRecordsZip(ids).then(function (data) {
                    _this12.toggleApproveMode();
                    if (data.download_url) {
                      var FileSaver = __webpack_require__(101);
                      FileSaver.saveAs(data.download_url, 'images.zip');
                    } else {
                      alert('Error in downloading zip');
                    }
                  });
                }

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this12);
      }))();
    },
    setMergeRecordTitle: function setMergeRecordTitle(approve) {
      if (this.consumerHasDescriptionField) {
        this.mergeData.title = this.concatenateSelectedRecordsField('title');
        this.mergeData.description = this.concatenateSelectedRecordsField('description');
      } else {
        this.mergeData.title = this.concatenateSelectedRecordsField('title');
      }
      this.mergeData.approve = approve;
      this.showPremergeModal = true;
    },
    mergeRecords: function mergeRecords(approve) {
      var _this13 = this;

      var data = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.mergeData);
      var ids = this.selectedRecords.map(function (rec) {
        return rec.id;
      });
      __WEBPACK_IMPORTED_MODULE_14__repositories_RecordRepository_js__["a" /* default */].mergeRecords(ids, this.mergeData).then(function () {
        _this13.toggleMergeMode();
        if (data.approve) {
          if (_this13.$root.$children[0].$data.clientId !== 'digiteka') {
            _this13.$store.commit('snackbar/show', {
              message: _this13.$t('merge_and_approve_msg_pm'),
              color: 'green',
              timeout: 30000
            });
          } else {
            _this13.$store.commit('snackbar/show', {
              message: _this13.$t('merge_and_approve_msg_iframe_digiteka'),
              color: '#0fd3bd',
              href: 'https://www.ultimedia.com/central/video/list/',
              timeout: 30000
            });
          }
        } else {
          if (_this13.$root.$children[0].$data.clientId !== 'digiteka') {
            _this13.$store.commit('snackbar/show', {
              message: _this13.$t('merge_msg'),
              color: 'green',
              timeout: 30000
            });
          } else {
            _this13.$store.commit('snackbar/show', {
              message: _this13.$t('merge_msg'),
              color: '#0fd3bd',
              timeout: 30000
            });
          }
        }
        _this13.mergeRecordTimeout = setTimeout(function () {
          return _this13.fetchRecords('VIDEO');
        }, 2000);
      }, function (error) {
        __WEBPACK_IMPORTED_MODULE_10__services_events__["a" /* default */].emit('error', error, '', { modal: false });
        _this13.$store.commit('snackbar/show', {
          message: error.message,
          color: 'error',
          timeout: 4
        });
      });
    },
    restoreRecords: function restoreRecords() {
      var _this14 = this;

      var ids = this.selectedRecords.map(function (rec) {
        return rec.id;
      });
      __WEBPACK_IMPORTED_MODULE_14__repositories_RecordRepository_js__["a" /* default */].restoreRecords(ids).then(function () {
        _this14.toggleApproveMode();
        _this14.fetchRecords();
      }, function (error) {
        __WEBPACK_IMPORTED_MODULE_10__services_events__["a" /* default */].emit('error', error, '', { modal: false });
      });
    },
    setCutIcon: function setCutIcon(record) {
      var rec = this.records.find(function (r) {
        return r.id === record.id;
      });
      if (rec) {
        rec.process_statuses.push({
          process: 'cut', status: 'running'
        });
      }
    },
    updateRecordProcessStatus: function updateRecordProcessStatus() {
      var _this15 = this;

      __WEBPACK_IMPORTED_MODULE_14__repositories_RecordRepository_js__["a" /* default */].getRecordsStatuses(this.records.map(function (record) {
        return record.id;
      })).then(function (resp) {
        var _loop = function _loop(record) {
          record.process_statuses = resp.filter(function (item) {
            return item.record === record.id;
          });
        };

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this15.records), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var record = _step.value;

            _loop(record);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      });
    },
    setRecordTabRoute: function setRecordTabRoute() {
      if (this.$route.params.tab !== this.activeTabName) {
        this.$router.replace({
          name: this.$route.name,
          params: { tab: this.activeTabName }
        });
      }
    },
    setPageLoadDate: function setPageLoadDate() {
      this.pageLoadDate = new Date().getTime();
    },
    concatenateSelectedRecordsField: function concatenateSelectedRecordsField(fieldName) {
      return this.selectedRecords.reduce(function (text, record, index) {
        if (index === 1) {
          if (text[fieldName] && record[fieldName]) {
            return text[fieldName] + '; ' + record[fieldName];
          } else {
            return text[fieldName] || record[fieldName];
          }
        } else if (text && record[fieldName]) {
          return text + '; ' + record[fieldName];
        } else {
          return record[fieldName];
        }
      });
    },
    onChange: function onChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        this.dragging = false;
        return;
      }
      this.createFile(files[0]);
    },
    createFile: function createFile(file) {
      if (!file.type.match('video.*')) {
        alert(this.$t('upload_video.please_select_video_file'));
        this.dragging = false;
        return;
      }
      if (file.size > 500000000) {
        alert(this.$t('upload_video.please_check_file'));
        this.dragging = false;
        return;
      }
      this.uploadingVideoFile = file;
      this.dragging = false;
    },
    removeFile: function removeFile() {
      this.uploadingVideoFile = '';
    },
    uploadData: function uploadData() {
      var _this16 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var headers, uploadUrlData, uploadDone, xhr, ref;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this16.uploadVideoFormHasErrors = false;
                if (!_this16.uploadingVideoFile) {
                  _this16.uploadVideoFormHasErrors = true;
                }
                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this16.uploadVideoForm).forEach(function (f) {
                  if (!_this16.uploadVideoForm[f]) _this16.uploadVideoFormHasErrors = true;
                  _this16.$refs[f].validate(true);
                });

                if (_this16.uploadVideoFormHasErrors) {
                  _context3.next = 18;
                  break;
                }

                headers = __WEBPACK_IMPORTED_MODULE_21__services_auth__["a" /* default */].getAuthHeader();
                _context3.next = 7;
                return __WEBPACK_IMPORTED_MODULE_22__services_http__["a" /* default */].post('/record/raw/upload/', headers, {
                  comment: _this16.descriptionVideoUpload,
                  record_type: 'VIDEO',
                  address: '',
                  user_id: _this16.uploadVideoAuthor.pk
                });

              case 7:
                uploadUrlData = _context3.sent;

                uploadDone = function uploadDone(rawRecordId) {
                  var url = '/record/raw/upload/' + rawRecordId + '/done/';
                  headers['Content-Type'] = 'application/json';
                  return __WEBPACK_IMPORTED_MODULE_22__services_http__["a" /* default */].post(url, headers, {
                    'title': _this16.titleVideoUpload,
                    'description': _this16.descriptionVideoUpload,
                    'lmr_category': _this16.typeVideoUpload,
                    'user_id': _this16.uploadVideoAuthor.pk,
                    'autoapprove': false
                  });
                };

                xhr = new XMLHttpRequest();

                xhr.upload.onprogress = function (event) {
                  _this16.bufferVideoUploading = parseInt(event.loaded / event.total * 100);
                };
                ref = _this16;

                xhr.onload = xhr.onerror = function () {
                  if (this.status === 200) {
                    uploadDone(uploadUrlData.id);
                    ref.mergeRecordTimeout = setTimeout(function () {
                      return ref.fetchRecords('VIDEO');
                    }, 2000);
                    ref.videoFileUploading = false;
                    ref.dialog = false;
                    ref.uploadingVideoFile = '';
                    ref.dragging = false;
                    ref.titleVideoUpload = '';
                    ref.authorVideoUpload = '';
                    ref.descriptionVideoUpload = '';
                    ref.typeVideoUpload = 'sport';
                    ref.uploadVideoFormHasErrors = false;
                    ref.videoFileUploading = false;
                    ref.bufferVideoUploading = 0;
                  } else {
                    console.log('error ' + this.status);
                  }
                };

                xhr.open('PUT', uploadUrlData.upload_link, true);
                xhr.setRequestHeader('Accept', '*/*');
                xhr.setRequestHeader('Content-Type', 'video/mp4');
                xhr.send(_this16.uploadingVideoFile);
                _this16.videoFileUploading = true;

              case 18:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this16);
      }))();
    }
  }),

  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timer);
    clearInterval(this.processStatusInterval);
    clearTimeout(this.mergeRecordTimeout);
  },

  watch: {
    $route: function $route(to, from) {
      if (to.name !== from.name) {
        this.activeTabIndex = 0;
        this.newTabRecordsCount = 0;
      }
      this.records = [];
      this.currentPage = 1;
      this.mergeMode = false;
      this.approveMode = false;
      this.downloadMode = false;
      this.selectedRecords = [];
      this.fetchRecords();
    },
    activeTabIndex: function activeTabIndex(newVal, oldVal) {
      this.recordOrdering = '';
      clearTimeout(this.mergeRecordTimeout);
      this.setRecordTabRoute();
    },
    searchFilteredUser: function searchFilteredUser(val) {
      var _this17 = this;

      if (this.recordFilters.user && val === this.recordFilters.user.autocomplete_full_name) {
        this.filtersAuthors = [this.recordFilters.user];
        return;
      }
      this.recordFilters.user = null;

      if (!val) {
        this.filtersAuthors = [];
        this.recordFilters.user = null;
        return;
      }
      if (this.isLoadingAuthors) return;
      this.isLoadingAuthors = true;
      var headers = __WEBPACK_IMPORTED_MODULE_21__services_auth__["a" /* default */].getAuthHeader();
      __WEBPACK_IMPORTED_MODULE_22__services_http__["a" /* default */].get('/media_platform/autocomplete/user/?search=' + val, headers, undefined, true).then(function (res) {
        _this17.filtersAuthors = res;
      }).catch(function (err) {
        console.log(err);
        console.log('----', err);
      }).finally(function () {
        return _this17.isLoadingAuthors = false;
      });
    },
    search: function search(val) {
      var _this18 = this;

      if (this.uploadVideoAuthor && val === this.uploadVideoAuthor.autocomplete_full_name) {
        this.entriesAuthors = [this.uploadVideoAuthor];
        return;
      }
      this.uploadVideoAuthor = null;

      if (!val) {
        this.entriesAuthors = [];
        this.uploadVideoAuthor = null;
        return;
      }

      if (this.isLoadingAuthors) return;
      this.isLoadingAuthors = true;
      var headers = __WEBPACK_IMPORTED_MODULE_21__services_auth__["a" /* default */].getAuthHeader();

      __WEBPACK_IMPORTED_MODULE_22__services_http__["a" /* default */].get('/media_platform/autocomplete/user/?search=' + val, headers, undefined, true).then(function (res) {
        _this18.entriesAuthors = res;
      }).catch(function (err) {
        console.log(err);
        console.log('----', err);
      }).finally(function () {
        return _this18.isLoadingAuthors = false;
      });
    }
  } });

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__marker_FTPSyncButton_vue__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__marker_FTPSyncButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__marker_FTPSyncButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__generic_Dropdown_vue__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__generic_Dropdown_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__generic_Dropdown_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    FtpSyncButton: __WEBPACK_IMPORTED_MODULE_0__marker_FTPSyncButton_vue___default.a,
    Dropdown: __WEBPACK_IMPORTED_MODULE_1__generic_Dropdown_vue___default.a
  }
});

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__repositories_MarkerRepository__ = __webpack_require__(56);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    markerId: {
      type: Number,
      required: false
    }
  },
  data: function data() {
    return {
      isLoading: false
    };
  },

  methods: {
    performSynchronization: function performSynchronization() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.isLoading = true;
                _context.prev = 1;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_2__repositories_MarkerRepository__["a" /* default */].triggerFTPSync(_this.markerId);

              case 4:
                response = _context.sent;

                _this.notifySuccess(response);
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](1);

                _this.notifyError(_context.t0);

              case 11:
                _context.prev = 11;

                _this.isLoading = false;
                return _context.finish(11);

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 8, 11, 14]]);
      }))();
    },
    notifySuccess: function notifySuccess(response) {
      var dataLink = response.path_to_marker_data;
      var message = this.$t('marker.ftp.records_link');
      this.$store.commit('snackbar/show', { href: dataLink, message: message });
    },
    notifyError: function notifyError(error) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response, json, _json, nonFieldErrors, detail, message;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                response = error.response;
                json = void 0;
                _context2.prev = 2;
                _context2.next = 5;
                return response.json();

              case 5:
                json = _context2.sent;
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2['catch'](2);

                json = {};

              case 11:
                _json = json, nonFieldErrors = _json.non_field_errors, detail = _json.detail;
                message = nonFieldErrors || detail || _this2.$t('marker.ftp.sync_error');

                _this2.$store.commit('snackbar/show', { message: message, color: 'error' });

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[2, 8]]);
      }))();
    }
  }
});

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3__ = __webpack_require__(903);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['root'],
  mounted: function mounted() {
    this.renderTree();
  },

  methods: {
    renderTree: function renderTree() {
      var nodeSize = 52;
      var leafSize = 48;
      var branchSize = 4;
      var padding = 24;

      var root = __WEBPACK_IMPORTED_MODULE_1_d3__["a" /* hierarchy */](this.root);

      var clusterFactory = __WEBPACK_IMPORTED_MODULE_1_d3__["b" /* tree */]().nodeSize([nodeSize, nodeSize]);
      var cluster = clusterFactory(root);
      var links = cluster.links();
      var nodes = cluster.descendants();

      var xmin = 0;
      var xmax = 0;
      var ymin = 0;
      var ymax = 0;

      cluster.each(function (node) {
        xmin = Math.min(xmin, node.x);
        xmax = Math.max(xmax, node.x);
        ymin = Math.min(ymin, node.y);
        ymax = Math.max(ymax, node.y);
      });

      var width = ymax - ymin;
      var height = xmax - xmin;

      var svg = __WEBPACK_IMPORTED_MODULE_1_d3__["c" /* select */](this.$el).append('svg').attr('width', width + leafSize / 2 + padding * 2).attr('height', height + leafSize + padding * 2).append('g').attr('transform', 'translate(' + padding + ', ' + (padding + leafSize / 2 + -xmin) + ')');

      var defs = svg.append('svg:defs');

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(cluster.leaves()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var leaf = _step.value;

          defs.append('svg:pattern').attr('id', leaf.data.name).attr('width', leafSize).attr('height', leafSize).attr('patternUnits', 'objectBoundingBox').append('svg:image').attr('xlink:href', leaf.data.thumb).attr('width', leafSize).attr('height', leafSize).attr('x', 0).attr('y', 0).attr('preserveAspectRatio', 'xMidYMid slice');
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      svg.selectAll('.link').data(links).enter().append('path').attr('class', 'link').attr('d', __WEBPACK_IMPORTED_MODULE_1_d3__["d" /* linkHorizontal */]().x(function (d) {
        return d.y;
      }).y(function (d) {
        return d.x;
      }));
      var node = svg.selectAll('.node').data(nodes).enter().append('g').attr('class', 'node').attr('transform', function (d) {
        return 'translate(' + d.y + ', ' + d.x + ')';
      });
      node.filter(function (d) {
        return d.children;
      }).append('circle').attr('class', function (d) {
        return d.parent ? 'branch' : 'root';
      }).attr('r', branchSize);
      node.filter(function (d) {
        return !d.children;
      }).append('circle').attr('r', leafSize / 2).attr('class', 'leaf').style('fill', '#fff').style('fill', function (d) {
        return 'url(#' + d.data.name + ')';
      });
      node.on('click', function (d) {
        if (d.parent) {
          console.log(d.data.name);
        }
      });
    }
  }
});

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_http__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_auth__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__generic_Dropdown_vue__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__generic_Dropdown_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__generic_Dropdown_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FTPSyncButton_vue__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FTPSyncButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__FTPSyncButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);









var locales = ['en', 'fr', 'nl'];

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['marker'],
  components: {
    Dropdown: __WEBPACK_IMPORTED_MODULE_3__generic_Dropdown_vue___default.a,
    FtpSyncButton: __WEBPACK_IMPORTED_MODULE_4__FTPSyncButton_vue___default.a
  },
  data: function data() {
    return {
      showOptions: false
    };
  },

  methods: {
    getLocalizedProp: function getLocalizedProp(obj) {
      var locale = this.currentLocale;
      if (obj[locale]) {
        return obj[locale];
      }
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(locales), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var l = _step.value;

          if (obj[l]) {
            return obj[l];
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    downloadCsv: function downloadCsv() {
      __WEBPACK_IMPORTED_MODULE_1__services_http__["a" /* default */].get('/marker/' + this.marker.id + '/csv/', __WEBPACK_IMPORTED_MODULE_2__services_auth__["a" /* default */].getAuthHeader()).then(function (response) {
        if (response.url) {
          window.location = response.url;
        }
      });
    }
  },
  computed: {
    currentLocale: function currentLocale() {
      return this.$i18n.locale;
    },
    hasStarted: function hasStarted() {
      return this.marker.starts_at.isBefore(__WEBPACK_IMPORTED_MODULE_5_moment___default()());
    }
  }
});

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_leaflet__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_leaflet_markercluster__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_leaflet_markercluster___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_leaflet_markercluster__);






__webpack_require__(276);
__webpack_require__(907);
__webpack_require__(906);

delete __WEBPACK_IMPORTED_MODULE_0_leaflet___default.a.Icon.Default.prototype._getIconUrl;

__WEBPACK_IMPORTED_MODULE_0_leaflet___default.a.Icon.Default.mergeOptions({
  iconRetinaUrl: __webpack_require__(952),
  iconUrl: __webpack_require__(953),
  shadowUrl: __webpack_require__(954)
});

var mapboxUrl = 'https://api.mapbox.com/styles/v1/philippe-look/cisadedxf003i2zo3t5ruhi23/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoicGhpbGlwcGUtbG9vayIsImEiOiJjaXNhZDl3aHQwMDJjMnVwNWtibDR2azBvIn0.rT49BllHbiANRj9yQL0ozQ';
/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['video_coords', 'image_coords', 'lat', 'long'],
  data: function data() {
    return {
      id: this._uid,
      doMapMove: true
    };
  },
  mounted: function mounted() {
    this.setupMapPreview(0, 0);
  },
  watch: {
    video_coords: function video_coords() {
      this.addMarkers();
    },
    image_coords: function image_coords() {
      this.addMarkers();
    }
  },
  methods: {
    setupMapPreview: function setupMapPreview(lat, long) {
      this.mapPreview = {};
      this.mapPreview.leaflet = __WEBPACK_IMPORTED_MODULE_0_leaflet___default.a.map('marker-map-' + this.id).setView([lat, long], 13);
      addMapboxLayerTo(this.mapPreview.leaflet);
      this.setupMarkers();
      this.mapPreview.leaflet.setView([0, 0], 13);
    },
    updateMapPreview: function updateMapPreview() {
      if (!this.markers || !this.markers.getBounds().isValid()) {
        this.mapPreview.leaflet.setView([0, 0], 13);
      } else {
        this.mapPreview.leaflet.on('zoomend', this.mapMoved);
        this.mapPreview.leaflet.fitBounds(this.markers.getBounds(), { padding: [50, 50] });
        this.mapPreview.leaflet.on('dragend', this.mapMoved);
      }
    },
    setupMarkers: function setupMarkers() {
      var _this = this;

      this.markers = __WEBPACK_IMPORTED_MODULE_0_leaflet___default.a.markerClusterGroup();
      this.mapPreview.leaflet.addLayer(this.markers);
      this.mapPreview.leaflet.on('click', function (a) {
        _this.doMapMove = true;
        if (_this.polygon) {
          _this.mapPreview.leaflet.removeLayer(_this.polygon);
          _this.polygon = false;
        }
        _this.mapMoved();
      });
      this.markers.on('clusterclick', function (a) {
        _this.doMapMove = false;

        var recordsV = [];
        var recordsI = [];
        a.layer.getAllChildMarkers().map(function (l) {
          if (l.properties.type === 'video') {
            recordsV.push(l.properties);
          } else {
            recordsI.push(l.properties);
          }
        });

        if (_this.polygon) {
          _this.mapPreview.leaflet.removeLayer(_this.polygon);
        }

        recordsV = recordsV.sort(_this.sort_ids).map(function (rec) {
          return rec.id;
        });
        recordsI = recordsI.sort(_this.sort_ids).map(function (rec) {
          return rec.id;
        });
        _this.polygon = __WEBPACK_IMPORTED_MODULE_0_leaflet___default.a.polygon(a.layer.getConvexHull());
        _this.mapPreview.leaflet.addLayer(_this.polygon);
        _this.$emit('map-moved', recordsV, recordsI);
      });
    },

    addMarkers: function addMarkers() {
      this.doMapMove = true;
      if (this.polygon) {
        this.mapPreview.leaflet.removeLayer(this.polygon);
        this.polygon = false;
      }
      if (this.markers) {
        this.markers.clearLayers();
      }
      if (this.video_coords && this.image_coords) {
        this.coords = this.video_coords.map(this.createVideoMarker);
        this.coords = this.coords.concat(this.image_coords.map(this.createImageMarker));
        this.markers.addLayers(this.coords);
        this.markers.on('click', this.clickedMarker);
        this.markers.refreshClusters();

        this.updateMapPreview();
      }
      this.mapMoved();
    },
    clickedMarker: function clickedMarker(e) {
      var id = e.layer.properties.id;
      this.$emit('clicked-marker', id);
    },
    mapMoved: function mapMoved(e) {
      if (!this.doMapMove) {
        return;
      }
      var bounds = this.mapPreview.leaflet.getBounds();
      var recordsV = [];
      var recordsI = [];
      this.markers.getLayers().filter(function (l) {
        return bounds.contains(l.getLatLng());
      }).map(function (l) {
        if (l.properties.type === 'video') {
          recordsV.push(l.properties);
        } else {
          recordsI.push(l.properties);
        }
      });
      recordsV = recordsV.sort(this.sort_ids).map(function (rec) {
        return rec.id;
      });
      recordsI = recordsI.sort(this.sort_ids).map(function (rec) {
        return rec.id;
      });
      this.$emit('map-moved', recordsV, recordsI);
    },
    createVideoMarker: function createVideoMarker(record) {
      return this.createMarker(record, 'video');
    },
    createImageMarker: function createImageMarker(record) {
      return this.createMarker(record, 'image');
    },
    createMarker: function createMarker(record, recordType) {
      var lat = record.point[1];
      var long = record.point[0];
      if (lat && long) {
        var marker = __WEBPACK_IMPORTED_MODULE_0_leaflet___default.a.marker(__WEBPACK_IMPORTED_MODULE_0_leaflet___default.a.latLng(lat, long));

        marker.properties = {};
        marker.properties.id = record.id;
        marker.properties.type = recordType;
        marker.properties.created_at = record.created_at;
        marker.properties.relevant = record.relevant;
        return marker;
      }
    },
    sort_ids: function sort_ids(a, b) {
      var dateA = new Date(a.created_at);
      var dateB = new Date(b.created_at);
      if (a.relevant > b.relevant) return -1;else if (a.relevant < b.relevant) return 1;
      if (dateA < dateB) return 1;
      if (dateA > dateB) return -1;
      return 0;
    }
  }
});

function addMapboxLayerTo(mapHandle) {
  __WEBPACK_IMPORTED_MODULE_0_leaflet___default.a.tileLayer(mapboxUrl).addTo(mapHandle);
}

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__repositories_MessageRepository_js__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_events__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_dates__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MessageGroupList__ = __webpack_require__(991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MessageGroupList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__MessageGroupList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_generic_Modal__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_generic_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_generic_Modal__);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    MessageGroupList: __WEBPACK_IMPORTED_MODULE_5__MessageGroupList___default.a,
    Modal: __WEBPACK_IMPORTED_MODULE_6__components_generic_Modal___default.a
  },
  props: ['markerId'],

  data: function data() {
    return {
      messages: [],
      timer: '',
      loading: true,
      DELIVERY_STATUS_NOTSENT: ['disabled_device', 'inactive_device', 'error'],
      DELIVERY_STATUS_FAILURE: ['failure'],
      DELIVERY_STATUS_SUCCESS: ['opened', 'delivered', 'in_app'],
      MESSAGE_STATUSES: {
        'opened': 'Opened',
        'delivered': 'Delivered',
        'in_app': 'In app',
        'disabled_device': 'Device disabled',
        'inactive_device': 'Device inactive',
        'error': 'Some error',
        'failure': 'Delivery failed',
        'processing': 'Processing'
      },
      FAILURE_STATUSES: {
        'Can not create endpoint': {
          status_class: 'status cnc_endpoint',
          title: 'Can not create endpoint'
        },
        'InvalidPlatformToken': {
          status_class: 'status invalid_plt',
          title: 'Invalid platform token'
        }
      },
      message_groups: [{
        key: 'delivered',
        title: 'Delivered messages',
        status_class: 'status success'
      }, {
        key: 'not_sent',
        title: 'Not sent messages because of device inactive or disabled or some error happend',
        status_class: 'status notsent'
      }, {
        key: 'failed',
        title: 'Messages have been sent but delivery failed',
        status_class: 'status failure'
      }, {
        key: 'pending',
        title: 'Processing messages',
        status_class: 'status pending'
      }, {
        key: 'disabled',
        title: 'User diable notification permission',
        status_class: 'status disabled'
      }],
      selected_message_group: {},
      messages_modal: false
    };
  },

  mounted: function mounted() {
    if (this.markerId) {
      this.setup(this.markerId);
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timer);
  },

  methods: {
    setup: function setup(markerId) {
      this.setupInterval(markerId);
      this.fetchMessages(markerId);
    },
    setupInterval: function setupInterval(markerId) {
      clearInterval(this.timer);
      this.timer = setInterval(this.updateMessages.bind(this, markerId), 20000);
    },
    readableDate: function readableDate(timestamp) {
      return __WEBPACK_IMPORTED_MODULE_4__services_dates__["a" /* default */].longFormat(__WEBPACK_IMPORTED_MODULE_4__services_dates__["a" /* default */].parseDate(timestamp));
    },
    updateMessages: function updateMessages(markerId) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__repositories_MessageRepository_js__["a" /* default */].fetchMarkerMessages(markerId).then(function (messages) {
        _this.messages = messages;
      });
    },
    fetchMessages: function fetchMessages(markerId) {
      var _this2 = this;

      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_2__repositories_MessageRepository_js__["a" /* default */].fetchMarkerMessages(markerId).then(function (messages) {
        _this2.loading = false;
        _this2.messages = messages;
      }, function (error) {
        _this2.loading = false;
        __WEBPACK_IMPORTED_MODULE_3__services_events__["a" /* default */].emit('error', error);
      });
    },
    groupMessages: function groupMessages(key) {
      var map = {
        delivered: this.deliveredMessages,
        failed: this.failedMessages,
        not_sent: this.notSentMessages,
        pending: this.pendingMessages,
        disabled: this.disabledMessages
      };
      return map[key];
    },
    showMessages: function showMessages(group) {
      this.selected_message_group = group;
      this.messages_modal = true;
    },
    hideMessages: function hideMessages() {
      this.messages_modal = false;
    },
    messageGroupStatuses: function messageGroupStatuses(messages) {
      return [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(messages.map(function (mes) {
        return mes.delivery_status;
      }))));
    },
    messageGroupFailures: function messageGroupFailures(messages) {
      var failures = [];
      messages.forEach(function (mes) {
        if (mes.failures.length) failures = failures.concat(mes.failures);
      });
      return [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(failures.map(function (failure) {
        return failure.failure_type;
      }))));
    },
    failureStatusClass: function failureStatusClass(failure) {
      if (failure in this.FAILURE_STATUSES) {
        return this.FAILURE_STATUSES[failure].status_class;
      }
      return 'status unmapped';
    }
  },

  computed: {
    sortedMessages: function sortedMessages() {
      return this.messages.slice().sort(sortIdAsc);
    },
    deliveredMessages: function deliveredMessages() {
      var _this3 = this;

      return this.sortedMessages.filter(function (mes) {
        return _this3.DELIVERY_STATUS_SUCCESS.indexOf(mes.delivery_status) !== -1;
      });
    },
    failedMessages: function failedMessages() {
      var _this4 = this;

      return this.sortedMessages.filter(function (mes) {
        return _this4.DELIVERY_STATUS_FAILURE.indexOf(mes.delivery_status) !== -1 && mes.notification_permission !== false;
      });
    },
    notSentMessages: function notSentMessages() {
      var _this5 = this;

      return this.sortedMessages.filter(function (mes) {
        return _this5.DELIVERY_STATUS_NOTSENT.indexOf(mes.delivery_status) !== -1 && mes.notification_disabled !== false;
      });
    },
    pendingMessages: function pendingMessages() {
      return this.sortedMessages.filter(function (mes) {
        return mes.delivery_status === 'processing';
      });
    },
    disabledMessages: function disabledMessages() {
      return this.sortedMessages.filter(function (mes) {
        return mes.notification_permission === false;
      });
    },
    selectedGroupMessages: function selectedGroupMessages() {
      if (this.selected_message_group.key) {
        return this.groupMessages(this.selected_message_group.key);
      }
      return [];
    }
  }
});

function sortIdAsc(a, b) {
  return a.id - b.id;
}

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MarkerMap_vue__ = __webpack_require__(988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MarkerMap_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MarkerMap_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__record_RecordsList_vue__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__record_RecordsList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__record_RecordsList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__repositories_RecordRepository_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MarkerDendrogram_vue__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MarkerDendrogram_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__MarkerDendrogram_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__record_RecordDetails_vue__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__record_RecordDetails_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__record_RecordDetails_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_events__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__record_MarkerTagsSelector__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__record_MarkerTagsSelector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__record_MarkerTagsSelector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__record_InappropriateFilter__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__record_InappropriateFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__record_InappropriateFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__record_LmrCategoryFilter__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__record_LmrCategoryFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__record_LmrCategoryFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__record_LmrCityReportFilter__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__record_LmrCityReportFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__record_LmrCityReportFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuex__ = __webpack_require__(26);















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    RecordsList: __WEBPACK_IMPORTED_MODULE_2__record_RecordsList_vue___default.a,
    RecordDetails: __WEBPACK_IMPORTED_MODULE_5__record_RecordDetails_vue___default.a,
    Dendrogram: __WEBPACK_IMPORTED_MODULE_4__MarkerDendrogram_vue___default.a,
    MarkerTagsSelector: __WEBPACK_IMPORTED_MODULE_7__record_MarkerTagsSelector___default.a,
    MarkerMap: __WEBPACK_IMPORTED_MODULE_1__MarkerMap_vue___default.a,
    InappropriateFilter: __WEBPACK_IMPORTED_MODULE_8__record_InappropriateFilter___default.a,
    LmrCategoryFilter: __WEBPACK_IMPORTED_MODULE_9__record_LmrCategoryFilter___default.a,
    LmrCityReportFilter: __WEBPACK_IMPORTED_MODULE_10__record_LmrCityReportFilter___default.a
  },
  props: ['marker'],
  data: function data() {
    return {
      records: [],
      video_coords: [],
      image_coords: [],
      filteredIds: [],
      filteredImageIds: [],
      imageRecords: [],
      newRecords: [],
      newRecordsCount: 0,
      relatedRecords: [],
      diversityTree: null,
      showTree: false,
      timer: '',
      loading: true,
      selectedRecord: null,
      recordFilters: {
        tags: [],
        inappropriate: 'hide',

        lmr_category: '',
        lmr_cities: []
      },
      activeTab: 0,
      ordering: 'default',
      orderingItems: [{ 'key': 'diversity', 'label': 'Sort by Diversity' }, { 'key': 'consistency', 'label': 'Sort by Consistency' }, { 'key': 'relevance', 'label': 'Sort by Relevance' }],
      pageSize: 30,
      recordsPage: 1,
      imagesPage: 1,
      recordCount: 0
    };
  },
  mounted: function mounted() {
    this.setup();
  },
  methods: {
    setup: function setup() {
      this.fetchRecordCoords();
      this.fetchRelatedRecords();
      this.fetchRecordsDiversity();
    },
    setupInterval: function setupInterval() {
      clearInterval(this.timer);
      this.timer = setInterval(this.updateRecords.bind(this), 30000);
    },
    handleRecordDelete: function handleRecordDelete(record, recordType) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_3__repositories_RecordRepository_js__["a" /* default */].deleteRecord(this.markerId, record).then(function () {
        _this.fetchRecords(recordType);
      }, function (error) {
        __WEBPACK_IMPORTED_MODULE_6__services_events__["a" /* default */].emit('error', error, '', { modal: false });
      });
    },
    handleRecordRestore: function handleRecordRestore(record, recordType) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_3__repositories_RecordRepository_js__["a" /* default */].restoreRecord(this.markerId, record).then(function () {
        _this2.fetchRecords(recordType);
      }, function (error) {
        __WEBPACK_IMPORTED_MODULE_6__services_events__["a" /* default */].emit('error', error, '', { modal: false });
      });
    },
    handleTagsSelected: function handleTagsSelected(tags) {
      this.filteredIds = [];
      this.filteredImageIds = [];
      this.recordFilters.tags = tags;

      this.fetchRecordCoords();
    },
    handleLmrCitySelected: function handleLmrCitySelected(cities) {
      this.recordFilters.lmr_cities = cities;
      this.fetchRecordCoords(true);
    },
    changeOrdering: function changeOrdering(ordering) {
      this.records = this.records.sort(function (a, b) {
        return (b.mldata[ordering] || 0) - (a.mldata[ordering] || 0);
      });
    },
    fetchRecordsFromRepository: function fetchRecordsFromRepository(recordType, page) {
      return __WEBPACK_IMPORTED_MODULE_3__repositories_RecordRepository_js__["a" /* default */].fetchMarkerRecords(this.marker, page, this.pageSize, this.recordFilters, recordType, this.activeTab);
    },
    updateRecords: function updateRecords() {
      var _this3 = this;

      this.fetchRecordsFromRepository('VIDEO', this.recordsPage).then(function (records) {
        var oldIds = _this3.records.map(function (record) {
          return record.id;
        });
        var newRecordsCount = records.filter(function (record) {
          return oldIds.indexOf(record.id) < 0;
        }).length;
        if (newRecordsCount > 0) {
          if (_this3.records.length === 0) {
            _this3.records = records;
          } else if (_this3.records.length > 0) {
            _this3.newRecords = records;
            _this3.newRecordsCount = newRecordsCount;
          }
        }
      });
    },
    swapInNewRecords: function swapInNewRecords() {
      this.records = this.newRecords.splice(0, this.newRecords.length);
      this.newRecords.length = 0;
      this.newRecordsCount = 0;
    },
    fetchRecords: function fetchRecords(recordType) {
      var _this4 = this;

      this.loading = true;
      var page = recordType === 'VIDEO' ? this.recordsPage : this.imagesPage;
      this.fetchRecordsByIds(recordType, page).then(function (records) {
        _this4.loading = false;
        _this4.setRecords(recordType, records);
      }, function (error) {
        _this4.loading = false;
        __WEBPACK_IMPORTED_MODULE_6__services_events__["a" /* default */].emit('error', error);
      });
    },
    fetchRecordsByIds: function fetchRecordsByIds(recordType, page) {
      var offset;
      var ids = [];
      if (recordType === 'VIDEO' && this.filteredIds) {
        offset = (page - 1) * this.pageSize;
        ids = this.filteredIds.slice(offset, offset + this.pageSize);
      } else if (recordType === 'IMAGE' && this.filteredImageIds) {
        offset = (page - 1) * this.pageSize;
        ids = this.filteredImageIds.slice(offset, offset + this.pageSize);
      }
      if (ids.length) {
        return __WEBPACK_IMPORTED_MODULE_3__repositories_RecordRepository_js__["a" /* default */].fetchMarkerRecordsByIds(this.marker, recordType, ids);
      }
      return [];
    },
    fetchRecordCoords: function fetchRecordCoords() {
      var _this5 = this;

      var onlyVideo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!this.markerId) {
        return;
      }
      this.loading = true;
      this.video_coords = [];

      __WEBPACK_IMPORTED_MODULE_3__repositories_RecordRepository_js__["a" /* default */].fetchMarkerRecordCoords(this.markerId, this.recordFilters, 'VIDEO', this.activeTab).then(function (coords) {
        _this5.loading = false;
        _this5.video_coords = coords;
        _this5.recordCount = _this5.video_coords.length;
        _this5.records = [];
      }, function (error) {
        _this5.loading = false;
        __WEBPACK_IMPORTED_MODULE_6__services_events__["a" /* default */].emit('error', error);
      });

      if (onlyVideo) return;

      this.image_loading = true;
      this.image_coords = [];
      __WEBPACK_IMPORTED_MODULE_3__repositories_RecordRepository_js__["a" /* default */].fetchMarkerRecordCoords(this.markerId, this.recordFilters, 'IMAGE', this.activeTab).then(function (coords) {
        _this5.image_loading = false;
        _this5.image_coords = coords;
        _this5.imageCount = _this5.image_coords.length;
        _this5.imageRecords = [];
      }, function (error) {
        _this5.image_loading = false;
        __WEBPACK_IMPORTED_MODULE_6__services_events__["a" /* default */].emit('error', error);
      });
    },
    setRecords: function setRecords(recordType, records) {
      if (recordType === 'VIDEO') {
        this.records = records;
      } else {
        this.imageRecords = records;
      }
    },
    fetchRelatedRecords: function fetchRelatedRecords() {
      var _this6 = this;

      if (!this.markerId) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_3__repositories_RecordRepository_js__["a" /* default */].fetchMarkerRelatedRecords(this.markerId, this.activeTab).then(function (records) {
        _this6.relatedRecords = records;
      });
    },
    fetchRecordsDiversity: function fetchRecordsDiversity() {
      var _this7 = this;

      if (!this.markerId) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_3__repositories_RecordRepository_js__["a" /* default */].fetchMarkerRecordsDiversityTree(this.markerId).then(function (response) {
        _this7.diversityTree = response.tree;
      });
    },
    markRecordRelevance: function markRecordRelevance(record, relevance, recordType) {
      var r = this.getRecords(recordType).find(function (r) {
        return r.id === record.id;
      });
      if (r && r.mldata) {
        r.mldata.marked_as_relevant = relevance;
      }
      __WEBPACK_IMPORTED_MODULE_3__repositories_RecordRepository_js__["a" /* default */].patchRecordRelevance(this.markerId, record, relevance).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_6__services_events__["a" /* default */].emit('error', error, '', { modal: false });
      });
    },
    getRecords: function getRecords(recordType) {
      var typeMapping = {
        'VIDEO': this.records,
        'IMAGE': this.imageRecords
      };
      return typeMapping[recordType];
    },
    tabSelected: function tabSelected() {
      this.filteredIds = [];
      this.filteredImageIds = [];
      this.records = [];
      this.imageRecords = [];

      this.fetchRecordCoords();
      this.fetchRelatedRecords();
    },
    calculateAmountPages: function calculateAmountPages(recordType) {
      if (recordType === 'VIDEO') {
        return Math.ceil(this.recordCount / this.pageSize) || 1;
      } else {
        return Math.ceil(this.imageCount / this.pageSize) || 1;
      }
    },
    showRecordDetails: function showRecordDetails(record) {
      this.selectedRecord = record;
    },
    handleClickedMarker: function handleClickedMarker(id) {
      var _this8 = this;

      __WEBPACK_IMPORTED_MODULE_3__repositories_RecordRepository_js__["a" /* default */].fetchMarkerRecordsByIds(this.marker, '', [id]).then(function (record) {
        _this8.showRecordDetails(record[0]);
      });
    },
    handleMapMoved: function handleMapMoved(idsV, idsI) {
      if (!this.compareArrays(idsV, this.filteredIds)) {
        this.filteredIds = idsV;
        this.recordsPage = 1;
        this.recordCount = this.filteredIds.length;
        this.records = [];
        if (idsV.length) {
          this.fetchRecords('VIDEO');
        }
      }
      if (!this.compareArrays(idsI, this.filteredImageIds)) {
        this.filteredImageIds = idsI;
        this.imagesPage = 1;
        this.imageCount = this.filteredImageIds.length;
        this.imageRecords = [];
        if (idsI.length) {
          this.fetchRecords('IMAGE');
        }
      }
    },
    compareArrays: function compareArrays(arr1, arr2) {
      if (arr1.length !== arr2.length) {
        return false;
      }
      for (var i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) {
          return false;
        }
      }
      return true;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex__["a" /* mapGetters */])(['isLmrConsumer']), {
    markerId: function markerId() {
      return this.marker && this.marker.id;
    }
  }),
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timer);
  }
});

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_dates__ = __webpack_require__(28);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    messages: Array,
    failure_statuses: Object
  },
  methods: {
    readableDate: function readableDate(timestamp) {
      return __WEBPACK_IMPORTED_MODULE_0__services_dates__["a" /* default */].longFormat(__WEBPACK_IMPORTED_MODULE_0__services_dates__["a" /* default */].parseDate(timestamp));
    },
    title: function title(message) {
      var _this = this;

      var title = this.readableDate(message.updated_at);
      if (message.failures.length) {
        message.failures.forEach(function (failure) {
          if (failure.failure_type in _this.failure_statuses) {
            title += ' ' + _this.failure_statuses[failure.failure_type].title;
          } else {
            title += ' ' + failure.failure_type;
          }
        });
      }
      return title;
    },
    statusClass: function statusClass(message) {
      if (message.failures.length) {
        var failure = message.failures[0];
        if (failure.failure_type in this.failure_statuses) {
          return this.failure_statuses[failure.failure_type].status_class;
        }
      }
      return message.delivery_status;
    }
  }
});

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_debounce__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default.a
  },
  data: function data() {
    return {
      value: []
    };
  },
  methods: {
    inputHandler: __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default()(function () {
      var filterOptions = this.value.map(function (option) {
        return option.name;
      });
      this.$emit('change', filterOptions);
    }, 1000)
  },
  computed: {
    optionsEditorConsumers: function optionsEditorConsumers() {
      if (this.$store.state.editorConsumers) {
        return this.$store.state.editorConsumers;
      }
      return [];
    }
  }
});

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: String
  },
  data: function data() {
    return {
      val: this.value
    };
  },

  methods: {
    changeValue: function changeValue() {
      this.$emit('input', this.val);
      this.$emit('change', this.val);
    }
  }
});

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: String
  },
  data: function data() {
    return {
      val: ''
    };
  },

  methods: {
    changeValue: function changeValue() {
      this.$emit('input', this.val);
      this.$emit('change', this.val);
    }
  }
});

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(15);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default.a
  },
  mounted: function mounted() {
    if (!this.options) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__store__["d" /* refreshGroups */])(this.$store);
    }
  },


  data: function data() {
    return {
      value: []
    };
  },
  methods: {
    inputHandler: __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default()(function () {
      var filterOptions = this.value.map(function (option) {
        return option.slug;
      });
      this.$emit('change', filterOptions);
    }, 1000)
  },
  computed: {
    options: function options() {
      if (this.$store.state.groups) {
        return this.$store.state.groups;
      }
      return [];
    },
    optionsEditorConsumers: function optionsEditorConsumers() {
      if (this.$store.state.editorConsumers) {
        return this.$store.state.editorConsumers;
      }
      return [];
    }
  }
});

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      engines: {
        aws: 'aws',
        kul: 'kul',
        man: 'man' }
    };
  },

  props: ['record'],
  filters: {
    round: function round(val) {
      return Math.round(val * 100) / 100;
    }
  },
  computed: {
    tags: function tags() {
      return this.record.mltags;
    },
    mlTags: function mlTags() {
      var _this = this;

      return this.tags.filter(function (tag) {
        return tag.engine !== _this.engines.man;
      }).sort(function (a, b) {
        var accDiff = b.accuracy - a.accuracy;
        if (accDiff !== 0) return accDiff;else return b.frames - a.frames;
      });
    },
    manualTags: function manualTags() {
      var _this2 = this;

      return this.tags.filter(function (tag) {
        return tag.engine === _this2.engines.man;
      }).sort(function (a, b) {
        return a.category <= b.category ? -1 : 1;
      });
    }
  }
});

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__repositories_RecordRepository__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_events__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_debounce__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_debounce__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default.a
  },
  props: {
    markerId: {
      type: Number,
      required: false
    }
  },
  mounted: function mounted() {
    this.fetchTags();
  },


  data: function data() {
    return {
      loading: false,
      value: [],
      options: []
    };
  },
  methods: {
    fetchTags: function fetchTags() {
      var _this = this;

      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_1__repositories_RecordRepository__["a" /* default */].fetchMarkerRecordTags(this.markerId).then(function (tags) {
        _this.loading = false;
        _this.options = _this.convertTagsToOptions(tags);
      }, function (error) {
        _this.loading = false;
        __WEBPACK_IMPORTED_MODULE_2__services_events__["a" /* default */].emit('error', error);
      });
    },
    convertTagsToOptions: function convertTagsToOptions(tags) {
      return tags.map(function (_ref) {
        var tag = _ref.tag,
            records = _ref.records;

        return {
          name: tag,
          records: records
        };
      });
    },

    inputHandler: __WEBPACK_IMPORTED_MODULE_3_lodash_debounce___default()(function (tags) {
      var tagNames = tags.map(function (tag) {
        return tag.name;
      });
      this.$emit('tags-selected', tagNames);
    }, 1000)
  }
});

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_video_js__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_video_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_video_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_videojs_thumbnails_videojs_thumbnails_js__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VideoModal_vue__ = __webpack_require__(999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VideoModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__VideoModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_events__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_debounce__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_debounce__);



__webpack_require__(277);

__webpack_require__(908);

__WEBPACK_IMPORTED_MODULE_0_video_js___default.a.registerPlugin('thumbnails', __WEBPACK_IMPORTED_MODULE_1__libs_videojs_thumbnails_videojs_thumbnails_js__["a" /* default */]);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    VideoModal: __WEBPACK_IMPORTED_MODULE_2__VideoModal_vue___default.a
  },
  data: function data() {
    return {
      showPlayer: false,
      playerReady: false,
      record: {
        url: null
      },
      playerElement: 'videojs-' + this._uid,
      playerOptions: {
        'controls': true,
        'autoplay': false,
        'preload': false
      }
    };
  },

  watch: {
    'showPlayer': function showPlayer(newValue, oldValue) {
      if (!newValue && oldValue) {
        this.player.pause();
      }
    }
  },
  mounted: function mounted() {
    this.resizeHandler = __WEBPACK_IMPORTED_MODULE_4_lodash_debounce___default()(this.adjustRatioEvent, 300);
    window.addEventListener('resize', this.resizeHandler);
    __WEBPACK_IMPORTED_MODULE_3__services_events__["a" /* default */].bus.$on('play-record', this.play);
    this.setupPlayer();
  },
  methods: {
    play: function play(record) {
      this.record = record;
      if (this.record.height && this.record.width) {
        this.adjustRatio(this.record.width / this.record.height);
      }
      this.playerReady = false;
      this.showPlayer = true;
      this.$nextTick(function () {
        var _this2 = this;

        this.player.on('loadedmetadata', function () {
          _this2.adjustRatio();
          _this2.playerReady = true;
        });
        this.player.pause();
        this.player.loadingSpinner.show();
        this.player.src(record.url);
        this.player.poster(record.thumbnail);
        if (record.sprite) {
          this.setUpThumbnailPreviews(this.player, record.sprite);
        } else {
          this.clearThumbnailPreviews();
        }
        this.player.load();
        this.player.play();
      });
    },
    stop: function stop() {
      this.showPlayer = false;
      this.player.pause();
    },

    setupPlayer: function setupPlayer() {
      if (this.playerSetUp) {
        return;
      }
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_0_video_js___default()(this.playerElement, this.playerOptions, function () {
        _this.player = this;
        _this.playerSetUp = true;
        _this.player.thumbnails();
      });
    },
    clearThumbnailPreviews: function clearThumbnailPreviews() {
      this.player.thumbnails().updateState({});
    },
    setUpThumbnailPreviews: function setUpThumbnailPreviews(player, sprite) {
      var frames = Math.floor(sprite.width / sprite.h_interval);
      var options = {
        0: {
          src: sprite.url,
          style: {
            height: sprite.height + 'px',
            width: sprite.width + 'px',
            clip: 'rect(0, ' + sprite.h_interval + 'px, ' + sprite.height + 'px, 0)',
            left: '-' + sprite.h_interval / 2 + 'px'
          }
        }
      };
      for (var i = 1; i < frames; i++) {
        options[i] = {
          style: {
            clip: 'rect(0, ' + sprite.h_interval * (i + 1) + 'px, ' + sprite.height + 'px, ' + sprite.h_interval * i + 'px)',
            left: '-' + (sprite.h_interval / 2 + sprite.h_interval * i) + 'px'
          }
        };
      }
      player.thumbnails().updateState(options);
    },
    adjustRatioEvent: function adjustRatioEvent(event) {
      this.adjustRatio();
    },
    adjustRatio: function adjustRatio(ratio) {
      if (this.playerSetUp) {
        if (!ratio) {
          ratio = this.player.videoWidth() / this.player.videoHeight();
        }
        var el = document.getElementById(this.playerElement);
        if (ratio && el) {
          var pageHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
          var pageWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
          var maxHeight = pageHeight * 0.8;
          var maxWidth = pageWidth * 0.8;
          if (ratio >= 1) {
            el.style.width = maxWidth + 'px';
            el.style.height = Math.floor(maxWidth / ratio) + 'px';
          } else {
            el.style.width = Math.floor(maxHeight * ratio) + 'px';
            el.style.height = maxHeight + 'px';
          }
        }
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.player.dispose();
    window.removeEventListener('resize', this.resizeHandler);
  }
});

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__repositories_RecordRepository__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RecordCutSlider__ = __webpack_require__(996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RecordCutSlider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__RecordCutSlider__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RecordCut',
  components: {
    RecordCutSlider: __WEBPACK_IMPORTED_MODULE_1__RecordCutSlider___default.a
  },
  props: {
    record: Object,
    processing: Boolean
  },
  data: function data() {
    return {
      range: { start: 0, stop: 0 },
      cut_btn_disabled: false
    };
  },

  methods: {
    updateRange: function updateRange(range) {
      this.range = range;
    },
    cutRecord: function cutRecord() {
      var _this = this;

      this.cut_btn_disabled = true;
      var newDuration = (this.range.stop || this.record.duration) - this.range.start;
      var media = this.record.media && this.record.media.find(function (media) {
        return media.name === 'vod';
      });
      __WEBPACK_IMPORTED_MODULE_0__repositories_RecordRepository__["a" /* default */].cutVideo(this.record.id, this.range.start, this.range.stop).then(function (resp) {
        _this.cut_btn_disabled = false;

        if (media) _this.$set(media, 'duration', newDuration);
        _this.$emit('cut-started');
      }, function (err) {
        err.response.json().then(function (resp) {
          _this.cut_btn_disabled = false;
          _this.$store.commit('snackbar/show', {
            message: resp.detail || err.message,
            color: 'red',
            timeout: 8000
          });
        });
      });
    },
    closeCutWindow: function closeCutWindow() {
      this.$emit('cancel');
    }
  }, beforeDestroy: function beforeDestroy() {
    clearInterval(this.notify_interval);
  }
});

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RecordPlayer_vue__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RecordPlayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__RecordPlayer_vue__);


var _this = this;





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    record: Object
  },

  components: {
    RecordPlayer: __WEBPACK_IMPORTED_MODULE_3__RecordPlayer_vue___default.a
  },

  data: function data() {
    return {
      sprite: null,
      leftControlPos: 0,
      rightControlPos: 0,
      runnerPos: 0,
      sliderWidth: 0,
      playerOptions: null,
      frames: [],
      playing: false
    };
  },
  mounted: function mounted() {
    this.sprite = this.record.media.find(function (el) {
      return el.name === 'thumbspritehoriz';
    });
    this.setSliderWidth();
    this.playerOptions = this.getRecordPlayerOptions(this.record);
    window.addEventListener('resize', this.onWindowResize);
    this.calcFrames();
  },


  computed: {
    frameStyle: function frameStyle() {
      if (this.sprite) return { 'background-image': 'url(' + this.sprite.url + ')' };
      return {};
    },
    leftControlStyle: function leftControlStyle() {
      return { left: this.leftControlPos + 'px' };
    },
    rightControlStyle: function rightControlStyle() {
      return { right: this.rightControlPos + 'px' };
    },
    leftMaskStyle: function leftMaskStyle() {
      return { width: this.leftControlPos + 'px' };
    },
    rightMaskStyle: function rightMaskStyle() {
      return { width: this.rightControlPos + 'px' };
    },
    runnerStyle: function runnerStyle() {
      return {
        left: this.runnerPos + 'px'
      };
    },
    pixelWeight: function pixelWeight() {
      return this.$props.record.duration / this.sliderWidth;
    },
    leftControlVideoPosition: function leftControlVideoPosition() {
      return this.leftControlPos * this.pixelWeight;
    },
    leftControlVideoPositionFormatted: function leftControlVideoPositionFormatted() {
      return this.formatDuration(this.leftControlVideoPosition);
    },
    rightControlVideoPosition: function rightControlVideoPosition() {
      return (this.sliderWidth - this.rightControlPos) * this.pixelWeight;
    },
    rightControlVideoPositionFormatted: function rightControlVideoPositionFormatted() {
      return this.formatDuration(this.rightControlVideoPosition);
    },
    videoSectionDuration: function videoSectionDuration() {
      return this.rightControlVideoPosition - this.leftControlVideoPosition;
    },
    videoSectionDurationFormatted: function videoSectionDurationFormatted() {
      return this.formatDuration(this.videoSectionDuration);
    },
    showControlTime: function showControlTime() {
      return this.sliderWidth - this.leftControlPos - this.rightControlPos > 150;
    }
  },

  methods: {
    getRecordPlayerOptions: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* getRecordPlayerOptions */],
    dragLeftControlStart: function dragLeftControlStart(e) {
      e.preventDefault();
      document.addEventListener('mousemove', this.dragLeftControl);
      document.addEventListener('mouseup', this.dragControlStop);
    },
    dragTouchLeftControlStart: function dragTouchLeftControlStart(e) {
      e.preventDefault();
      document.addEventListener('touchmove', this.dragTouchLeftControl);
      document.addEventListener('touchend', this.dragTouchControlStop);
    },
    dragRightControlStart: function dragRightControlStart(e) {
      e.preventDefault();
      document.addEventListener('mousemove', this.dragRightControl);
      document.addEventListener('mouseup', this.dragControlStop);
    },
    dragTouchRightControlStart: function dragTouchRightControlStart(e) {
      e.preventDefault();
      document.addEventListener('touchmove', this.dragTouchRightControl);
      document.addEventListener('touchend', this.dragTouchControlStop);
    },
    dragLeftControl: function dragLeftControl(e) {
      e.preventDefault();
      this.dragControl('left', e.clientX - this.$refs.slider.offsetLeft);
    },
    dragTouchLeftControl: function dragTouchLeftControl(e) {
      this.dragControl('left', e.touches[0].clientX - this.$refs.slider.offsetLeft);
    },
    dragRightControl: function dragRightControl(e) {
      e.preventDefault();
      this.dragControl('right', this.$refs.slider.offsetLeft + this.sliderWidth - e.clientX);
    },
    dragTouchRightControl: function dragTouchRightControl(e) {
      this.dragControl('right', this.$refs.slider.offsetLeft + this.sliderWidth - e.touches[0].clientX);
    },
    dragControl: function dragControl(side, pos) {
      var oppositePos = this[(side === 'left' ? 'right' : 'left') + 'ControlPos'];
      if (pos < 0) pos = 0;
      if (this.sliderWidth - pos - oppositePos > 10) {
        this[side + 'ControlPos'] = pos;
        if (side === 'right') pos = this.sliderWidth - pos;
        this.setPlayerPosition(pos);
      }
    },
    dragControlStop: function dragControlStop(e) {
      e.preventDefault();
      document.removeEventListener('mousemove', this.dragLeftControl);
      document.removeEventListener('mousemove', this.dragRightControl);
      document.removeEventListener('mouseup', this.dragControlStop);
      this.$emit('range-update', {
        start: Math.round(this.leftControlVideoPosition * 100) / 100,
        stop: Math.round(this.rightControlVideoPosition * 100) / 100
      });
    },
    dragTouchControlStop: function dragTouchControlStop(e) {
      e.preventDefault();
      document.removeEventListener('touchmove', this.dragTouchLeftControl);
      document.removeEventListener('touchmove', this.dragTouchRightControl);
      document.removeEventListener('touchend', this.dragTouchControlStop);
      this.$emit('range-update', {
        start: Math.round(this.leftControlVideoPosition * 100) / 100,
        stop: Math.round(this.rightControlVideoPosition * 100) / 100
      });
    },
    formatDuration: function formatDuration(seconds) {
      var m = parseInt(seconds / 60);
      var s = parseInt(seconds - m * 60);
      var ds = '0';
      if (String(seconds).indexOf('.') !== -1) {
        ds = String(seconds).split('.')[1][0];
      }
      return String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0') + '.' + ds;
    },
    setRunnerPos: function setRunnerPos(e) {
      this.runnerPos = e.clientX - this.$refs.slider.offsetLeft;
      this.setPlayerPosition(this.runnerPos);
    },
    playerTimeUpdateHandler: function playerTimeUpdateHandler(event) {
      if (!this.playing) return;
      var time = event.target.currentTime;

      if (time + 0.15 >= this.rightControlVideoPosition) {
        this.setPlayerPosition(this.leftControlPos);
      }
      this.runnerPos = time / this.pixelWeight;
    },
    play: function play() {
      this.$refs.playerComponent.player.play();
    },
    pause: function pause() {
      this.$refs.playerComponent.player.pause();
    },
    setPlayerPosition: function setPlayerPosition(pos) {
      this.$refs.playerComponent.player.currentTime(this.pixelWeight * pos);
    },
    currentTime: function currentTime() {
      return this.$refs.playerComponent.player.currentTime();
    },
    playRange: function playRange() {
      if (this.playing) {
        this.pause();
      } else {
        if (this.currentTime() < this.leftControlVideoPosition || this.currentTime() + 0.2 >= this.rightControlVideoPosition) {
          this.setPlayerPosition(this.leftControlPos);
        }
        this.play();
      }
    },
    setSliderWidth: function setSliderWidth() {
      this.sliderWidth = this.$refs.slider.offsetWidth;
    },

    onWindowResize: __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default()(function () {
      _this.setSliderWidth();
    }, 100),
    calcFrames: function calcFrames() {
      var sprite = this.sprite;
      var framesInSprite = Math.floor(sprite.width / sprite.sprite_interval_h);

      var frameWidth = 60 * sprite.width / framesInSprite / sprite.height;
      var style = {};
      var framesNum = Math.ceil(this.sliderWidth / frameWidth);
      if (framesNum > framesInSprite) {
        framesNum = framesInSprite;
        style['width'] = frameWidth + 'px';
      } else {
        style['flex-grow'] = 1;
      }
      var step = Math.round(framesInSprite / framesNum) || 1;
      this.framesNum = framesNum;
      for (var i = 0; i < framesNum; i++) {
        var bgPos = Math.round(-step * i * frameWidth);
        if (step * i >= framesInSprite) bgPos += frameWidth;
        this.frames.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ 'background-position-x': bgPos + 'px' }, style));
      }
    }
  }, beforeDestroy: function beforeDestroy() {
    document.removeEventListener('mouseup', this.dragControlStop);
    window.removeEventListener('resize', this.onWindowResize);
  }
});

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RecordPlayer_vue__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RecordPlayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__RecordPlayer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Thumbnail_vue__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Thumbnail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Thumbnail_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__repositories_RecordRepository_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_dates__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RecordCut__ = __webpack_require__(995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RecordCut___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__RecordCut__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(170);












var round = function round(val) {
  return Math.round(val * 100) / 100;
};

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['record', 'markerId'],
  data: function data() {
    return {
      similarRecords: [],
      videoRequestText: '',
      videoRequestLoading: false,
      recordCutEnabled: false,
      cutNotifyInterval: null,
      cutProcessing: false,
      editTagsActive: false,
      editableTags: [],
      tagsSelectOptions: [],
      engines: {
        aws: 'aws',
        kul: 'kul',
        man: 'man' }
    };
  },

  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default.a,
    RecordPlayer: __WEBPACK_IMPORTED_MODULE_2__RecordPlayer_vue___default.a,
    Thumbnail: __WEBPACK_IMPORTED_MODULE_3__Thumbnail_vue___default.a,
    RecordCut: __WEBPACK_IMPORTED_MODULE_7__RecordCut___default.a
  },
  mounted: function mounted() {
    window.addEventListener('keyup', this.keypressed);
    this.updateSimilarRecords();
    this.checkCutState();
    this.tagsSelectOptions = this.record.mltags.map(function (tag) {
      return { name: tag.category };
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('keyup', this.keypressed);
    clearInterval(this.cutNotifyInterval);
  },

  watch: {
    record: function record() {
      this.similarRecords = [];
      this.updateSimilarRecords();
    }
  },
  filters: {
    round: round,
    filesize: function filesize(val) {
      return round(val / 1024 / 1024);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapGetters */])(['isLmrConsumer']), {
    vod: function vod() {
      return this.record.media && this.record.media.find(function (media) {
        return media.name === 'vod';
      });
    },
    original: function original() {
      return this.record.media && this.record.media.find(function (media) {
        return media.name === 'original';
      });
    },
    tags: function tags() {
      var _this = this;

      var manualTags = this.record.mltags.filter(function (tag) {
        return tag.engine === _this.engines.man;
      }).sort(function (a, b) {
        return a.category <= b.category ? -1 : 1;
      }).map(function (tag) {
        return tag.category;
      });

      var tags = this.record.mltags.filter(function (tag) {
        return tag.engine !== _this.engines.man;
      }).sort(function (a, b) {
        var accDiff = b.accuracy - a.accuracy;
        if (accDiff !== 0) return accDiff;else return b.frames - a.frames;
      }).map(function (tag) {
        return tag.category;
      });
      return manualTags.concat(tags);
    },
    recordDate: function recordDate() {
      return __WEBPACK_IMPORTED_MODULE_5__services_dates__["a" /* default */].dateFormat(__WEBPACK_IMPORTED_MODULE_5__services_dates__["a" /* default */].parseDate(this.record.shooting_date));
    },
    recordTime: function recordTime() {
      return __WEBPACK_IMPORTED_MODULE_5__services_dates__["a" /* default */].timeFormat(__WEBPACK_IMPORTED_MODULE_5__services_dates__["a" /* default */].parseDate(this.record.shooting_date));
    },
    recordTz: function recordTz() {
      return __WEBPACK_IMPORTED_MODULE_5__services_dates__["a" /* default */].tzFormat(__WEBPACK_IMPORTED_MODULE_5__services_dates__["a" /* default */].parseDate(this.record.shooting_date));
    },
    recordCoordinates: function recordCoordinates() {
      var lat = this.record.from_point.coordinates[1];
      var long = this.record.from_point.coordinates[0];
      return Math.abs(lat).toFixed(2) + '\xB0' + (lat >= 0 ? 'N' : 'S') + ',       ' + Math.abs(long).toFixed(2) + '\xB0' + (long >= 0 ? 'E' : 'W');
    },
    cutCacheUpdateLock: function cutCacheUpdateLock() {
      var cutProcess = this.record.process_statuses.find(function (item) {
        return item.process === 'cut';
      });
      return cutProcess && cutProcess.status === 'done' && this.cutProcessing;
    }
  }),
  methods: {
    getRecordPlayerOptions: __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* getRecordPlayerOptions */],
    close: function close() {
      this.$emit('close');
    },
    keypressed: function keypressed(event) {
      var esc = 27;
      if (event.keyCode === esc) {
        this.close();
      }
    },
    updateSimilarRecords: function updateSimilarRecords() {
      var _this2 = this;

      if (!this.markerId) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_4__repositories_RecordRepository_js__["a" /* default */].fetchSimilarRecords(this.markerId, this.record.id).then(function (records) {
        _this2.similarRecords = records;
      });
    },
    clickedRecordHandler: function clickedRecordHandler(record) {
      this.$emit('clicked-similar-record', record);
    },
    sendVideoRequestPush: function sendVideoRequestPush() {
      var _this3 = this;

      this.videoRequestLoading = true;
      __WEBPACK_IMPORTED_MODULE_4__repositories_RecordRepository_js__["a" /* default */].requestMoreVideos(this.record.id, this.videoRequestText).then(function () {
        _this3.videoRequestLoading = false;
        _this3.$store.commit('snackbar/show', {
          message: 'Message have been sent',
          color: 'green',
          timeout: 3000
        });
      }).catch(function (err) {
        _this3.videoRequestLoading = false;
        _this3.$store.commit('snackbar/show', {
          message: err.message,
          color: 'red',
          timeout: 3000
        });
      });
    },
    showRecordCut: function showRecordCut() {
      this.$refs.playerComponent.player.pause();
      this.recordCutEnabled = true;
    },
    showCutSpinner: function showCutSpinner() {
      var _this4 = this;

      this.cutProcessing = true;
      this.notifyWhenCutFinished();
      setTimeout(function () {
        _this4.recordCutEnabled = false;
      }, 3000);
      this.$emit('cut-started', this.record);
      this.close();
    },
    checkCutState: function checkCutState() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_4__repositories_RecordRepository_js__["a" /* default */].getRecordCutState(this.record.id).then(function (resp) {
        if (resp.state === 'busy') {
          _this5.cutProcessing = true;
          _this5.notifyWhenCutFinished();
        }
      });
    },
    notifyWhenCutFinished: function notifyWhenCutFinished() {
      var _this6 = this;

      this.cutNotifyInterval = setInterval(function () {
        __WEBPACK_IMPORTED_MODULE_4__repositories_RecordRepository_js__["a" /* default */].getRecordCutState(_this6.record.id).then(function (resp) {
          if (resp.state === 'free') {
            _this6.cutProcessing = false;
            clearInterval(_this6.cutNotifyInterval);
          }
        });
      }, 5000);
    },
    toggleEditTagsMode: function toggleEditTagsMode() {
      if (!this.editTagsActive) {
        this.setTagsFromRecord();
        this.editTagsActive = true;
      } else {
        this.editTagsActive = false;
      }
    },
    setTagsFromRecord: function setTagsFromRecord() {
      this.editableTags = this.record.mltags.map(function (tag) {
        return { name: tag.category };
      }).sort(function (t1, t2) {
        return t1.name > t2.name ? 1 : -1;
      });
    },
    addTag: function addTag(tag) {
      tag = { name: tag.charAt(0).toUpperCase() + tag.slice(1) };
      this.tagsSelectOptions.push(tag);
      this.editableTags.push(tag);
    },
    saveTags: function saveTags() {
      var _this7 = this;

      var tags = this.editableTags.map(function (tag) {
        return tag.name;
      });
      this.editTagsActive = false;
      __WEBPACK_IMPORTED_MODULE_4__repositories_RecordRepository_js__["a" /* default */].updateRecordTags(this.record.id, tags).then(function (savedTags) {
        _this7.$store.commit('snackbar/show', {
          message: 'Tags updated',
          color: 'green',
          timeout: 3000
        });
        _this7.$set(_this7.record, 'mltags', savedTags);
      }).catch(function (err) {
        _this7.$store.commit('snackbar/show', {
          message: err.message,
          color: 'error',
          timeout: 5000
        });
      });
    }
  } });

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Thumbnail_vue__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Thumbnail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Thumbnail_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MLTags_vue__ = __webpack_require__(993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MLTags_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__MLTags_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generic_DatetimeAgo_vue__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generic_DatetimeAgo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__generic_DatetimeAgo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__repositories_RecordRepository__ = __webpack_require__(33);









var FileSaver = __webpack_require__(101);

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Thumbnail: __WEBPACK_IMPORTED_MODULE_3__Thumbnail_vue___default.a,
    TimeAgo: __WEBPACK_IMPORTED_MODULE_5__generic_DatetimeAgo_vue___default.a,
    MLTags: __WEBPACK_IMPORTED_MODULE_4__MLTags_vue___default.a
  },
  data: function data() {
    return {
      tooltip: '',
      digitekaLink: '',
      digitekaDirectLink: '',
      selected_group: 0
    };
  },

  props: ['record', 'readOnly', 'selectedRecords', 'showSelectIndex', 'isChoosingMode'],
  mounted: function mounted() {
    var _this = this;

    this.record.selected = false;
    if (this.record.mldata.approved) {
      this.getDigitekaLink(this.record).then(function (link) {
        return _this.setDigitekaLinks(link);
      });
    }
    this.selected_group = this.record.groups[0].id;
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["d" /* mapActions */])(['getDigitekaLink', 'buildDigitekaDirectLink']), {
    clickedRecordHandler: function clickedRecordHandler(record) {
      this.$emit('clicked-record-item', record);
    },
    clickedRecordCardHandler: function clickedRecordCardHandler(record) {
      if (this.isChoosingMode === true) {
        this.$emit('clicked-record-item', record);
      }
    },
    markRecord: function markRecord(record, relevance) {
      this.$emit('mark-record-relevance-item', record, relevance);
    },
    deleteRecord: function deleteRecord() {
      this.$emit('delete-record-item', this.record);
    },
    restoreRecord: function restoreRecord() {
      this.$emit('restore-record-item', this.record);
    },
    editRecordNotes: function editRecordNotes(record) {
      this.$emit('edit-record-notes', record);
    },
    setRecoverTooltip: function setRecoverTooltip() {
      if (this.record.mldata.deleted_at) this.tooltip = 'click here to recover';
    },
    downloadRecord: function downloadRecord(record) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res, blob;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetch(record.play_link);

              case 2:
                res = _context.sent;
                _context.next = 5;
                return res.blob();

              case 5:
                blob = _context.sent;

                FileSaver.saveAs(blob, record.verbose_filename);

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    setDigitekaLinks: function setDigitekaLinks(link) {
      var _this3 = this;

      this.digitekaLink = link;
      this.buildDigitekaDirectLink(this.record).then(function (dlink) {
        _this3.digitekaDirectLink = dlink;
      });
    },
    copyDigitekaLink: function copyDigitekaLink() {
      this.$refs.copyText.value = this.digitekaLink;
      this.$refs.copyText.select();
      console.log('link', this.digitekaLink);
      document.execCommand('copy');
      this.$store.commit('snackbar/show', {
        message: 'Link copied to clipboard',
        timeout: 2000,
        color: 'green'
      });
    },
    changeEdition: function changeEdition(recordId, groupId) {
      __WEBPACK_IMPORTED_MODULE_7__repositories_RecordRepository__["a" /* default */].patchRecordEdition(recordId, { usergroup: groupId });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapGetters */])(['isLmrConsumer']), {
    selected: function selected() {
      var _this4 = this;

      if (Array.isArray(this.selectedRecords)) {
        return this.selectedRecords.some(function (rec) {
          return rec.id === _this4.record.id;
        });
      }
      return false;
    },
    selectIndex: function selectIndex() {
      var _this5 = this;

      if (this.selected) {
        return this.selectedRecords.findIndex(function (record) {
          return record.id === _this5.record.id;
        }) + 1;
      }
    },
    hideDeleteIcon: function hideDeleteIcon() {
      return this.readOnly || this.record.mldata.approved;
    },
    processStatusesSorted: function processStatusesSorted() {
      if (this.record.process_statuses.length === 0) return [];
      var processOrdering = ['cut', 'intro', 'ftpupload'];
      return this.record.process_statuses.sort(function (a, b) {
        var aIndex = processOrdering.indexOf(a.process);
        var bIndex = processOrdering.indexOf(b.process);
        if (aIndex < bIndex) return -1;else if (aIndex > bIndex) return 1;else return 0;
      });
    },
    getProcessList: function getProcessList() {
      var processList = this.record.process_statuses.map(function (a) {
        return a.process;
      });
      return processList;
    }
  }),
  watch: {
    'record.digiteka_id': function recordDigiteka_id(newVal, oldVal) {
      var _this6 = this;

      if (newVal) {
        this.getDigitekaLink(this.record).then(function (link) {
          return _this6.setDigitekaLinks(link);
        });
      }
    }
  }
});

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_video_js__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_video_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_video_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_debounce__);




__webpack_require__(277);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RecordPlayer',
  props: ['options', 'sizeStyles'],
  data: function data() {
    return {
      playerReady: false,
      record: {
        url: null
      },
      playerElement: 'videojs-' + this._uid,
      playerOptions: {
        'controls': true,
        'autoplay': false,
        'preload': false
      }
    };
  },

  watch: {
    'options': function options(newValue, oldValue) {
      if (newValue && oldValue && newValue.url !== oldValue.url) {
        this.player.pause();
        this.play(newValue);
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.resizeHandler = __WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default()(this.adjustRatioEvent, 300);
    window.addEventListener('resize', this.resizeHandler);
    this.setupPlayer().then(function () {
      _this2.play(_this2.options);
    });
  },
  methods: {
    play: function play(record) {
      this.record = record;
      if (this.record.height && this.record.width) {
        this.adjustRatio(this.record.width / this.record.height);
      }
      this.playerReady = false;
      this.$nextTick(function () {
        var _this3 = this;

        this.player.on('loadedmetadata', function () {
          _this3.adjustRatio();
          _this3.playerReady = true;
        });
        this.player.pause();
        this.player.loadingSpinner.show();
        this.player.src(record.url);
        this.player.poster(record.thumbnail);
        if (record.sprite) {
          this.setUpThumbnailPreviews(this.player, record.sprite);
        } else {
          this.clearThumbnailPreviews();
        }
        this.player.load();
        this.player.play();
      });
    },

    setupPlayer: function setupPlayer() {
      var _this4 = this;

      if (this.playerSetUp) {
        return;
      }
      var _this = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_1_video_js___default()(_this4.playerElement, _this4.playerOptions, function () {
          _this.player = this;
          _this.playerSetUp = true;
          _this.player.thumbnails();
          resolve();
        });
      });
    },
    clearThumbnailPreviews: function clearThumbnailPreviews() {
      this.player.thumbnails().updateState({});
    },
    setUpThumbnailPreviews: function setUpThumbnailPreviews(player, sprite) {
      var frames = Math.floor(sprite.width / sprite.h_interval);
      var options = {
        0: {
          src: sprite.url,
          style: {
            height: sprite.height + 'px',
            width: sprite.width + 'px',
            clip: 'rect(0, ' + sprite.h_interval + 'px, ' + sprite.height + 'px, 0)',
            left: '-' + sprite.h_interval / 2 + 'px'
          }
        }
      };
      for (var i = 1; i < frames; i++) {
        options[i] = {
          style: {
            clip: 'rect(0, ' + sprite.h_interval * (i + 1) + 'px, ' + sprite.height + 'px, ' + sprite.h_interval * i + 'px)',
            left: '-' + (sprite.h_interval / 2 + sprite.h_interval * i) + 'px'
          }
        };
      }
      player.thumbnails().updateState(options);
    },
    adjustRatioEvent: function adjustRatioEvent(event) {
      this.adjustRatio();
    },
    adjustRatio: function adjustRatio(ratio) {
      if (this.playerSetUp) {
        if (!ratio) {
          ratio = this.player.videoWidth() / this.player.videoHeight();
        }
        var el = document.getElementById(this.playerElement);
        if (ratio && el) {
          if (this.sizeStyles) {
            el.style.width = this.sizeStyles.width;
            el.style.height = this.sizeStyles.height;
          } else {
            var width = 640;
            var height = Math.floor(640 / ratio);
            if (width < height) {
              height = 640;
              width = Math.floor(640 * ratio);
            }
            el.style.width = width + 'px';
            el.style.height = height + 'px';
            if (this.$root.$children[0].$data.clientId === 'digiteka') {
              var _width = Math.floor(this.$parent.$parent.$parent.$refs.testRef.scrollWidth);
              console.log(window.innerWidth, this.$parent.$parent.$parent.$refs.testRef.scrollWidth, '--------------');
              var _height = Math.floor(_width / ratio);
              if (_width < _height) {
                _height = window.innerHeight * 0.8;
                _width = Math.floor(_height * ratio);
              }
              el.style.width = _width + 'px';
              el.style.height = _height + 'px';
            }
          }
        }
      }
    },
    seekedEvent: function seekedEvent(event) {
      this.$emit('seeked', event);
    },
    timeUpdateEvent: function timeUpdateEvent(event) {
      this.$emit('timeupdate', event);
    },
    playingEvent: function playingEvent(event) {
      this.$emit('playing');
    },
    pauseEvent: function pauseEvent(event) {
      this.$emit('pause');
    },
    endedEvent: function endedEvent(event) {
      this.$emit('ended');
    }
  }, beforeDestroy: function beforeDestroy() {
    this.player.pause();
    this.player.dispose();
    window.removeEventListener('resize', this.resizeHandler);
  }
});

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RecordItem_vue__ = __webpack_require__(997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RecordItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__RecordItem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__generic_ConfirmModal2_vue__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__generic_ConfirmModal2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__generic_ConfirmModal2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__generic_Modal_vue__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__generic_Modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__generic_Modal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_debounce__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__repositories_RecordRepository_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_events__ = __webpack_require__(9);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ConfirmModal2: __WEBPACK_IMPORTED_MODULE_1__generic_ConfirmModal2_vue___default.a,
    RecordItem: __WEBPACK_IMPORTED_MODULE_0__RecordItem_vue___default.a,
    Modal: __WEBPACK_IMPORTED_MODULE_2__generic_Modal_vue___default.a
  },
  props: ['records', 'marker', 'records_type', 'readOnly', 'selectedRecords', 'showSelectIndex', 'isChoosingMode'],
  data: function data() {
    return {
      recordPendingDeletion: null,

      recordNotesBeingEdited: null,
      recordNotesSaveInProgress: false,
      recordCommentEdited: '',
      recordTitleEdited: '',
      recordDescriptionEdited: '',
      recordConsumerName: '',
      recordHasComment: false,
      recordHasDescriptionField: false
    };
  },
  mounted: function mounted() {
    this.recordNotesUpdateHandler = __WEBPACK_IMPORTED_MODULE_3_lodash_debounce___default()(this.saveRecordNotes, 1000);
  },

  methods: {
    clickedRecordHandler: function clickedRecordHandler(record) {
      this.$emit('clicked-record', record);
    },
    markRecord: function markRecord(record, relevance) {
      this.$emit('mark-record-relevance', record, relevance, record.record_type);
    },
    deleteRecord: function deleteRecord(record) {
      this.recordPendingDeletion = record;
    },
    restoreRecord: function restoreRecord(record) {
      this.$emit('restore-record', record, record.record_type);
    },
    confirmDeleteRecord: function confirmDeleteRecord() {
      this.$emit('delete-record', this.recordPendingDeletion, this.recordPendingDeletion.record_type);
      this.recordPendingDeletion = null;
    },
    editRecordNotes: function editRecordNotes(record) {
      this.recordConsumerName = record.consumer;
      this.recordNotesBeingEdited = record;
      if (record.comment && !record.title) {
        this.recordHasComment = true;
      } else if (record.comment && record.title && !record.description) {
        this.recordHasComment = true;
      }
      this.recordHasDescriptionField = record.has_description_field;
      if (this.recordHasComment && this.recordHasDescriptionField) {
        this.recordHasDescriptionField = false;
      }
      this.recordCommentEdited = record.comment;
      this.recordTitleEdited = record.title;
      this.recordDescriptionEdited = record.description;
    },
    saveRecordNotes: function saveRecordNotes(record, e) {
      var _this = this;

      this.recordNotesSaveInProgress = true;
      __WEBPACK_IMPORTED_MODULE_4__repositories_RecordRepository_js__["a" /* default */].patchRecordNotes(this.markerId, record, e.target.value).then(function () {
        _this.recordNotesSaveInProgress = false;
      }, function (error) {
        __WEBPACK_IMPORTED_MODULE_5__services_events__["a" /* default */].emit('error', error, '', { modal: false });
        _this.recordNotesSaveInProgress = false;
      });
    },
    saveRecordComment: function saveRecordComment() {
      var _this2 = this;

      this.recordNotesSaveInProgress = true;
      var newTitle = this.recordTitleEdited;
      var newComment = this.recordCommentEdited;
      var newDescription = this.recordDescriptionEdited;
      var record = this.recordNotesBeingEdited;
      __WEBPACK_IMPORTED_MODULE_4__repositories_RecordRepository_js__["a" /* default */].patchRecordComment(this.recordNotesBeingEdited, {
        comment: newComment,
        title: newTitle,
        description: newDescription
      }).then(function () {
        _this2.recordNotesSaveInProgress = false;
        _this2.recordNotesBeingEdited = null;
        record.comment = newComment;
        record.title = newTitle;
        record.description = newDescription;
      }, function (error) {
        __WEBPACK_IMPORTED_MODULE_5__services_events__["a" /* default */].emit('error', error, '', { modal: false });
        _this2.recordNotesSaveInProgress = false;
      });
    },
    closeCommentModal: function closeCommentModal() {
      if (!this.recordNotesSaveInProgress) this.recordNotesBeingEdited = null;
    }
  },
  computed: {
    markerId: function markerId() {
      return this.marker && this.marker.id;
    },
    disableCommentModalBtn: function disableCommentModalBtn() {
      if (this.recordHasDescriptionField) {
        if (this.recordNotesBeingEdited) return !this.recordTitleEdited || !this.recordDescriptionEdited;else return false;
      } else {
        if (this.recordNotesBeingEdited) return !this.recordTitleEdited;else return false;
      }
    }
  }
});

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: String
  },
  data: function data() {
    return {
      val: ''
    };
  },

  methods: {
    changeValue: function changeValue() {
      this.$emit('input', this.val);
      this.$emit('change', this.val);
    }
  }
});

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      elementId: 'thumbnail-' + this._uid,
      spriteOffset: null,
      sprite: undefined
    };
  },

  props: ['media', 'default'],
  created: function created() {
    var _this = this;

    var sprite = this.media.find(function (el) {
      return el.name === 'thumbspritehoriz';
    });
    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.sprite) !== undefined) {
      var img = new Image();
      img.onload = function (event) {
        return _this.setSpriteSize(event, sprite);
      };
      img.src = sprite.url;
    }
  },

  methods: {
    setSpriteSize: function setSpriteSize(event, sprite) {
      sprite.width = event.target.naturalWidth;
      sprite.height = event.target.naturalHeight;
      this.sprite = this.adjustSpriteSize(sprite, 150);
    },
    setSprite: function setSprite(event) {
      if (typeof this.sprite === 'undefined') {
        return;
      }

      var rect = document.getElementById(this.elementId).getBoundingClientRect();
      var xoffset = event.clientX - rect.left;
      var percent = xoffset / rect.width;
      var spriteOffset = Math.floor(this.sprite.width * percent / this.sprite.sprite_interval_h) * this.sprite.sprite_interval_h;
      this.spriteOffset = -spriteOffset;
    },
    clearSprite: function clearSprite() {
      this.spriteOffset = null;
    },
    adjustSpriteSize: function adjustSpriteSize(sprite, minHeight) {
      if (sprite.height < minHeight) {
        var ratio = minHeight / sprite.height;
        sprite.sprite_interval_h = Math.floor(sprite.sprite_interval_h * ratio);
        sprite.width = Math.floor(sprite.width * ratio);
        sprite.height = minHeight;
      }
      return sprite;
    }
  },
  computed: {
    defaultStyling: function defaultStyling() {
      return {
        backgroundImage: 'url(' + this.default + ')'
      };
    },
    baseThumbsStyling: function baseThumbsStyling() {
      if (typeof this.sprite === 'undefined') {
        return {};
      } else {
        return {
          backgroundImage: 'url(' + this.sprite.url + ')',
          backgroundSize: this.sprite.width + 'px ' + this.sprite.height + 'px'
        };
      }
    },
    activeThumbsStyling: function activeThumbsStyling() {
      if (this.spriteOffset === null) {
        return {};
      } else {
        return {
          backgroundPosition: this.spriteOffset + 'px'
        };
      }
    }
  }
});

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    show: {
      type: Boolean,
      required: true
    }
  },
  mounted: function mounted() {
    window.addEventListener('keyup', this.keypressed);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('keyup', this.keypressed);
  },
  methods: {
    keypressed: function keypressed(event) {
      var esc = 27;
      if (event.keyCode === esc) {
        this.hide();
      }
    },
    hide: function hide() {
      this.$emit('hide');
    }
  }
});

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['start', 'end'],
  data: function data() {
    return {
      now: Date.now()
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.interval = setInterval(function () {
      _this.now = Date.now();
    }, 1000);
  },

  methods: {
    readableDuration: function readableDuration(t, locale) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default.a.duration(t).locale(locale).humanize();
    }
  },
  computed: {
    startToNow: function startToNow() {
      return this.start - this.now;
    },
    endToNow: function endToNow() {
      return this.end - this.now;
    },
    locale: function locale() {
      return this.$i18n.locale;
    },
    duration: function duration() {
      return this.end - this.start;
    }
  },
  destroyed: function destroyed() {
    clearInterval(this.interval);
  }
});

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_dates__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_flatpickr_component__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_flatpickr_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_flatpickr_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_flatpickr_dist_flatpickr_css__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_flatpickr_dist_flatpickr_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_flatpickr_dist_flatpickr_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_flatpickr_dist_l10n_fr__ = __webpack_require__(937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_flatpickr_dist_l10n_fr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_flatpickr_dist_l10n_fr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_flatpickr_dist_l10n_nl__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_flatpickr_dist_l10n_nl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_flatpickr_dist_l10n_nl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_flatpickr_dist_l10n_default__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_flatpickr_dist_l10n_default___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_flatpickr_dist_l10n_default__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pencilpix_vue2_clock_picker__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pencilpix_vue2_clock_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pencilpix_vue2_clock_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pencilpix_vue2_clock_picker_dist_vue2_clock_picker_min_css__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pencilpix_vue2_clock_picker_dist_vue2_clock_picker_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__pencilpix_vue2_clock_picker_dist_vue2_clock_picker_min_css__);












var calendarLocales = {
  fr: __WEBPACK_IMPORTED_MODULE_4_flatpickr_dist_l10n_fr__["French"],
  nl: __WEBPACK_IMPORTED_MODULE_5_flatpickr_dist_l10n_nl__["Dutch"],
  en: __WEBPACK_IMPORTED_MODULE_6_flatpickr_dist_l10n_default__["english"]
};

var dateFormats = {
  fr: 'd-m-Y',
  nl: 'd-m-Y',
  en: 'Y-m-d'
};

var momentFormats = {
  fr: 'DD-MM-YYYY',
  nl: 'DD-MM-YYYY',
  en: 'YYYY-MM-DD'
};

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['value', 'attrs'],
  data: function data() {
    return {
      hackyReload: false,
      calendarConfig: {
        wrap: true,
        dateFormat: dateFormats[this.$i18n.locale],
        locale: calendarLocales[this.$i18n.locale]
      }
    };
  },
  components: {
    flatPickr: __WEBPACK_IMPORTED_MODULE_1_vue_flatpickr_component___default.a,
    VueClockPicker: __WEBPACK_IMPORTED_MODULE_7__pencilpix_vue2_clock_picker___default.a
  },
  methods: {
    inputTimeChangeHandler: function inputTimeChangeHandler(event) {
      this.setTimeValue(event.target.value);
    },

    setTimeValue: function setTimeValue(input) {
      var rex = /(\d{2}):(\d{2})/;
      if (rex.test(input)) {
        var matches = rex.exec(input);
        var clone = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.value);
        clone.hours(matches[1]);
        clone.minutes(matches[2]);
        this.$emit('input', clone);
      }
    },
    updateDate: function updateDate(pickedDateString) {
      var parsed = __WEBPACK_IMPORTED_MODULE_2_moment___default()(pickedDateString, momentFormats[this.$i18n.locale]);
      if (!parsed.isValid()) {
        parsed = __WEBPACK_IMPORTED_MODULE_2_moment___default()();
      }
      parsed.minutes(this.value.minutes());
      parsed.hours(this.value.hours());
      this.$emit('input', parsed);
    },
    showPicker: function showPicker(event) {
      this.$refs.clockpicker.open();
    },
    localeChangedHandler: function localeChangedHandler(l) {
      this.value.locale(l);
      this.calendarConfig.locale = calendarLocales[l];
      this.calendarConfig.dateFormat = dateFormats[l];

      this.hackyReload = true;
      this.$nextTick(function () {
        this.hackyReload = false;
      });
      return true;
    }
  },
  mounted: function mounted() {
    this.setupTimePicker();
    __WEBPACK_IMPORTED_MODULE_0__services_dates__["a" /* default */].bus.$on('locale-changed', this.localeChangedHandler);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_0__services_dates__["a" /* default */].bus.$off('locale-changed', this.localeChangedHandler);
  },
  computed: {
    valueTime: function valueTime() {
      return this.value.format('HH:mm');
    },
    valueDate: function valueDate() {
      return this.value.format(momentFormats[this.$i18n.locale]);
    }
  }
});

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['value', 'locales', 'attrs', 'currentLocale'],
  data: function data() {
    return {
      id: this._uid
    };
  },
  watch: {
    value: {
      handler: function handler() {
        this.validate();
      },
      deep: true
    },
    currentLocale: function currentLocale(l, previousLocale) {
      var _this = this;

      this.$nextTick(function () {
        _this.validate();
      });
    }
  },
  methods: {
    setValue: function setValue(lang, event) {
      var copy = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.value);
      copy[lang] = event.target.value;
      this.$emit('input', copy);
    },
    validate: function validate() {
      var _this2 = this;

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.locales), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var l = _step.value;

          this.clearCustomValidity(this.getElementForLocale(l));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (this.attrs.required) {
        if (!__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.value).some(function (l) {
          return _this2.value[l];
        })) {
          this.addCustomValidity(this.$t('language_input_required'));
        }
      }
    },
    clearCustomValidity: function clearCustomValidity(el) {
      if (el.validity.customError) {
        el.setCustomValidity('');
      }
    },
    addCustomValidity: function addCustomValidity(message) {
      this.getActiveElement().setCustomValidity(message);
    },
    getElementForLocale: function getElementForLocale(l) {
      return document.getElementById('input-locale-' + this.id + '-' + l);
    },
    getActiveElement: function getActiveElement() {
      return this.getElementForLocale(this.currentLocale);
    }
  }
});

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_maps_PlacesApi_js__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_debounce__);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      inputBuffer: '',
      placesAPIList: '',
      selectedPlace: 0,
      showDropdown: false,
      inFocus: false
    };
  },
  props: ['attrs', 'position'],
  methods: {
    input: function input(event) {
      this.inputBuffer = event.target.value;
      if (this.inputBuffer) {
        this.processInput();
      }
    },
    processInput: __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default()(function () {
      var _this = this;

      if (this.inputBuffer) {
        __WEBPACK_IMPORTED_MODULE_0__services_maps_PlacesApi_js__["a" /* default */].autocomplete(this.inputBuffer).then(function (result) {
          _this.placesAPIList = result;
          _this.$nextTick(function () {
            this.showDropdown = typeof this.places !== 'undefined' && this.places.length > 0;
          });
        });
      }
    }, 100),
    fetchPlace: function fetchPlace(place) {
      var _this2 = this;

      if (place) {
        __WEBPACK_IMPORTED_MODULE_0__services_maps_PlacesApi_js__["a" /* default */].details(place.place_id).then(function (result) {
          _this2.$emit('place-selected', {
            lat: result.geometry.location.lat,
            long: result.geometry.location.lng,
            address: result.formatted_address
          });
          _this2.inputBuffer = '';
          _this2.triggerBlur();
        });
      }
    },
    setSelected: function setSelected(i) {
      this.selectedPlace = i;
    },
    up: function up() {
      this.selectedPlace = this.selectedPlace === 0 ? this.selectedPlace : this.selectedPlace - 1;
    },
    down: function down() {
      this.selectedPlace = this.selectedPlace === this.places.length - 1 ? this.selectedPlace : this.selectedPlace + 1;
      if (this.showDropdown === false) {
        this.processInput();
      }
    },
    enter: function enter() {
      this.fetchPlace(this.places[this.selectedPlace]);
    },
    focus: function focus() {
      this.inFocus = true;
      this.processInput();
    },
    triggerBlur: function triggerBlur() {
      var el = document.getElementById(this.attrs.id);
      el.blur();
    },
    blur: function blur() {
      this.inFocus = false;
      this.showDropdown = false;
      this.selectedPlace = 0;
    },

    formatCoordinates: function formatCoordinates(lat, long) {
      return this.$t('map.coordinates') + ' ' + Math.abs(lat).toFixed(2) + '\xB0' + (lat >= 0 ? 'N' : 'S') + ', ' + Math.abs(long).toFixed(2) + '\xB0' + (long >= 0 ? 'E' : 'W');
    }
  },
  computed: {
    inputValue: function inputValue() {
      if (this.inFocus) {
        return this.inputBuffer;
      } else {
        if (this.position) {
          if (this.position.address) {
            return this.position.address;
          } else if (this.position.lat !== 0 && this.position.long !== 0) {
            return this.formatCoordinates(this.position.lat, this.position.long);
          }
        }
      }

      return '';
    },
    places: function places() {
      if (this.placesAPIList.length) {
        return this.placesAPIList.filter(function (p) {
          return p.place_id !== undefined;
        });
      }
    }
  }
});

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['value'],
  methods: {
    setValueTo: function setValueTo(newValue) {
      this.$emit('input', newValue);
    }
  }
});

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_leaflet__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_maps_circleEditor_js__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InputPlaces_vue__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InputPlaces_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__InputPlaces_vue__);







var mapboxUrl = 'https://api.mapbox.com/styles/v1/philippe-look/cisadedxf003i2zo3t5ruhi23/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoicGhpbGlwcGUtbG9vayIsImEiOiJjaXNhZDl3aHQwMDJjMnVwNWtibDR2azBvIn0.rT49BllHbiANRj9yQL0ozQ';

function addMapboxLayerTo(mapHandle) {
  __WEBPACK_IMPORTED_MODULE_0_leaflet___default.a.tileLayer(mapboxUrl).addTo(mapHandle);
}

var circleOptions = {
  stroke: true,
  color: '#ff2d55',
  weight: 1,
  dashArray: '6, 6',
  opacity: 1,
  fill: true,
  fillColor: '#ff2d55',
  fillOpacity: 0.05,
  clickable: false
};

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['position', 'attrs', 'maxRadius'],
  data: function data() {
    return {
      showHelp: true
    };
  },
  components: {
    InputPlaces: __WEBPACK_IMPORTED_MODULE_3__InputPlaces_vue___default.a
  },
  mounted: function mounted() {
    this.address = this.position.address;
    this.setupMapEditor();
  },
  methods: {
    setupMapEditor: function setupMapEditor() {
      var mapEditor = __WEBPACK_IMPORTED_MODULE_0_leaflet___default.a.map('map-editor').setView([this.position.lat, this.position.long], 13);
      addMapboxLayerTo(mapEditor);

      var circle = new __WEBPACK_IMPORTED_MODULE_1__libs_maps_circleEditor_js__["a" /* default */]([this.position.lat, this.position.long], this.position.radius, circleOptions);
      mapEditor.addLayer(circle);

      if (this.position.lat === 0 && this.position.long === 0) {
        mapEditor.fitWorld().zoomIn();
      } else {
        mapEditor.fitBounds(circle.getBounds(), { padding: [50, 50] });
      }

      mapEditor.doubleClickZoom.disable();
      circle.on('centerchange', __WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default()(this.centerChanged, 200));
      circle.on('radiuschange', __WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default()(this.radiusChanged, 200));
      mapEditor.on('dblclick', this.doubleClickHandler);
      mapEditor.on('viewreset', this.viewResetHandler);

      this.mapEditor = {};
      this.mapEditor.lmap = mapEditor;
      this.mapEditor.circle = circle;
    },
    centerChanged: function centerChanged() {
      this.$emit('position-changed', this.getPosition());
    },
    radiusChanged: function radiusChanged() {
      var radius = this.maxRadiusFilter(this.mapEditor.circle.getRadius());
      this.mapEditor.circle.updateRadius(radius);
      this.$emit('position-changed', this.getPosition());
    },
    doubleClickHandler: function doubleClickHandler(mouseEvent) {
      this.address = '';
      this.moveCenter(mouseEvent.latlng.lat, mouseEvent.latlng.lng);
    },
    viewResetHandler: function viewResetHandler() {
      var _this = this;

      setTimeout(function () {
        _this.mapEditor.circle.detectOverlappingMakers();
        _this.mapEditor.circle.orientGizmo();
      }, 100);
    },
    moveCenter: function moveCenter(lat, long) {
      this.mapEditor.circle.setLatLng([lat, long]);
      this.mapEditor.circle.resetMarkers();
      this.mapEditor.circle.fire('centerchange');
    },
    getPosition: function getPosition() {
      var radius = this.mapEditor.circle.getRadius();
      var latlng = this.mapEditor.circle.getLatLng().wrap();
      return { lat: latlng.lat, long: latlng.lng, radius: radius, address: this.address };
    },
    setPositionFromAddress: function setPositionFromAddress(position) {
      this.address = position.address;
      this.moveCenter(position.lat, position.long);
      this.mapEditor.lmap.fitBounds(this.mapEditor.circle.getBounds(), { padding: [50, 50] });
    },
    maxRadiusFilter: function maxRadiusFilter(newRadius) {
      var radius = Math.round(newRadius);
      if (radius > this.maxRadius) {
        radius = this.maxRadius;
      }
      return radius;
    }
  }
});

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_leaflet__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_debounce__);





var mapboxUrl = 'https://api.mapbox.com/styles/v1/philippe-look/cisadedxf003i2zo3t5ruhi23/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoicGhpbGlwcGUtbG9vayIsImEiOiJjaXNhZDl3aHQwMDJjMnVwNWtibDR2azBvIn0.rT49BllHbiANRj9yQL0ozQ';

var circleOptions = {
  stroke: true,
  color: '#ff2d55',
  weight: 2,
  dashArray: '6, 6',
  opacity: 1,
  fill: true,
  fillColor: '#ff2d55',
  fillOpacity: 0.1,
  clickable: false
};

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['position'],
  data: function data() {
    return {
      id: this._uid
    };
  },
  mounted: function mounted() {
    this.mapUpdateHandler = __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default()(this.updateMapPreview, 200);
    this.setupMapPreview(this.position.lat, this.position.long, this.position.radius);
  },
  watch: {
    position: function position() {
      this.mapUpdateHandler();
    }
  },
  methods: {
    setupMapPreview: function setupMapPreview(lat, long, radius) {
      var mapPreview = __WEBPACK_IMPORTED_MODULE_0_leaflet___default.a.map('map-preview-' + this.id, { zoomControl: false, attributionControl: false }).setView([lat, long], 13);
      addMapboxLayerTo(mapPreview);
      disableMapControls(mapPreview);
      var circle = __WEBPACK_IMPORTED_MODULE_0_leaflet___default.a.circle([lat, long], radius, circleOptions).addTo(mapPreview);
      this.mapPreview = {};
      this.mapPreview.leaflet = mapPreview;
      this.mapPreview.circle = circle;
      this.mapUpdateHandler();
    },
    updateMapPreview: function updateMapPreview() {
      this.mapPreview.circle.setLatLng([this.position.lat, this.position.long]);
      this.mapPreview.circle.setRadius(this.position.radius);
      if (this.position.initial) {
        this.mapPreview.circle.setStyle({ opacity: 0 });
        this.mapPreview.leaflet.fitWorld().zoomIn();
      } else {
        this.mapPreview.circle.setStyle({ opacity: 1 });
        this.mapPreview.leaflet.fitBounds(this.mapPreview.circle.getBounds(), { padding: [50, 50] });
      }
    }
  }
});

function disableMapControls(mapHandle) {
  mapHandle._handlers.forEach(function (handler) {
    handler.disable();
  });
}

function addMapboxLayerTo(mapHandle) {
  __WEBPACK_IMPORTED_MODULE_0_leaflet___default.a.tileLayer(mapboxUrl).addTo(mapHandle);
}

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      'showDropdown': false
    };
  },

  props: ['brands', 'value'],
  computed: {
    selectedBrand: function selectedBrand() {
      var _this = this;

      var result = this.brands.find(function (brand) {
        return brand.id === _this.value;
      });
      if (typeof result === 'undefined' && this.brands.length) {
        return this.brands[0];
      } else {
        return result;
      }
    }
  },
  mounted: function mounted() {
    document.body.addEventListener('click', this.hideDropdown);
  },
  beforeDestroy: function beforeDestroy() {
    document.body.removeEventListener('click', this.hideDropdown);
  },

  methods: {
    selectBrand: function selectBrand(brand) {
      this.showDropdown = false;
      this.$emit('input', brand.id);
    },
    hideDropdown: function hideDropdown() {
      event.stopPropagation();
      this.showDropdown = false;
    }
  }
});

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['groups', 'value'],
  data: function data() {
    return {
      showSelection: false,
      showCategory: null,
      tooltipPosition: {
        x: 0, y: 0
      }
    };
  },
  mounted: function mounted() {
    document.body.addEventListener('click', this.hide);
  },
  beforeDestroy: function beforeDestroy() {
    document.body.removeEventListener('click', this.hide);
  },

  methods: {
    hide: function hide() {
      this.showSelection = false;
    },
    isSelected: function isSelected(category, group) {
      return this.value && this.value.find(function (cat) {
        return category.slug === cat.slug && cat.groups.find(function (g) {
          return g.slug === group.slug;
        });
      });
    },
    toggleShowSelection: function toggleShowSelection(event) {
      this.tooltipPosition = { x: event.layerX, y: event.layerY };
      this.showSelection = !this.showSelection;
    },
    toggle: function toggle(clickedCategory, clickedGroup) {
      var newValue = [];
      var removed = false;

      var _loop = function _loop(cat) {
        newValue.push({
          name: cat.name,
          slug: cat.slug,
          groups: cat.groups.reduce(function (result, grp) {
            if (cat.slug !== clickedCategory.slug || grp.slug !== clickedGroup.slug) {
              result.push(grp);
            } else {
              removed = true;
            }
            return result;
          }, [])
        });
      };

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.value), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var cat = _step.value;

          _loop(cat);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (!removed) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.groups), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var cat = _step2.value;

            if (cat.slug === clickedCategory.slug) {
              var newCat = newValue.find(function (c) {
                return c.slug === clickedCategory.slug;
              });
              if (!newCat) {
                newCat = {
                  name: cat.name,
                  slug: cat.slug,
                  groups: []
                };
                newValue.push(newCat);
              }
              newCat.groups.push(clickedGroup);
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
      this.$emit('input', newValue);
    }
  },
  computed: {
    shownCategory: function shownCategory() {
      return this.showCategory ? this.showCategory : this.groups[0].slug;
    },
    selectedGroupsCount: function selectedGroupsCount() {
      if (!this.value) {
        return 0;
      }
      return this.value.reduce(function (total, cat) {
        total += cat.groups.length;
        return total;
      }, 0);
    }
  }
});

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__generic_ConfirmModal_vue__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__generic_ConfirmModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__generic_ConfirmModal_vue__);





var locales = ['en', 'fr', 'nl'];

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['marker'],
  components: {
    ConfirmModal: __WEBPACK_IMPORTED_MODULE_1__generic_ConfirmModal_vue___default.a
  },
  methods: {
    deleteMarker: function deleteMarker(marker) {
      this.$emit('trash', marker);
    },
    getLocalizedProp: function getLocalizedProp(obj) {
      var locale = this.currentLocale;
      if (obj[locale]) {
        return obj[locale];
      }
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(locales), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var l = _step.value;

          if (obj[l]) {
            return obj[l];
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  },
  computed: {
    currentLocale: function currentLocale() {
      return this.$i18n.locale;
    },
    joined_targeted_groups: function joined_targeted_groups() {
      if (this.marker.targeted_groups.length === 0) return 'ALL';
      var groups = this.marker.targeted_groups.map(function (x) {
        return x.groups;
      }).flat();
      return groups.map(function (x) {
        return x.name;
      }).join(', ');
    }
  }
});

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__generic_ConfirmModal_vue__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__generic_ConfirmModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__generic_ConfirmModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MarkerRow_vue__ = __webpack_require__(1007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MarkerRow_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MarkerRow_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['markers'],
  components: {
    ConfirmModal: __WEBPACK_IMPORTED_MODULE_0__generic_ConfirmModal_vue___default.a,
    MarkerRow: __WEBPACK_IMPORTED_MODULE_1__MarkerRow_vue___default.a
  },
  methods: {
    deleteMarker: function deleteMarker(marker) {
      this.$emit('trash', marker);
    }
  }
});

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__repositories_ConsumerSettingsRepository__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__markerEdit_InputLocalizedText_vue__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__markerEdit_InputLocalizedText_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__markerEdit_InputLocalizedText_vue__);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    InputLocalizedTextarea: __WEBPACK_IMPORTED_MODULE_6__markerEdit_InputLocalizedText_vue___default.a
  },
  data: function data() {
    var data = {
      loading: false,
      test: null,
      settings: {
        film_something_now_enabled: null,
        export_type: '',
        export_individual_format: '',
        localized_thank_you: {},
        localized_marker_request: {},
        ftp: {},
        ios_app_version: '',
        video_quality: {
          wifi: 'high',
          mobile_4g: 'medium',
          mobile_3g: 'medium'
        }
      },
      showPwd: false,
      exportTypes: ['CSV', 'XML'],
      exportIndividualFormats: [{ value: 1, text: 'Id' }, { value: 2, text: 'Country-City-Date' }],
      currentEditLocale: 'en',
      locales: ['en', 'fr', 'nl'],
      videoQualityVariants: [{ value: 'high', text: 'High' }, { value: 'medium', text: 'Medium' }, { value: 'low', text: 'Low' }]
    };
    data.locales.forEach(function (l) {
      data.settings.localized_thank_you[l] = '';
      data.settings.localized_marker_request[l] = '';
    });
    return data;
  },
  mounted: function mounted() {
    var _this = this;

    this.loading = true;
    __WEBPACK_IMPORTED_MODULE_5__repositories_ConsumerSettingsRepository__["a" /* default */].fetchSettings().then(function (settings) {
      _this.loading = false;
      if (settings.ftp === null) {
        settings.ftp = {
          host: '',
          path: '',
          user: '',
          password: ''
        };
      }
      if (!settings.video_quality) {
        settings.video_quality = _this.settings.video_quality;
      }
      _this.settings = settings;
    });
  },

  methods: {
    submit: function submit() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var payload;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('test');
                payload = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(_this2.settings));

                if (_this2.isEmpty(payload.ftp)) {
                  delete payload.ftp;
                }
                _context.prev = 3;
                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_5__repositories_ConsumerSettingsRepository__["a" /* default */].patchSettings(payload);

              case 6:
                _this2.$store.commit('snackbar/show', {
                  message: 'The settings have been updated', color: 'green'
                });
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](3);

                _this2.notifyError(_context.t0);

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[3, 9]]);
      }))();
    },
    isEmpty: function isEmpty(obj) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(obj).every(function (x) {
        return x === null || x === '';
      });
    },
    notifyError: function notifyError(error) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response, json, _json, nonFieldErrors, ftp, message, errList;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                response = error.response;
                json = void 0;
                _context2.prev = 2;
                _context2.next = 5;
                return response.json();

              case 5:
                json = _context2.sent;
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2['catch'](2);

                json = {};

              case 11:
                _json = json, nonFieldErrors = _json.non_field_errors, ftp = _json.ftp;
                message = void 0;

                if (ftp) {
                  errList = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(ftp).map(function (err) {
                    return err[0] + ': ' + err[1];
                  });

                  message = errList.join(' ');
                }
                message = nonFieldErrors || message || 'Hello';
                _this3.$store.commit('snackbar/show', { message: message, color: 'error' });

              case 16:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[2, 8]]);
      }))();
    }
  }

});

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__repositories_UserRepository_js__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_events__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UserRecords__ = __webpack_require__(1012);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UserRecords___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__UserRecords__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    UserRecords: __WEBPACK_IMPORTED_MODULE_2__UserRecords___default.a
  },
  data: function data() {
    return {
      profile: {}
    };
  },
  mounted: function mounted() {
    this.fetchUserDetailsData();
  },

  methods: {
    fetchUserDetailsData: function fetchUserDetailsData() {
      var _this = this;

      var userId = this.userId;
      __WEBPACK_IMPORTED_MODULE_0__repositories_UserRepository_js__["a" /* default */].fetchUserDetails(userId).then(function (data) {
        _this.profile = data;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_1__services_events__["a" /* default */].emit('error', error);
      });
    }
  },
  computed: {
    fullName: function fullName() {
      return this.profile.first_name + ' ' + this.profile.last_name;
    },
    avatar: function avatar() {
      var defaultImg = __webpack_require__(956);
      return this.profile.picture ? this.profile.picture : defaultImg;
    },
    userId: function userId() {
      return Number(this.$route.params.userId);
    }
  }
});

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(15);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default.a
  },
  mounted: function mounted() {
    if (!this.options) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__store__["d" /* refreshGroups */])(this.$store);
    }
  },


  data: function data() {
    return {
      value: []
    };
  },
  methods: {
    inputHandler: __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default()(function (chosenGroup) {
      this.$emit('groups-selected', chosenGroup);
    }, 1000)
  },
  computed: {
    options: function options() {
      if (this.$store.state.groups) {
        return this.$store.state.groups.map(function (x) {
          return x.groups;
        }).flat();
      }
      return [];
    }
  }
});

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__marker_record_RecordsList__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__marker_record_RecordsList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__marker_record_RecordsList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__repositories_RecordRepository__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_events__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__marker_record_RecordDetails_vue__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__marker_record_RecordDetails_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__marker_record_RecordDetails_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    RecordsList: __WEBPACK_IMPORTED_MODULE_0__marker_record_RecordsList___default.a,
    RecordDetails: __WEBPACK_IMPORTED_MODULE_3__marker_record_RecordDetails_vue___default.a
  },
  data: function data() {
    return {
      records: [],
      imageRecords: [],
      loading: true,
      activeTab: 0,
      pageSize: 20,
      recordsPage: 1,
      imagesPage: 1,
      selectedRecord: null
    };
  },

  props: {
    userId: {
      type: Number,
      required: true
    }
  },
  mounted: function mounted() {
    this.fetchRecords('VIDEO');
    this.fetchRecords('IMAGE');
  },

  methods: {
    fetchRecords: function fetchRecords(recordType) {
      var _this = this;

      this.loading = true;
      var page = recordType === 'VIDEO' ? this.recordsPage : this.imagesPage;
      __WEBPACK_IMPORTED_MODULE_1__repositories_RecordRepository__["a" /* default */].fetchUserRecords(this.userId, page, this.pageSize, recordType, this.activeTab).then(function (records) {
        _this.loading = false;
        _this.setRecords(recordType, records);
      }, function (error) {
        _this.loading = false;
        __WEBPACK_IMPORTED_MODULE_2__services_events__["a" /* default */].emit('error', error);
      });
    },
    setRecords: function setRecords(recordType, records) {
      if (recordType === 'VIDEO') {
        this.records = records;
      } else {
        this.imageRecords = records;
      }
    },
    handleRecordDelete: function handleRecordDelete(_ref, recordType) {
      var _this2 = this;

      var id = _ref.id;

      __WEBPACK_IMPORTED_MODULE_1__repositories_RecordRepository__["a" /* default */].deleteUserRecord(this.userId, id).then(function () {
        _this2.fetchRecords(recordType);
      }, function (error) {
        __WEBPACK_IMPORTED_MODULE_2__services_events__["a" /* default */].emit('error', error, '', { modal: false });
      });
    },
    handleRecordRestore: function handleRecordRestore(_ref2, recordType) {
      var _this3 = this;

      var id = _ref2.id;

      __WEBPACK_IMPORTED_MODULE_1__repositories_RecordRepository__["a" /* default */].restoreUserRecord(this.userId, id).then(function () {
        _this3.fetchRecords(recordType);
      }, function (error) {
        __WEBPACK_IMPORTED_MODULE_2__services_events__["a" /* default */].emit('error', error, '', { modal: false });
      });
    },
    markRecordRelevance: function markRecordRelevance(_ref3, relevance, recordType) {
      var id = _ref3.id;

      var r = this.getRecords(recordType).find(function (r) {
        return r.id === id;
      });
      if (r && r.mldata) {
        r.mldata.marked_as_relevant = relevance;
      }
      __WEBPACK_IMPORTED_MODULE_1__repositories_RecordRepository__["a" /* default */].patchUserRecordRelevance(this.userId, id, relevance).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2__services_events__["a" /* default */].emit('error', error, '', { modal: false });
      });
    },
    getRecords: function getRecords(recordType) {
      var typeMapping = {
        'VIDEO': this.records,
        'IMAGE': this.imageRecords
      };
      return typeMapping[recordType];
    },
    tabSelected: function tabSelected() {
      this.fetchRecords('VIDEO');
      this.fetchRecords('IMAGE');
    },
    calculateAmountPages: function calculateAmountPages(recordType) {
      var records = recordType === 'VIDEO' ? this.records : this.imageRecords;
      return Math.ceil(records.count / this.pageSize) || 1;
    },
    showRecordDetails: function showRecordDetails(record) {
      this.selectedRecord = record;
    }
  }
});

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_debounce__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      search: ''
    };
  },
  methods: {
    inputHandler: __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(function (query) {
      this.search = query.target.value;
      this.$emit('query-updated', this.search);
    }, 1000)
  }
});

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UserGroupSelector_vue__ = __webpack_require__(1011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UserGroupSelector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__UserGroupSelector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UserSearchInput_vue__ = __webpack_require__(1013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UserSearchInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__UserSearchInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__repositories_UserRepository_js__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_events__ = __webpack_require__(9);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    UserGroupSelector: __WEBPACK_IMPORTED_MODULE_0__UserGroupSelector_vue___default.a,
    UserSearchInput: __WEBPACK_IMPORTED_MODULE_1__UserSearchInput_vue___default.a
  },
  data: function data() {
    return {
      value: [],
      headers: [{ text: 'First Name', value: 'first_name' }, { text: 'Last Name', value: 'last_name' }, { text: 'User groups', value: 'user_groups' }, { text: '# Valid Vids', value: 'valid_records_amt' }, { text: '# Vids', value: 'all_records_amt' }, { text: 'View', value: 'link' }],
      users: [],
      userFilters: {
        group: '',
        name_query: ''
      }
    };
  },
  mounted: function mounted() {
    this.fetchUserListData();
  },

  methods: {
    fetchUserListData: function fetchUserListData() {
      var _this = this;

      var getParams = {
        usergroup: this.userFilters.group,
        full_name: this.userFilters.name_query
      };
      __WEBPACK_IMPORTED_MODULE_2__repositories_UserRepository_js__["a" /* default */].fetchUsersList(getParams).then(function (users) {
        _this.users = users;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_3__services_events__["a" /* default */].emit('error', error);
      });
    },
    exportUserData: function exportUserData() {
      __WEBPACK_IMPORTED_MODULE_2__repositories_UserRepository_js__["a" /* default */].exportAllUsers();
    },
    handleGroupsSelected: function handleGroupsSelected(chosenGroup) {
      this.userFilters.group = chosenGroup.slug;
      this.fetchUserListData();
    },
    handleNameQueryUpdated: function handleNameQueryUpdated(query) {
      console.log(query);
      this.userFilters.name_query = query;
      this.fetchUserListData();
    },
    buildDetailsLink: function buildDetailsLink(pk) {
      return 'user/' + pk + '/';
    }
  },
  computed: {
    userGroups: function userGroups() {
      if (this.$store.state.groups) {
        var groups = this.$store.state.groups.map(function (x) {
          return x.groups;
        }).flat();
        return groups;
      }
    }
  }
});

/***/ }),
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 905 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 906 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 907 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 908 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 909 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 910 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 911 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 912 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 913 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 914 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 915 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 916 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 917 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 918 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 919 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 920 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 921 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 922 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 923 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 924 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 925 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 926 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 927 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 928 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 929 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 930 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 931 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 932 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 933 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 934 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 279,
	"./af.js": 279,
	"./ar": 286,
	"./ar-dz": 280,
	"./ar-dz.js": 280,
	"./ar-kw": 281,
	"./ar-kw.js": 281,
	"./ar-ly": 282,
	"./ar-ly.js": 282,
	"./ar-ma": 283,
	"./ar-ma.js": 283,
	"./ar-sa": 284,
	"./ar-sa.js": 284,
	"./ar-tn": 285,
	"./ar-tn.js": 285,
	"./ar.js": 286,
	"./az": 287,
	"./az.js": 287,
	"./be": 288,
	"./be.js": 288,
	"./bg": 289,
	"./bg.js": 289,
	"./bm": 290,
	"./bm.js": 290,
	"./bn": 291,
	"./bn.js": 291,
	"./bo": 292,
	"./bo.js": 292,
	"./br": 293,
	"./br.js": 293,
	"./bs": 294,
	"./bs.js": 294,
	"./ca": 295,
	"./ca.js": 295,
	"./cs": 296,
	"./cs.js": 296,
	"./cv": 297,
	"./cv.js": 297,
	"./cy": 298,
	"./cy.js": 298,
	"./da": 299,
	"./da.js": 299,
	"./de": 302,
	"./de-at": 300,
	"./de-at.js": 300,
	"./de-ch": 301,
	"./de-ch.js": 301,
	"./de.js": 302,
	"./dv": 303,
	"./dv.js": 303,
	"./el": 304,
	"./el.js": 304,
	"./en-au": 305,
	"./en-au.js": 305,
	"./en-ca": 306,
	"./en-ca.js": 306,
	"./en-gb": 307,
	"./en-gb.js": 307,
	"./en-ie": 308,
	"./en-ie.js": 308,
	"./en-nz": 309,
	"./en-nz.js": 309,
	"./eo": 310,
	"./eo.js": 310,
	"./es": 313,
	"./es-do": 311,
	"./es-do.js": 311,
	"./es-us": 312,
	"./es-us.js": 312,
	"./es.js": 313,
	"./et": 314,
	"./et.js": 314,
	"./eu": 315,
	"./eu.js": 315,
	"./fa": 316,
	"./fa.js": 316,
	"./fi": 317,
	"./fi.js": 317,
	"./fo": 318,
	"./fo.js": 318,
	"./fr": 321,
	"./fr-ca": 319,
	"./fr-ca.js": 319,
	"./fr-ch": 320,
	"./fr-ch.js": 320,
	"./fr.js": 321,
	"./fy": 322,
	"./fy.js": 322,
	"./gd": 323,
	"./gd.js": 323,
	"./gl": 324,
	"./gl.js": 324,
	"./gom-latn": 325,
	"./gom-latn.js": 325,
	"./gu": 326,
	"./gu.js": 326,
	"./he": 327,
	"./he.js": 327,
	"./hi": 328,
	"./hi.js": 328,
	"./hr": 329,
	"./hr.js": 329,
	"./hu": 330,
	"./hu.js": 330,
	"./hy-am": 331,
	"./hy-am.js": 331,
	"./id": 332,
	"./id.js": 332,
	"./is": 333,
	"./is.js": 333,
	"./it": 334,
	"./it.js": 334,
	"./ja": 335,
	"./ja.js": 335,
	"./jv": 336,
	"./jv.js": 336,
	"./ka": 337,
	"./ka.js": 337,
	"./kk": 338,
	"./kk.js": 338,
	"./km": 339,
	"./km.js": 339,
	"./kn": 340,
	"./kn.js": 340,
	"./ko": 341,
	"./ko.js": 341,
	"./ky": 342,
	"./ky.js": 342,
	"./lb": 343,
	"./lb.js": 343,
	"./lo": 344,
	"./lo.js": 344,
	"./lt": 345,
	"./lt.js": 345,
	"./lv": 346,
	"./lv.js": 346,
	"./me": 347,
	"./me.js": 347,
	"./mi": 348,
	"./mi.js": 348,
	"./mk": 349,
	"./mk.js": 349,
	"./ml": 350,
	"./ml.js": 350,
	"./mr": 351,
	"./mr.js": 351,
	"./ms": 353,
	"./ms-my": 352,
	"./ms-my.js": 352,
	"./ms.js": 353,
	"./mt": 354,
	"./mt.js": 354,
	"./my": 355,
	"./my.js": 355,
	"./nb": 356,
	"./nb.js": 356,
	"./ne": 357,
	"./ne.js": 357,
	"./nl": 359,
	"./nl-be": 358,
	"./nl-be.js": 358,
	"./nl.js": 359,
	"./nn": 360,
	"./nn.js": 360,
	"./pa-in": 361,
	"./pa-in.js": 361,
	"./pl": 362,
	"./pl.js": 362,
	"./pt": 364,
	"./pt-br": 363,
	"./pt-br.js": 363,
	"./pt.js": 364,
	"./ro": 365,
	"./ro.js": 365,
	"./ru": 366,
	"./ru.js": 366,
	"./sd": 367,
	"./sd.js": 367,
	"./se": 368,
	"./se.js": 368,
	"./si": 369,
	"./si.js": 369,
	"./sk": 370,
	"./sk.js": 370,
	"./sl": 371,
	"./sl.js": 371,
	"./sq": 372,
	"./sq.js": 372,
	"./sr": 374,
	"./sr-cyrl": 373,
	"./sr-cyrl.js": 373,
	"./sr.js": 374,
	"./ss": 375,
	"./ss.js": 375,
	"./sv": 376,
	"./sv.js": 376,
	"./sw": 377,
	"./sw.js": 377,
	"./ta": 378,
	"./ta.js": 378,
	"./te": 379,
	"./te.js": 379,
	"./tet": 380,
	"./tet.js": 380,
	"./th": 381,
	"./th.js": 381,
	"./tl-ph": 382,
	"./tl-ph.js": 382,
	"./tlh": 383,
	"./tlh.js": 383,
	"./tr": 384,
	"./tr.js": 384,
	"./tzl": 385,
	"./tzl.js": 385,
	"./tzm": 387,
	"./tzm-latn": 386,
	"./tzm-latn.js": 386,
	"./tzm.js": 387,
	"./uk": 388,
	"./uk.js": 388,
	"./ur": 389,
	"./ur.js": 389,
	"./uz": 391,
	"./uz-latn": 390,
	"./uz-latn.js": 390,
	"./uz.js": 391,
	"./vi": 392,
	"./vi.js": 392,
	"./x-pseudo": 393,
	"./x-pseudo.js": 393,
	"./yo": 394,
	"./yo.js": 394,
	"./zh-cn": 395,
	"./zh-cn.js": 395,
	"./zh-hk": 396,
	"./zh-hk.js": 396,
	"./zh-tw": 397,
	"./zh-tw.js": 397
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 942;

/***/ }),
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 953 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAApCAYAAADAk4LOAAAFgUlEQVR4Aa1XA5BjWRTN2oW17d3YaZtr2962HUzbDNpjszW24mRt28p47v7zq/bXZtrp/lWnXr337j3nPCe85NcypgSFdugCpW5YoDAMRaIMqRi6aKq5E3YqDQO3qAwjVWrD8Ncq/RBpykd8oZUb/kaJutow8r1aP9II0WmLKLIsJyv1w/kqw9Ch2MYdB++12Onxee/QMwvf4/Dk/Lfp/i4nxTXtOoQ4pW5Aj7wpici1A9erdAN2OH64x8OSP9j3Ft3b7aWkTg/Fm91siTra0f9on5sQr9INejH6CUUUpavjFNq1B+Oadhxmnfa8RfEmN8VNAsQhPqF55xHkMzz3jSmChWU6f7/XZKNH+9+hBLOHYozuKQPxyMPUKkrX/K0uWnfFaJGS1QPRtZsOPtr3NsW0uyh6NNCOkU3Yz+bXbT3I8G3xE5EXLXtCXbbqwCO9zPQYPRTZ5vIDXD7U+w7rFDEoUUf7ibHIR4y6bLVPXrz8JVZEql13trxwue/uDivd3fkWRbS6/IA2bID4uk0UpF1N8qLlbBlXs4Ee7HLTfV1j54APvODnSfOWBqtKVvjgLKzF5YdEk5ewRkGlK0i33Eofffc7HT56jD7/6U+qH3Cx7SBLNntH5YIPvODnyfIXZYRVDPqgHtLs5ABHD3YzLuespb7t79FY34DjMwrVrcTuwlT55YMPvOBnRrJ4VXTdNnYug5ucHLBjEpt30701A3Ts+HEa73u6dT3FNWwflY86eMHPk+Yu+i6pzUpRrW7SNDg5JHR4KapmM5Wv2E8Tfcb1HoqqHMHU+uWDD7zg54mz5/2BSnizi9T1Dg4QQXLToGNCkb6tb1NU+QAlGr1++eADrzhn/u8Q2YZhQVlZ5+CAOtqfbhmaUCS1ezNFVm2imDbPmPng5wmz+gwh+oHDce0eUtQ6OGDIyR0uUhUsoO3vfDmmgOezH0mZN59x7MBi++WDL1g/eEiU3avlidO671bkLfwbw5XV2P8Pzo0ydy4t2/0eu33xYSOMOD8hTf4CrBtGMSoXfPLchX+J0ruSePw3LZeK0juPJbYzrhkH0io7B3k164hiGvawhOKMLkrQLyVpZg8rHFW7E2uHOL888IBPlNZ1FPzstSJM694fWr6RwpvcJK60+0HCILTBzZLFNdtAzJaohze60T8qBzyh5ZuOg5e7uwQppofEmf2++DYvmySqGBuKaicF1blQjhuHdvCIMvp8whTTfZzI7RldpwtSzL+F1+wkdZ2TBOW2gIF88PBTzD/gpeREAMEbxnJcaJHNHrpzji0gQCS6hdkEeYt9DF/2qPcEC8RM28Hwmr3sdNyht00byAut2k3gufWNtgtOEOFGUwcXWNDbdNbpgBGxEvKkOQsxivJx33iow0Vw5S6SVTrpVq11ysA2Rp7gTfPfktc6zhtXBBC+adRLshf6sG2RfHPZ5EAc4sVZ83yCN00Fk/4kggu40ZTvIEm5g24qtU4KjBrx/BTTH8ifVASAG7gKrnWxJDcU7x8X6Ecczhm3o6YicvsLXWfh3Ch1W0k8x0nXF+0fFxgt4phz8QvypiwCCFKMqXCnqXExjq10beH+UUA7+nG6mdG/Pu0f3LgFcGrl2s0kNNjpmoJ9o4B29CMO8dMT4Q5ox8uitF6fqsrJOr8qnwNbRzv6hSnG5wP+64C7h9lp30hKNtKdWjtdkbuPA19nJ7Tz3zR/ibgARbhb4AlhavcBebmTHcFl2fvYEnW0ox9xMxKBS8btJ+KiEbq9zA4RthQXDhPa0T9TEe69gWupwc6uBUphquXgf+/FrIjweHQS4/pduMe5ERUMHUd9xv8ZR98CxkS4F2n3EUrUZ10EYNw7BWm9x1GiPssi3GgiGRDKWRYZfXlON+dfNbM+GgIwYdwAAAAASUVORK5CYII="

/***/ }),
/* 954 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAApCAQAAAACach9AAACMUlEQVR4Ae3ShY7jQBAE0Aoz/f9/HTMzhg1zrdKUrJbdx+Kd2nD8VNudfsL/Th///dyQN2TH6f3y/BGpC379rV+S+qqetBOxImNQXL8JCAr2V4iMQXHGNJxeCfZXhSRBcQMfvkOWUdtfzlLgAENmZDcmo2TVmt8OSM2eXxBp3DjHSMFutqS7SbmemzBiR+xpKCNUIRkdkkYxhAkyGoBvyQFEJEefwSmmvBfJuJ6aKqKWnAkvGZOaZXTUgFqYULWNSHUckZuR1HIIimUExutRxwzOLROIG4vKmCKQt364mIlhSyzAf1m9lHZHJZrlAOMMztRRiKimp/rpdJDc9Awry5xTZCte7FHtuS8wJgeYGrex28xNTd086Dik7vUMscQOa8y4DoGtCCSkAKlNwpgNtphjrC6MIHUkR6YWxxs6Sc5xqn222mmCRFzIt8lEdKx+ikCtg91qS2WpwVfBelJCiQJwvzixfI9cxZQWgiSJelKnwBElKYtDOb2MFbhmUigbReQBV0Cg4+qMXSxXSyGUn4UbF8l+7qdSGnTC0XLCmahIgUHLhLOhpVCtw4CzYXvLQWQbJNmxoCsOKAxSgBJno75avolkRw8iIAFcsdc02e9iyCd8tHwmeSSoKTowIgvscSGZUOA7PuCN5b2BX9mQM7S0wYhMNU74zgsPBj3HU7wguAfnxxjFQGBE6pwN+GjME9zHY7zGp8wVxMShYX9NXvEWD3HbwJf4giO4CFIQxXScH1/TM+04kkBiAAAAAElFTkSuQmCC"

/***/ }),
/* 955 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiICB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgIDxwYXRoIGZpbGw9IiMwMDAwMDAiIGQ9Ik00LDJIMTRWNEg0VjE0SDJWNEMyLDIuODkgMi44OSwyIDQsMk04LDZIMThWOEg4VjE4SDZWOEM2LDYuODkgNi44OSw2IDgsNk0xMiwxMEgyMEMyMS4xMSwxMCAyMiwxMC44OSAyMiwxMlYyMEMyMiwyMS4xMSAyMS4xMSwyMiAyMCwyMkgxMkMxMC44OSwyMiAxMCwyMS4xMSAxMCwyMFYxMkMxMCwxMC44OSAxMC44OSwxMCAxMiwxME0xNCwxMlYyMEwyMCwxNkwxNCwxMloiIC8+Cjwvc3ZnPg=="

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/defaultAvatar.c231fa1.png";

/***/ }),
/* 957 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjMiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAyMyAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMy4wMTczMyIgeT0iNC4yNSIgd2lkdGg9IjQuMzEwMzQiIGhlaWdodD0iNSIgcng9IjAuNSIgZmlsbD0id2hpdGUiIHN0cm9rZT0iYmxhY2siLz4KPHBhdGggZD0iTTguMDI3MTkgNC4wMTQ3NEwxMy41MTEyIDIuMzY2MDJDMTMuODMyIDIuMjY5NTYgMTQuMTU1MSAyLjUwOTggMTQuMTU1MSAyLjg0NDg1VjEwLjY1NTFDMTQuMTU1MSAxMC45OTAyIDEzLjgzMiAxMS4yMzA0IDEzLjUxMTIgMTEuMTM0TDguMDI3MTkgOS40ODUyNUM3LjgxNTg0IDkuNDIxNzEgNy42NzExNCA5LjIyNzEyIDcuNjcxMTQgOS4wMDY0MlY0LjQ5MzU3QzcuNjcxMTQgNC4yNzI4NyA3LjgxNTg0IDQuMDc4MjggOC4wMjcxOSA0LjAxNDc0WiIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxyZWN0IHg9IjAuMjQwNzczIiB5PSIwLjY2MTU1MiIgd2lkdGg9IjIuMDI4MzUiIGhlaWdodD0iNS43NjM5MiIgcng9IjEuMDE0MTgiIHRyYW5zZm9ybT0ibWF0cml4KDAuOTA4MTQyIDAuNDE4NjYyIC0wLjQyNjU5NiAwLjkwNDQ0MiA0Ljk0ODM4IDcuNDYyNDEpIiBmaWxsPSJibGFjayIgc3Ryb2tlPSJibGFjayIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTIuNTE3MjQgNS4yNUMxLjY3OTI5IDUuMjUgMSA1LjkyMTU3IDEgNi43NUMxIDcuNTc4NDMgMS42NzkyOSA4LjI1IDIuNTE3MjQgOC4yNVY4LjI1IiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMi41MTcyNCA1LjI1QzEuNjc5MjkgNS4yNSAxIDUuOTIxNTcgMSA2Ljc1QzEgNy41Nzg0MyAxLjY3OTI5IDguMjUgMi41MTcyNCA4LjI1VjguMjUiIHN0cm9rZT0iYmxhY2siLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNi4xNzI1IDUuMjVDMTcuMDEwNCA1LjI1IDE3LjY4OTcgNS45MjE1NyAxNy42ODk3IDYuNzVDMTcuNjg5NyA3LjU3ODQzIDE3LjAxMDQgOC4yNSAxNi4xNzI1IDguMjVWOC4yNSIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTE2LjE3MjUgNS4yNUMxNy4wMTA0IDUuMjUgMTcuNjg5NyA1LjkyMTU3IDE3LjY4OTcgNi43NUMxNy42ODk3IDcuNTc4NDMgMTcuMDEwNCA4LjI1IDE2LjE3MjUgOC4yNVY4LjI1IiBzdHJva2U9ImJsYWNrIi8+CjxyZWN0IHg9IjE0LjM5NjUiIHk9IjEuMjUiIHdpZHRoPSIxLjI3NTg2IiBoZWlnaHQ9IjExIiByeD0iMC41IiBmaWxsPSJibGFjayIgc3Ryb2tlPSJibGFjayIvPgo8cmVjdCB4PSIxOS4zOTQzIiB5PSI2LjE4NzUiIHdpZHRoPSIzLjQxODEiIGhlaWdodD0iMC4zNzUiIHJ4PSIwLjE4NzUiIGZpbGw9IiNEOEQ4RDgiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMC4zNzUiLz4KPHJlY3QgeD0iMC4xMTE3OTgiIHk9IjAuMjM5NzYyIiB3aWR0aD0iMy40MTI1OCIgaGVpZ2h0PSIwLjM3NTUwNyIgcng9IjAuMTg3NzUzIiB0cmFuc2Zvcm09Im1hdHJpeCgwLjk0MDkzNyAwLjMzODU4MiAtMC4zNDU0ODQgMC45Mzg0MjQgMTguNzk3MiA4LjIyNjkxKSIgZmlsbD0iI0Q4RDhEOCIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIwLjM3NTUwNyIvPgo8cmVjdCB4PSIwLjAyMzA4ODMiIHk9IjAuMjYzOTE3IiB3aWR0aD0iMy4zOTg1NyIgaGVpZ2h0PSIwLjM3Njc4NyIgcng9IjAuMTg4Mzk0IiB0cmFuc2Zvcm09Im1hdHJpeCgwLjc2OTY0NiAwLjYzODQ3MSAtMC42NDcwOTMgMC43NjI0MTEgMTcuNTk0OCA5Ljc5Nzk2KSIgZmlsbD0iI0Q4RDhEOCIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIwLjM3Njc4NyIvPgo8cmVjdCB4PSIwLjI0MTUzIiB5PSIwLjExMjYyMyIgd2lkdGg9IjMuNDEyNTgiIGhlaWdodD0iMC4zNzU1MDciIHJ4PSIwLjE4Nzc1MyIgdHJhbnNmb3JtPSJtYXRyaXgoMC45NDA5MzcgLTAuMzM4NTgxIDAuMzQ1NDg1IDAuOTM4NDI0IDE4LjQyMzYgNC4zNzEyOSkiIGZpbGw9IiNEOEQ4RDgiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMC4zNzU1MDciLz4KPHJlY3QgeD0iMC4yNjY5MDQiIHk9IjAuMDIzMzQ5NiIgd2lkdGg9IjMuMzk4NTciIGhlaWdodD0iMC4zNzY3ODciIHJ4PSIwLjE4ODM5MyIgdHJhbnNmb3JtPSJtYXRyaXgoMC43Njk2NDYgLTAuNjM4NDcxIDAuNjQ3MDkzIDAuNzYyNDExIDE2Ljk3NzUgMi41ODY0MikiIGZpbGw9IiNEOEQ4RDgiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMC4zNzY3ODciLz4KPC9zdmc+Cg=="

/***/ }),
/* 958 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAzMSAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMy4wMTczMyIgeT0iMTAuMjUiIHdpZHRoPSI0LjMxMDM0IiBoZWlnaHQ9IjUiIHJ4PSIwLjUiIGZpbGw9IndoaXRlIiBzdHJva2U9IiNDRENEQ0QiLz4KPHBhdGggZD0iTTguMDI3MTkgMTAuMDE0N0wxMy41MTEyIDguMzY2MDNDMTMuODMyIDguMjY5NTYgMTQuMTU1MSA4LjUwOTggMTQuMTU1MSA4Ljg0NDg2VjE2LjY1NTFDMTQuMTU1MSAxNi45OTAyIDEzLjgzMiAxNy4yMzA0IDEzLjUxMTIgMTcuMTM0TDguMDI3MTkgMTUuNDg1M0M3LjgxNTg0IDE1LjQyMTcgNy42NzExNCAxNS4yMjcxIDcuNjcxMTQgMTUuMDA2NFYxMC40OTM2QzcuNjcxMTQgMTAuMjcyOSA3LjgxNTg0IDEwLjA3ODMgOC4wMjcxOSAxMC4wMTQ3WiIgZmlsbD0id2hpdGUiIHN0cm9rZT0iI0NEQ0RDRCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik02LjI5MDQ1IDE1LjkzNkw0LjY5Njg3IDE5LjMxNDZDNC40NTk0MiAxOS44MTgxIDMuODYwNTggMjAuMDM2IDMuMzU1MDkgMTkuODAzQzIuODQzMyAxOS41NjcgMi42MjIwNCAxOC45NTkxIDIuODYyNDUgMTguNDQ5NEw0LjQ1NjAzIDE1LjA3MDhDNC42OTM0OCAxNC41Njc0IDUuMjkyMzMgMTQuMzQ5NCA1Ljc5NzgxIDE0LjU4MjRDNi4zMDk2IDE0LjgxODQgNi41MzA4NiAxNS40MjYzIDYuMjkwNDUgMTUuOTM2WiIgZmlsbD0iI0NEQ0RDRCIgc3Ryb2tlPSIjQ0RDRENEIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMi41MTcyNCAxMS4yNUMxLjY3OTI5IDExLjI1IDEgMTEuOTIxNiAxIDEyLjc1QzEgMTMuNTc4NCAxLjY3OTI5IDE0LjI1IDIuNTE3MjQgMTQuMjUiIGZpbGw9IiNDRENEQ0QiLz4KPHBhdGggZD0iTTIuNTE3MjQgMTEuMjVDMS42NzkyOSAxMS4yNSAxIDExLjkyMTYgMSAxMi43NUMxIDEzLjU3ODQgMS42NzkyOSAxNC4yNSAyLjUxNzI0IDE0LjI1IiBzdHJva2U9IiNDRENEQ0QiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNi4xNzI1IDExLjI1QzE3LjAxMDQgMTEuMjUgMTcuNjg5NyAxMS45MjE2IDE3LjY4OTcgMTIuNzVDMTcuNjg5NyAxMy41Nzg0IDE3LjAxMDQgMTQuMjUgMTYuMTcyNSAxNC4yNSIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTE2LjE3MjUgMTEuMjVDMTcuMDEwNCAxMS4yNSAxNy42ODk3IDExLjkyMTYgMTcuNjg5NyAxMi43NUMxNy42ODk3IDEzLjU3ODQgMTcuMDEwNCAxNC4yNSAxNi4xNzI1IDE0LjI1IiBzdHJva2U9IiNDRENEQ0QiLz4KPHJlY3QgeD0iMTQuMzk2NSIgeT0iNy4yNSIgd2lkdGg9IjEuMjc1ODYiIGhlaWdodD0iMTEiIHJ4PSIwLjUiIGZpbGw9IiNDRENEQ0QiIHN0cm9rZT0iI0NEQ0RDRCIvPgo8cmVjdCB4PSIxOS4zOTQzIiB5PSIxMi4xODc1IiB3aWR0aD0iMy40MTgxIiBoZWlnaHQ9IjAuMzc1IiByeD0iMC4xODc1IiBmaWxsPSIjRDhEOEQ4IiBzdHJva2U9IiNDRENEQ0QiIHN0cm9rZS13aWR0aD0iMC4zNzUiLz4KPG1hc2sgaWQ9InBhdGgtMTEtaW5zaWRlLTEiIGZpbGw9IndoaXRlIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xOC41NzkgMTQuNTk5OEMxOC42NTAzIDE0LjQwNjIgMTguODY0NCAxNC4zMDY0IDE5LjA1ODYgMTQuMzc2MkwyMS45MTYyIDE1LjQwNDVDMjIuMTEyNCAxNS40NzUxIDIyLjIxMzUgMTUuNjkxOSAyMi4xNDE1IDE1Ljg4NzZWMTUuODg3NkMyMi4wNzAyIDE2LjA4MTIgMjEuODU2MSAxNi4xODEgMjEuNjYyIDE2LjExMTFMMTguODA0MyAxNS4wODI4QzE4LjYwODEgMTUuMDEyMyAxOC41MDcgMTQuNzk1NCAxOC41NzkgMTQuNTk5OFYxNC41OTk4WiIvPgo8L21hc2s+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTguNTc5IDE0LjU5OThDMTguNjUwMyAxNC40MDYyIDE4Ljg2NDQgMTQuMzA2NCAxOS4wNTg2IDE0LjM3NjJMMjEuOTE2MiAxNS40MDQ1QzIyLjExMjQgMTUuNDc1MSAyMi4yMTM1IDE1LjY5MTkgMjIuMTQxNSAxNS44ODc2VjE1Ljg4NzZDMjIuMDcwMiAxNi4wODEyIDIxLjg1NjEgMTYuMTgxIDIxLjY2MiAxNi4xMTExTDE4LjgwNDMgMTUuMDgyOEMxOC42MDgxIDE1LjAxMjMgMTguNTA3IDE0Ljc5NTQgMTguNTc5IDE0LjU5OThWMTQuNTk5OFoiIGZpbGw9IiNEOEQ4RDgiLz4KPHBhdGggZD0iTTE4LjcyIDE1LjMxNzFMMjEuNTc3NyAxNi4zNDU0TDIyLjI1NDggMTQuNDYzNkwxOS4zOTcxIDEzLjQzNTNMMTguNzIgMTUuMzE3MVpNMjIuMDAwNiAxNS4xNzAyTDE5LjE0MjkgMTQuMTQxOUwxOC40NjU3IDE2LjAyMzhMMjEuMzIzNCAxNy4wNTIxTDIyLjAwMDYgMTUuMTcwMlpNMTkuMTQyOSAxNC4xNDE5QzE5LjQ2OTEgMTQuMjU5MyAxOS42MzcyIDE0LjYxOTkgMTkuNTE3NSAxNC45NDUzTDE3LjY0MDYgMTQuMjU0M0MxNy4zNzY4IDE0Ljk3MDkgMTcuNzQ3MiAxNS43NjUyIDE4LjQ2NTcgMTYuMDIzOEwxOS4xNDI5IDE0LjE0MTlaTTIxLjIwMzEgMTUuNTQyMUMyMS4zMjE2IDE1LjIyMDEgMjEuNjc3NyAxNS4wNTQgMjIuMDAwNiAxNS4xNzAyTDIxLjMyMzQgMTcuMDUyMUMyMi4wMzQ1IDE3LjMwOCAyMi44MTg4IDE2Ljk0MjIgMjMuMDc5OSAxNi4yMzNMMjEuMjAzMSAxNS41NDIxWk0yMS41Nzc3IDE2LjM0NTRDMjEuMjUxNCAxNi4yMjgxIDIxLjA4MzMgMTUuODY3NCAyMS4yMDMxIDE1LjU0MjFMMjMuMDc5OSAxNi4yMzNDMjMuMzQzNyAxNS41MTY0IDIyLjk3MzMgMTQuNzIyMSAyMi4yNTQ4IDE0LjQ2MzZMMjEuNTc3NyAxNi4zNDU0Wk0xOS4zOTcxIDEzLjQzNTNDMTguNjg2IDEzLjE3OTQgMTcuOTAxNyAxMy41NDUxIDE3LjY0MDYgMTQuMjU0M0wxOS41MTc1IDE0Ljk0NTNDMTkuMzk4OSAxNS4yNjczIDE5LjA0MjggMTUuNDMzMyAxOC43MiAxNS4zMTcxTDE5LjM5NzEgMTMuNDM1M1oiIGZpbGw9IiNDRENEQ0QiIG1hc2s9InVybCgjcGF0aC0xMS1pbnNpZGUtMSkiLz4KPG1hc2sgaWQ9InBhdGgtMTMtaW5zaWRlLTIiIGZpbGw9IndoaXRlIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNy4xNzc3IDE2LjAzNEMxNy4zMTEzIDE1Ljg3NjcgMTcuNTQ2NiAxNS44NTYxIDE3LjcwNTUgMTUuOTg3OUwyMC4wMzEyIDE3LjkxNzJDMjAuMTkyNiAxOC4wNTExIDIwLjIxMzYgMTguMjkxIDIwLjA3NzkgMTguNDUxVjE4LjQ1MUMxOS45NDQzIDE4LjYwODMgMTkuNzA5IDE4LjYyODkgMTkuNTUwMSAxOC40OTcxTDE3LjIyNDQgMTYuNTY3OEMxNy4wNjMgMTYuNDMzOSAxNy4wNDIgMTYuMTkzOSAxNy4xNzc3IDE2LjAzNFYxNi4wMzRaIi8+CjwvbWFzaz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNy4xNzc3IDE2LjAzNEMxNy4zMTEzIDE1Ljg3NjcgMTcuNTQ2NiAxNS44NTYxIDE3LjcwNTUgMTUuOTg3OUwyMC4wMzEyIDE3LjkxNzJDMjAuMTkyNiAxOC4wNTExIDIwLjIxMzYgMTguMjkxIDIwLjA3NzkgMTguNDUxVjE4LjQ1MUMxOS45NDQzIDE4LjYwODMgMTkuNzA5IDE4LjYyODkgMTkuNTUwMSAxOC40OTcxTDE3LjIyNDQgMTYuNTY3OEMxNy4wNjMgMTYuNDMzOSAxNy4wNDIgMTYuMTkzOSAxNy4xNzc3IDE2LjAzNFYxNi4wMzRaIiBmaWxsPSIjRDhEOEQ4Ii8+CjxwYXRoIGQ9Ik0xOS41NTAxIDE4LjQ5NzFMMjAuMTg4NiAxNy43Mjc1TDE5LjU1MDEgMTguNDk3MVpNMTcuMDY3IDE2Ljc1NzVMMTkuMzkyNyAxOC42ODY4TDIwLjY2OTcgMTcuMTQ3NUwxOC4zNDQgMTUuMjE4MkwxNy4wNjcgMTYuNzU3NVpNMjAuMTg4NiAxNy43Mjc1TDE3Ljg2MjkgMTUuNzk4MkwxNi41ODU5IDE3LjMzNzVMMTguOTExNiAxOS4yNjY4TDIwLjE4ODYgMTcuNzI3NVpNMTcuODYyOSAxNS43OTgyQzE4LjEyOTkgMTYuMDE5NyAxOC4xNjQ2IDE2LjQxNjYgMTcuOTQwMSAxNi42ODExTDE2LjQxNTMgMTUuMzg2OUMxNS45MTkzIDE1Ljk3MTMgMTUuOTk2MSAxNi44NDgxIDE2LjU4NTkgMTcuMzM3NUwxNy44NjI5IDE1Ljc5ODJaTTE5LjMxNTUgMTcuODAzOUMxOS41MzY1IDE3LjU0MzUgMTkuOTI1OCAxNy41MDk1IDIwLjE4ODYgMTcuNzI3NUwxOC45MTE2IDE5LjI2NjhDMTkuNDkyMiAxOS43NDg0IDIwLjM1MjIgMTkuNjczMSAyMC44NDAzIDE5LjA5OEwxOS4zMTU1IDE3LjgwMzlaTTE5LjM5MjcgMTguNjg2OEMxOS4xMjU3IDE4LjQ2NTMgMTkuMDkxIDE4LjA2ODQgMTkuMzE1NSAxNy44MDM5TDIwLjg0MDMgMTkuMDk4QzIxLjMzNjMgMTguNTEzNyAyMS4yNTk2IDE3LjYzNjkgMjAuNjY5NyAxNy4xNDc1TDE5LjM5MjcgMTguNjg2OFpNMTguMzQ0IDE1LjIxODJDMTcuNzYzNCAxNC43MzY2IDE2LjkwMzQgMTQuODExOCAxNi40MTUzIDE1LjM4NjlMMTcuOTQwMSAxNi42ODExQzE3LjcxOTIgMTYuOTQxNSAxNy4zMjk4IDE2Ljk3NTUgMTcuMDY3IDE2Ljc1NzVMMTguMzQ0IDE1LjIxODJaIiBmaWxsPSIjQ0RDRENEIiBtYXNrPSJ1cmwoI3BhdGgtMTMtaW5zaWRlLTIpIi8+CjxtYXNrIGlkPSJwYXRoLTE1LWluc2lkZS0zIiBmaWxsPSJ3aGl0ZSI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTguNTc5IDEwLjYzNzVDMTguNTA3IDEwLjQ0MTkgMTguNjA4MSAxMC4yMjUxIDE4LjgwNDMgMTAuMTU0NUwyMS42NjIgOS4xMjYyMUMyMS44NTYxIDkuMDU2MzUgMjIuMDcwMiA5LjE1NjE5IDIyLjE0MTUgOS4zNDk4VjkuMzQ5OEMyMi4yMTM1IDkuNTQ1NDIgMjIuMTEyNCA5Ljc2MjI2IDIxLjkxNjIgOS44MzI4NEwxOS4wNTg1IDEwLjg2MTFDMTguODY0NCAxMC45MzEgMTguNjUwMyAxMC44MzExIDE4LjU3OSAxMC42Mzc1VjEwLjYzNzVaIi8+CjwvbWFzaz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xOC41NzkgMTAuNjM3NUMxOC41MDcgMTAuNDQxOSAxOC42MDgxIDEwLjIyNTEgMTguODA0MyAxMC4xNTQ1TDIxLjY2MiA5LjEyNjIxQzIxLjg1NjEgOS4wNTYzNSAyMi4wNzAyIDkuMTU2MTkgMjIuMTQxNSA5LjM0OThWOS4zNDk4QzIyLjIxMzUgOS41NDU0MiAyMi4xMTI0IDkuNzYyMjYgMjEuOTE2MiA5LjgzMjg0TDE5LjA1ODUgMTAuODYxMUMxOC44NjQ0IDEwLjkzMSAxOC42NTAzIDEwLjgzMTEgMTguNTc5IDEwLjYzNzVWMTAuNjM3NVoiIGZpbGw9IiNEOEQ4RDgiLz4KPHBhdGggZD0iTTE5LjE0MjggMTEuMDk1NEwyMi4wMDA1IDEwLjA2NzFMMjEuMzIzNCA4LjE4NTI3TDE4LjQ2NTcgOS4yMTM1NkwxOS4xNDI4IDExLjA5NTRaTTIxLjU3NzYgOC44OTE5MUwxOC43MiA5LjkyMDJMMTkuMzk3MSAxMS44MDIxTDIyLjI1NDggMTAuNzczOEwyMS41Nzc2IDguODkxOTFaTTE4LjcyIDkuOTIwMkMxOS4wNDI4IDkuODA0MDMgMTkuMzk4OSA5Ljk3MDA4IDE5LjUxNzQgMTAuMjkyMUwxNy42NDA2IDEwLjk4M0MxNy45MDE3IDExLjY5MjIgMTguNjg2IDEyLjA1NzkgMTkuMzk3MSAxMS44MDIxTDE4LjcyIDkuOTIwMlpNMjEuMjAzIDkuNjk1MjhDMjEuMDgzMyA5LjM2OTkzIDIxLjI1MTQgOS4wMDkyOSAyMS41Nzc2IDguODkxOTFMMjIuMjU0OCAxMC43NzM4QzIyLjk3MzMgMTAuNTE1MiAyMy4zNDM3IDkuNzIwOTEgMjMuMDc5OSA5LjAwNDMxTDIxLjIwMyA5LjY5NTI4Wk0yMi4wMDA1IDEwLjA2NzFDMjEuNjc3NyAxMC4xODMzIDIxLjMyMTYgMTAuMDE3MyAyMS4yMDMgOS42OTUyOEwyMy4wNzk5IDkuMDA0MzFDMjIuODE4OCA4LjI5NTEyIDIyLjAzNDUgNy45MjkzOSAyMS4zMjM0IDguMTg1MjdMMjIuMDAwNSAxMC4wNjcxWk0xOC40NjU3IDkuMjEzNTZDMTcuNzQ3MiA5LjQ3MjExIDE3LjM3NjggMTAuMjY2NCAxNy42NDA2IDEwLjk4M0wxOS41MTc0IDEwLjI5MjFDMTkuNjM3MiAxMC42MTc0IDE5LjQ2OTEgMTAuOTc4MSAxOS4xNDI4IDExLjA5NTRMMTguNDY1NyA5LjIxMzU2WiIgZmlsbD0iI0NEQ0RDRCIgbWFzaz0idXJsKCNwYXRoLTE1LWluc2lkZS0zKSIvPgo8bWFzayBpZD0icGF0aC0xNy1pbnNpZGUtNCIgZmlsbD0id2hpdGUiPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE3LjE3NzcgOC43MDA5NUMxNy4wNDIgOC41NDEwNSAxNy4wNjI5IDguMzAxMDkgMTcuMjI0NCA4LjE2NzE4TDE5LjU1MDEgNi4yMzc4NkMxOS43MDg5IDYuMTA2MDYgMTkuOTQ0MyA2LjEyNjY1IDIwLjA3NzkgNi4yODQwM1Y2LjI4NDAzQzIwLjIxMzYgNi40NDM5NCAyMC4xOTI2IDYuNjgzOSAyMC4wMzEyIDYuODE3ODFMMTcuNzA1NSA4Ljc0NzEzQzE3LjU0NjYgOC44Nzg5MiAxNy4zMTEyIDguODU4MzMgMTcuMTc3NyA4LjcwMDk1VjguNzAwOTVaIi8+CjwvbWFzaz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNy4xNzc3IDguNzAwOTVDMTcuMDQyIDguNTQxMDUgMTcuMDYyOSA4LjMwMTA5IDE3LjIyNDQgOC4xNjcxOEwxOS41NTAxIDYuMjM3ODZDMTkuNzA4OSA2LjEwNjA2IDE5Ljk0NDMgNi4xMjY2NSAyMC4wNzc5IDYuMjg0MDNWNi4yODQwM0MyMC4yMTM2IDYuNDQzOTQgMjAuMTkyNiA2LjY4MzkgMjAuMDMxMiA2LjgxNzgxTDE3LjcwNTUgOC43NDcxM0MxNy41NDY2IDguODc4OTIgMTcuMzExMiA4Ljg1ODMzIDE3LjE3NzcgOC43MDA5NVY4LjcwMDk1WiIgZmlsbD0iI0Q4RDhEOCIvPgo8cGF0aCBkPSJNMTcuMjI0NCA4LjE2NzE4TDE2LjU4NTkgNy4zOTc1M0wxNy4yMjQ0IDguMTY3MThaTTE3Ljg2MjggOC45MzY4MkwyMC4xODg1IDcuMDA3NUwxOC45MTE2IDUuNDY4MjFMMTYuNTg1OSA3LjM5NzUzTDE3Ljg2MjggOC45MzY4MlpNMTkuMzkyNyA2LjA0ODE2TDE3LjA2NyA3Ljk3NzQ4TDE4LjM0MzkgOS41MTY3N0wyMC42Njk2IDcuNTg3NDVMMTkuMzkyNyA2LjA0ODE2Wk0xNy4wNjcgNy45Nzc0OEMxNy4zMjk4IDcuNzU5NDYgMTcuNzE5MSA3Ljc5MzUyIDE3Ljk0MDEgOC4wNTM4NkwxNi40MTUzIDkuMzQ4MDRDMTYuOTAzNCA5LjkyMzE1IDE3Ljc2MzQgOS45OTgzOCAxOC4zNDM5IDkuNTE2NzdMMTcuMDY3IDcuOTc3NDhaTTE5LjMxNTUgNi45MzExMkMxOS4wOTEgNi42NjY2MSAxOS4xMjU3IDYuMjY5NjggMTkuMzkyNyA2LjA0ODE2TDIwLjY2OTYgNy41ODc0NUMyMS4yNTk1IDcuMDk4MTEgMjEuMzM2MiA2LjIyMTI3IDIwLjg0MDMgNS42MzY5NEwxOS4zMTU1IDYuOTMxMTJaTTIwLjE4ODUgNy4wMDc1QzE5LjkyNTcgNy4yMjU1MiAxOS41MzY0IDcuMTkxNDYgMTkuMzE1NSA2LjkzMTEyTDIwLjg0MDMgNS42MzY5NEMyMC4zNTIyIDUuMDYxODQgMTkuNDkyMiA0Ljk4NjYgMTguOTExNiA1LjQ2ODIxTDIwLjE4ODUgNy4wMDc1Wk0xNi41ODU5IDcuMzk3NTNDMTUuOTk2IDcuODg2ODcgMTUuOTE5MyA4Ljc2MzcxIDE2LjQxNTMgOS4zNDgwNEwxNy45NDAxIDguMDUzODZDMTguMTY0NiA4LjMxODM4IDE4LjEyOTkgOC43MTUzMSAxNy44NjI4IDguOTM2ODJMMTYuNTg1OSA3LjM5NzUzWiIgZmlsbD0iI0NEQ0RDRCIgbWFzaz0idXJsKCNwYXRoLTE3LWluc2lkZS00KSIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTI0IDEzQzI3LjMxMzcgMTMgMzAgMTAuMzEzNyAzMCA3QzMwIDMuNjg2MjkgMjcuMzEzNyAxIDI0IDFDMjAuNjg2MyAxIDE4IDMuNjg2MjkgMTggN0MxOCAxMC4zMTM3IDIwLjY4NjMgMTMgMjQgMTNaIiBmaWxsPSJ3aGl0ZSIgc3Ryb2tlPSIjN0E3QTdBIi8+CjxwYXRoIGQ9Ik0yMS45ODE5IDYuNzYzMDhMMjMuNjMwNSA4LjU3NDExIiBzdHJva2U9IiM4QUM5QjEiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPHBhdGggZD0iTTI2LjE0OTUgNS4zNTY3NEwyMy43MjY3IDguNDcwOTIiIHN0cm9rZT0iIzhBQzlCMSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K"

/***/ }),
/* 959 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.7653a68.png";

/***/ }),
/* 961 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiICB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgIDxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0xNC4wNiw5TDE1LDkuOTRMNS45MiwxOUg1VjE4LjA4TDE0LjA2LDlNMTcuNjYsM0MxNy40MSwzIDE3LjE1LDMuMSAxNi45NiwzLjI5TDE1LjEzLDUuMTJMMTguODgsOC44N0wyMC43MSw3LjA0QzIxLjEsNi42NSAyMS4xLDYgMjAuNzEsNS42M0wxOC4zNywzLjI5QzE4LjE3LDMuMDkgMTcuOTIsMyAxNy42NiwzTTE0LjA2LDYuMTlMMywxNy4yNVYyMUg2Ljc1TDE3LjgxLDkuOTRMMTQuMDYsNi4xOVoiIC8+Cjwvc3ZnPg=="

/***/ }),
/* 962 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAyMSAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0LjUgNy41SDIwLjUiIHN0cm9rZT0iIzk3OTc5NyIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIgc3Ryb2tlLWRhc2hhcnJheT0iMiIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTMuMzQ3OTEgNS42MjgzOEM0LjYyNzI2IDYuMzE4NzQgNi4xMzAwOSA2LjEyNDQ2IDYuNzA0NTggNS4xOTQ0NUM3LjI3OTA4IDQuMjY0NDMgNi43MDc2OCAyLjk1MDg2IDUuNDI4MzMgMi4yNjA1MUM0LjE0ODk4IDEuNTcwMTUgMi42NDYxNCAxLjc2NDQzIDIuMDcxNjUgMi42OTQ0NUMxLjQ5NzE2IDMuNjI0NDYgMi4wNjg1NiA0LjkzODAzIDMuMzQ3OTEgNS42MjgzOFoiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMiIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTYuNjQzMTggNC45MzkyMUwxOC4zNzQ1IDEwLjc1NzZMMTcuMDg2NyAxMS4zNjY0TDQuNDQ3NTEgNi4xODA5M0w2LjY0MzE4IDQuOTM5MjFaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTMuMzQ3OTEgOS4zNzE2MkM0LjYyNzI2IDguNjgxMjYgNi4xMzAwOSA4Ljg3NTU0IDYuNzA0NTggOS44MDU1NUM3LjI3OTA4IDEwLjczNTYgNi43MDc2OCAxMi4wNDkxIDUuNDI4MzMgMTIuNzM5NUM0LjE0ODk4IDEzLjQyOTggMi42NDYxNCAxMy4yMzU2IDIuMDcxNjUgMTIuMzA1NkMxLjQ5NzE2IDExLjM3NTUgMi4wNjg1NiAxMC4wNjIgMy4zNDc5MSA5LjM3MTYyWiIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNi42NDMxOCAxMC4wNjA4TDE4LjM3NDUgNC4yNDI0TDE3LjA4NjcgMy42MzM2NEw0LjQ0NzUxIDguODE5MDdMNi42NDMxOCAxMC4wNjA4WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg=="

/***/ }),
/* 963 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjciIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyNyAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zLjM0NzkxIDExLjYyODRDNC42MjcyNiAxMi4zMTg3IDYuMTMwMDkgMTIuMTI0NSA2LjcwNDU4IDExLjE5NDRDNy4yNzkwOCAxMC4yNjQ0IDYuNzA3NjggOC45NTA4NiA1LjQyODMzIDguMjYwNTFDNC4xNDg5OCA3LjU3MDE1IDIuNjQ2MTQgNy43NjQ0MyAyLjA3MTY1IDguNjk0NDVDMS40OTcxNiA5LjYyNDQ2IDIuMDY4NTYgMTAuOTM4IDMuMzQ3OTEgMTEuNjI4NFoiIGZpbGw9IndoaXRlIiBzdHJva2U9IiNDRENEQ0QiIHN0cm9rZS13aWR0aD0iMiIvPgo8cGF0aCBkPSJNNS41OTAwMyAxMi4xMDkyTDYuNjU4NTQgMTEuNTA0OUwxNy4yMjc0IDE2Ljc0NjhMMTcuMDcyNCAxNi44MjAxTDUuNTkwMDMgMTIuMTA5MloiIGZpbGw9ImJsYWNrIiBzdHJva2U9IiNDRENEQ0QiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zLjM0NzkxIDE1LjM3MTZDNC42MjcyNiAxNC42ODEzIDYuMTMwMDkgMTQuODc1NSA2LjcwNDU4IDE1LjgwNTZDNy4yNzkwOCAxNi43MzU2IDYuNzA3NjggMTguMDQ5MSA1LjQyODMzIDE4LjczOTVDNC4xNDg5OCAxOS40Mjk4IDIuNjQ2MTQgMTkuMjM1NiAyLjA3MTY1IDE4LjMwNTZDMS40OTcxNiAxNy4zNzU1IDIuMDY4NTYgMTYuMDYyIDMuMzQ3OTEgMTUuMzcxNloiIGZpbGw9IndoaXRlIiBzdHJva2U9IiNDRENEQ0QiIHN0cm9rZS13aWR0aD0iMiIvPgo8cGF0aCBkPSJNNS41OTAwMyAxNC44OTA4TDYuNjU4NTQgMTUuNDk1MUwxNy4yMjc0IDEwLjI1MzJMMTcuMDcyNCAxMC4xNzk5TDUuNTkwMDMgMTQuODkwOFoiIGZpbGw9ImJsYWNrIiBzdHJva2U9IiNDRENEQ0QiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMCAxM0MyMy4zMTM3IDEzIDI2IDEwLjMxMzcgMjYgN0MyNiAzLjY4NjI5IDIzLjMxMzcgMSAyMCAxQzE2LjY4NjMgMSAxNCAzLjY4NjI5IDE0IDdDMTQgMTAuMzEzNyAxNi42ODYzIDEzIDIwIDEzWiIgZmlsbD0id2hpdGUiIHN0cm9rZT0iIzdBN0E3QSIvPgo8cGF0aCBkPSJNMTcuOTgxOSA2Ljc2MzA4TDE5LjYzMDUgOC41NzQxMSIgc3Ryb2tlPSIjOEFDOUIxIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjxwYXRoIGQ9Ik0yMi4xNDk1IDUuMzU2NzRMMTkuNzI2NyA4LjQ3MDkyIiBzdHJva2U9IiM4QUM5QjEiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg=="

/***/ }),
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(929)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(431),
  /* template */
  __webpack_require__(1067),
  /* scopeId */
  "data-v-b884a6d8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(432),
  /* template */
  __webpack_require__(1052),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(433),
  /* template */
  __webpack_require__(1037),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(933)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(434),
  /* template */
  __webpack_require__(1075),
  /* scopeId */
  "data-v-fd032756",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(435),
  /* template */
  __webpack_require__(1051),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(436),
  /* template */
  __webpack_require__(1050),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(437),
  /* template */
  __webpack_require__(1046),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(438),
  /* template */
  __webpack_require__(1073),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(439),
  /* template */
  __webpack_require__(1026),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(441),
  /* template */
  __webpack_require__(1023),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(443),
  /* template */
  __webpack_require__(1066),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(445),
  /* template */
  __webpack_require__(1072),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(447),
  /* template */
  __webpack_require__(1074),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(927)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(448),
  /* template */
  __webpack_require__(1063),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(449),
  /* template */
  __webpack_require__(1029),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(916)
__webpack_require__(917)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(450),
  /* template */
  __webpack_require__(1035),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(451),
  /* template */
  __webpack_require__(1053),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(454),
  /* template */
  __webpack_require__(1021),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(455),
  /* template */
  __webpack_require__(1034),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(456),
  /* template */
  __webpack_require__(1064),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(457),
  /* template */
  __webpack_require__(1039),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(458),
  /* template */
  __webpack_require__(1042),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(910)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(459),
  /* template */
  __webpack_require__(1016),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(463),
  /* template */
  __webpack_require__(1018),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(465),
  /* template */
  __webpack_require__(1040),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(926)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(466),
  /* template */
  __webpack_require__(1062),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(922)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(467),
  /* template */
  __webpack_require__(1058),
  /* scopeId */
  "data-v-75c5f7a3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(918)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(469),
  /* template */
  __webpack_require__(1041),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(914)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(472),
  /* template */
  __webpack_require__(1030),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(474),
  /* template */
  __webpack_require__(1032),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(475),
  /* template */
  __webpack_require__(1038),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(911)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(476),
  /* template */
  __webpack_require__(1017),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(920)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(479),
  /* template */
  __webpack_require__(1045),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(924)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(480),
  /* template */
  __webpack_require__(1060),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(481),
  /* template */
  __webpack_require__(1020),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(925)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(482),
  /* template */
  __webpack_require__(1061),
  /* scopeId */
  "data-v-80479a14",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(915)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(483),
  /* template */
  __webpack_require__(1033),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(484),
  /* template */
  __webpack_require__(1019),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(485),
  /* template */
  __webpack_require__(1070),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(486),
  /* template */
  __webpack_require__(1049),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(487),
  /* template */
  __webpack_require__(1056),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(934)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(488),
  /* template */
  __webpack_require__(1076),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(489),
  /* template */
  __webpack_require__(1031),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(490),
  /* template */
  __webpack_require__(1025),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(491),
  /* template */
  __webpack_require__(1036),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1015 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#",
      "loading": _vm.isLoading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.performSynchronization($event)
      }
    }
  }, [_c('span', {
    class: ['glyphicon', 'glyphicon-refresh', {
      'spin': _vm.isLoading
    }]
  }), _vm._v("\n  " + _vm._s(_vm.$t('marker.ftp.synchronize')) + "\n")])
},staticRenderFns: []}

/***/ }),
/* 1016 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tag-filter"
  }, [_c('multiselect', {
    attrs: {
      "placeholder": _vm.$tc('user.filter.consumer'),
      "label": "full_name",
      "track-by": "full_name",
      "options": _vm.optionsEditorConsumers,
      "searchable": false,
      "multiple": ""
    },
    on: {
      "input": _vm.inputHandler
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('div', {
          staticClass: "option__desc"
        }, [_c('span', {
          staticClass: "option__title"
        }, [_vm._v(_vm._s(props.option.full_name))])])]
      }
    }]),
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1017 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-7 col-md-12"
  }, [_c('div', {
    staticClass: "input-group input-date",
    attrs: {
      "id": _vm.attrs.id + '-datepicker'
    }
  }, [(!_vm.hackyReload) ? _c('flat-pickr', {
    staticClass: "form-control",
    attrs: {
      "id": _vm.attrs.id + '-date',
      "placeholder": _vm.attrs.placeholder,
      "disabled": _vm.attrs.disabled,
      "value": _vm.valueDate,
      "config": _vm.calendarConfig
    },
    on: {
      "input": _vm.updateDate
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default btn-number",
    attrs: {
      "type": "button",
      "disabled": _vm.attrs.disabled,
      "data-toggle": ""
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5 col-md-12"
  }, [_c('div', {
    staticClass: "input-group input-time"
  }, [_c('vue-clock-picker', {
    ref: "clockpicker",
    attrs: {
      "input-class": "hidden",
      "value": _vm.valueTime
    },
    on: {
      "timeset": _vm.setTimeValue
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "pattern": "\\d{2}:\\d{2}",
      "id": _vm.attrs.id + '-time',
      "placeholder": _vm.attrs.placeholder,
      "disabled": _vm.attrs.disabled,
      "required": ""
    },
    domProps: {
      "value": _vm.valueTime
    },
    on: {
      "change": _vm.inputTimeChangeHandler,
      "focus": function($event) {
        $event.stopPropagation();
      },
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default btn-number",
    attrs: {
      "type": "button",
      "disabled": _vm.attrs.disabled
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showPicker()
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-time"
  })])])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1018 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.tags.length > 0) ? _c('div', {
    staticClass: "mltags"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mldata-details"
  }, [(typeof _vm.record.mldata.relevance !== 'undefined' && _vm.record.mldata.relevance !== null) ? _c('p', [_c('strong', [_vm._v("Relevance")]), _vm._v(":\n        " + _vm._s(_vm._f("round")(_vm.record.mldata.relevance)) + "\n        "), (_vm.record.mldata.keyword) ? _c('span', [_vm._v("\n          (" + _vm._s(_vm.record.mldata.keyword) + ")\n        ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (typeof _vm.record.mldata.consistency !== 'undefined' && _vm.record.mldata.consistency !== null) ? _c('p', [_c('strong', [_vm._v("Consistency")]), _vm._v(": " + _vm._s(_vm._f("round")(_vm.record.mldata.consistency)) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "mltags-table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_vm._l((_vm.manualTags), function(tag, mIndex) {
    return _c('tr', {
      key: tag.category + mIndex
    }, [_c('td', [_vm._v(_vm._s(tag.category))]), _vm._v(" "), (tag.weight) ? _c('td', [_vm._v(_vm._s(Math.round(tag.weight * 10000000) / 1000))]) : _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(tag.frames))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("round")(tag.accuracy)))])])
  }), _vm._v(" "), _vm._l((_vm.mlTags), function(tag, mlIndex) {
    return _c('tr', {
      key: mlIndex
    }, [_c('td', [_vm._v(_vm._s(tag.category))]), _vm._v(" "), (tag.weight) ? _c('td', [_vm._v(_vm._s(Math.round(tag.weight * 10000000) / 1000))]) : _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(tag.frames))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("round")(tag.accuracy)))])])
  })], 2)])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tags-toggle"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-tags"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Category")]), _vm._v(" "), _c('th', [_vm._v("Weight")]), _vm._v(" "), _c('th', [_vm._v("# Frames")]), _vm._v(" "), _c('th', [_vm._v("Accuracy")])])])
}]}

/***/ }),
/* 1019 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-md-4 col-sm-10"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'marker',
        params: {
          markerId: _vm.marker.id
        }
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.getLocalizedProp(_vm.marker.name)))])]), _vm._v(" "), _c('router-link', {
    staticClass: "glyphicon glyphicon-pencil clickable edit",
    attrs: {
      "aria-hidden": "true",
      "tag": "span",
      "to": {
        path: ("/marker/" + (_vm.marker.id) + "/edit")
      }
    }
  }), _vm._v(" "), _c('confirm-modal', {
    staticClass: "trash-marker",
    attrs: {
      "cancel-label": _vm.$t('cancel'),
      "confirm-label": _vm.$t('delete')
    },
    on: {
      "confirm": function($event) {
        return _vm.deleteMarker(_vm.marker)
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-trash clickable edit",
    attrs: {
      "slot": "trigger",
      "aria-hidden": "true"
    },
    slot: "trigger"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('marker.delete_confirmation')))]), _vm._v(" "), _c('div', {
    staticClass: "well"
  }, [_vm._v(_vm._s(_vm.getLocalizedProp(_vm.marker.name)))])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-6 col-xs-6"
  }, [_c('span', {
    staticClass: "visible-sm-inline visible-xs"
  }, [_vm._v(_vm._s(_vm.$t('marker.targeted_groups'))), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('spacing'))
    }
  }), _vm._v(":")]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.joined_targeted_groups))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-6 col-xs-6"
  }, [_c('span', {
    staticClass: "visible-sm-inline visible-xs"
  }, [_vm._v(_vm._s(_vm.$t('marker.start_date'))), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('spacing'))
    }
  }), _vm._v(":")]), _vm._v(" "), _c('date', {
    attrs: {
      "value": _vm.marker.starts_at
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-6 col-xs-6"
  }, [_c('span', {
    staticClass: "visible-sm-inline visible-xs"
  }, [_vm._v(_vm._s(_vm.$t('marker.end_date'))), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('spacing'))
    }
  }), _vm._v(":")]), _vm._v(" "), _c('date', {
    attrs: {
      "value": _vm.marker.ends_at
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-12"
  }, [_vm._v("\n    " + _vm._s(_vm.marker.records_count) + "\n    "), _c('span', {
    staticClass: "visible-sm-inline visible-xs-inline"
  }, [_vm._v(" " + _vm._s(_vm.$tc('records.video', _vm.marker.records_count >= 2 ? 2 : 1)))])])])
},staticRenderFns: []}

/***/ }),
/* 1020 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "map-preview",
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "min-height": "300px",
      "min-width": "300px"
    },
    attrs: {
      "id": ("map-preview-" + _vm.id)
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 1021 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 marker-details"
  }, [_c('h3', [_c('span', {
    staticClass: "highlight"
  }, [_vm._v(_vm._s(_vm.$t("marker.event")) + ":")]), _vm._v("\n      " + _vm._s(_vm.getLocalizedProp(_vm.marker.name)) + "\n      "), _c('dropdown', {
    staticClass: "event-options"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-option-horizontal clickable options-trigger",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu show",
    attrs: {
      "slot": "options"
    },
    slot: "options"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: ("/marker/" + (_vm.marker.id) + "/edit")
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-pencil"
  }), _vm._v("\n              " + _vm._s(_vm.$t('marker.edit')) + "\n            ")])], 1), _vm._v(" "), _c('li', {
    class: {
      'disabled': !_vm.hasStarted
    }
  }, [_c('a', _vm._g({
    attrs: {
      "href": "#"
    }
  }, _vm.hasStarted ? {
    click: _vm.downloadCsv
  } : {
    click: function (e) { return e.stopPropagation(); }
  }), [_c('span', {
    staticClass: "glyphicon glyphicon-download-alt"
  }), _vm._v("\n              " + _vm._s(_vm.$t('marker.download_csv')) + "\n            ")])]), _vm._v(" "), _c('li', [_c('ftp-sync-button', {
    attrs: {
      "marker-id": _vm.marker.id
    }
  })], 1)])])], 1), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "highlight"
  }, [_vm._v(_vm._s(_vm.$t("marker.start_date")) + ":")]), _vm._v(" "), _c('date', {
    attrs: {
      "value": _vm.marker.starts_at
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "separator"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    staticClass: "highlight"
  }, [_vm._v(_vm._s(_vm.$t("marker.end_date")) + ":")]), _vm._v(" "), _c('date', {
    attrs: {
      "value": _vm.marker.ends_at
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1022 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dropdown",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showOptions = !_vm.showOptions
      }
    }
  }, [_c('div', {
    staticClass: "trigger"
  }, [_vm._t("trigger")], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "dropdown"
    }
  }, [(_vm.showOptions) ? _vm._t("options") : _vm._e()], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1023 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-mask",
    attrs: {
      "transition": "modal"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container modal-transition-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_vm._t("content")], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.cancel($event)
      }
    }
  }, [_vm._t("cancel", [_vm._v(_vm._s(_vm.$t('cancel')))])], 2), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.ok($event)
      }
    }
  }, [_vm._t("ok", [_vm._v(_vm._s(_vm.$t('ok')))])], 2)])])])])
},staticRenderFns: []}

/***/ }),
/* 1024 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    on: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  }, [_vm._t("trigger")], 2), _vm._v(" "), (_vm.showModal) ? _c('div', {
    staticClass: "modal-mask",
    attrs: {
      "transition": "modal"
    },
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container modal-transition-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_vm._t("content")], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.cancel($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.cancelLabel))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.ok($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.confirmLabel))])])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1025 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-wrapper"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$tc('user.filter.name')
    },
    domProps: {
      "value": _vm.search
    },
    on: {
      "input": _vm.inputHandler
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 1026 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "top-slide"
    }
  }, [_c('div', {
    staticClass: "update-prompt"
  }, [_c('div', {}, [_c('h3', [_vm._v(_vm._s(_vm.$t('update_available')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('update_prompt')))])]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.reload
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-refresh"
  }), _vm._v("\n      " + _vm._s(_vm.$t('update')) + "\n    ")])])])
},staticRenderFns: []}

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "data-app": ""
    }
  }, [(_vm.clientId === 'digiteka') ? _c('link', {
    attrs: {
      "rel": "stylesheet",
      "href": "/static/css/digiteka.css",
      "type": "text/css",
      "media": "all"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "container",
    attrs: {
      "flat": "",
      "id": "top-bar"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "logo-wrap"
  }, [(_vm.$store.state.consumerLogo) ? _c('img', {
    attrs: {
      "src": _vm.$store.state.consumerLogo,
      "alt": "logo"
    }
  }) : _c('img', {
    attrs: {
      "src": __webpack_require__(960),
      "alt": "logo"
    }
  })]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', {
    staticClass: "top-menu"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/videos/new',
        exact: true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.videos')))]), _vm._v(" "), (_vm.$store.state.consumerGroup == 'ebra') ? _c('router-link', {
    attrs: {
      "to": {
        path: '/images/new',
        exact: true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.images')))]) : _vm._e(), _vm._v(" "), (_vm.$store.state.is_manager) ? [_c('router-link', {
    attrs: {
      "to": {
        path: '/user',
        exact: true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.users')))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: '/settings',
        exact: true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.settings')))])] : _vm._e(), _vm._v(" "), (_vm.$store.state.authenticated) ? [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.logout($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('logout')))])] : [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.logout($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('login')))])], _vm._v(" "), _c('div', {
    staticClass: "dropdown locale-menu"
  }, [_c('a', {
    staticClass: "clickable dropdown-toggle",
    on: {
      "click": function($event) {
        _vm.dropdownToggle = !_vm.dropdownToggle
      }
    }
  }, [_vm._v(_vm._s(_vm.currentLocale) + " "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    class: {
      'show': _vm.dropdownToggle
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.updateLocale('en')
      }
    }
  }, [_vm._v("en")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.updateLocale('fr')
      }
    }
  }, [_vm._v("fr")])])])])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('service-message'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('error-display', {
    staticClass: "error-display"
  }), _vm._v(" "), (_vm.updateAvailable) ? _c('update-prompt') : _vm._e(), _vm._v(" "), _c('modal-record-player'), _vm._v(" "), _c('snack-bar')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1028 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": _vm.elementId
    },
    on: {
      "mousemove": function($event) {
        return _vm.setSprite($event)
      },
      "mouseout": function($event) {
        return _vm.clearSprite()
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.spriteOffset === null),
      expression: "spriteOffset === null"
    }],
    staticClass: "thumbnail-default",
    style: (_vm.defaultStyling)
  }), _vm._v(" "), _c('div', {
    staticClass: "thumbnail-previews",
    class: {
      'invisible': _vm.spriteOffset === null
    },
    style: ([_vm.baseThumbsStyling, _vm.activeThumbsStyling])
  })])
},staticRenderFns: []}

/***/ }),
/* 1029 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 marker-details"
  }, [_c('h3', [_c('span', {
    staticClass: "highlight"
  }, [_vm._v(_vm._s(_vm.$t('individual_records')))]), _vm._v(" "), _c('Menu')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1030 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-radio-group', {
    staticClass: "sdk_filter",
    attrs: {
      "row": true
    },
    on: {
      "change": _vm.changeValue
    },
    model: {
      value: (_vm.val),
      callback: function($$v) {
        _vm.val = $$v
      },
      expression: "val"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": _vm.$t('all'),
      "value": ""
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": _vm.$t('Pro Apps'),
      "value": "no_sdk"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "SDK",
      "value": "sdk"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1031 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-records"
  }, [_c('v-tabs', {
    attrs: {
      "fixed-tabs": "",
      "slider-color": "#ff2d55"
    },
    on: {
      "change": _vm.tabSelected
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-tab', [_vm._v("\n        Approved\n      ")]), _vm._v(" "), _c('v-tab', [_vm._v("\n        Deleted\n      ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading && !_vm.records.length),
      expression: "loading && !records.length"
    }],
    staticClass: "loading-indicator center-block"
  }), _vm._v(" "), _c('records-list', {
    attrs: {
      "records": _vm.records
    },
    on: {
      "delete-record": _vm.handleRecordDelete,
      "restore-record": _vm.handleRecordRestore,
      "mark-record-relevance": _vm.markRecordRelevance,
      "clicked-record": _vm.showRecordDetails
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading && _vm.records.length),
      expression: "!loading && records.length"
    }]
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.calculateAmountPages('VIDEO'),
      "total-visible": 10
    },
    on: {
      "input": function($event) {
        return _vm.fetchRecords('VIDEO')
      }
    },
    model: {
      value: (_vm.recordsPage),
      callback: function($$v) {
        _vm.recordsPage = $$v
      },
      expression: "recordsPage"
    }
  })], 1), _vm._v(" "), (_vm.imageRecords.length > 0) ? _c('div', [_c('h2', [_vm._v("Images")]), _vm._v(" "), _c('div', [_c('records-list', {
    attrs: {
      "records": _vm.imageRecords
    },
    on: {
      "delete-record": _vm.handleRecordDelete,
      "restore-record": _vm.handleRecordRestore,
      "mark-record-relevance": _vm.markRecordRelevance,
      "clicked-record": _vm.showRecordDetails
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.calculateAmountPages('IMAGE'),
      "total-visible": 10
    },
    on: {
      "input": function($event) {
        return _vm.fetchRecords('IMAGE')
      }
    },
    model: {
      value: (_vm.recordsPage),
      callback: function($$v) {
        _vm.recordsPage = $$v
      },
      expression: "recordsPage"
    }
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.selectedRecord) ? _c('record-details', {
    attrs: {
      "record": _vm.selectedRecord
    },
    on: {
      "clicked-similar-record": _vm.showRecordDetails,
      "close": function($event) {
        _vm.selectedRecord = null
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1032 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "modal-mask",
    attrs: {
      "transition": "modal"
    },
    on: {
      "click": _vm.hide
    }
  }, [_c('div', {
    staticClass: "video-modal-wrapper"
  }, [_c('div', {
    staticClass: "video-modal-container modal-transition-container"
  }, [_vm._t("loading"), _vm._v(" "), _vm._t("body")], 2)])])
},staticRenderFns: []}

/***/ }),
/* 1033 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "user-group-selection-container"
  }, [(_vm.selectedGroupsCount > 0) ? _c('p', [_vm._v("\n      " + _vm._s(_vm.$tc('marker.selected_user_groups_count',
    _vm.selectedGroupsCount >= 2 ? 2 : 1, {
      count: _vm.selectedGroupsCount
    })) + "\n      "), _c('span', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.toggleShowSelection($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('marker.user_group_click_here')))]), _vm._v("\n        " + _vm._s(_vm.$t('marker.user_group_to_change_selection')) + "\n      ")])]) : _c('p', [_vm._v("\n      " + _vm._s(_vm.$t('marker.all_users_will_be_notified')) + "\n      "), _c('span', [_vm._v("\n        " + _vm._s(_vm.$t('marker.user_group_you_may')) + "\n        "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.toggleShowSelection($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('marker.user_group_specify')))]), _vm._v("\n        " + _vm._s(_vm.$t('marker.user_group_which_groups_to_target')) + "\n      ")])]), _vm._v(" "), (_vm.showSelection) ? _c('div', {
    staticClass: "user-group-selection",
    style: ({
      top: _vm.tooltipPosition.y + 'px',
      left: _vm.tooltipPosition.x + 'px'
    })
  }, [_c('div', {
    staticClass: "user-group-selection-header"
  }, [_c('div', [_vm._v("\n          " + _vm._s(_vm.$t('marker.user_group_categories')) + "\n        ")]), _vm._v(" "), _c('div', [_vm._v("\n          " + _vm._s(_vm.$t('marker.user_groups')) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "user-group-selection-content"
  }, [_c('ul', {
    staticClass: "user-group-category"
  }, _vm._l((_vm.groups), function(category) {
    return _c('li', {
      class: {
        'selected': _vm.shownCategory === category.slug
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.showCategory = category.slug
        }
      }
    }, [_vm._v("\n            " + _vm._s(category.name) + " "), _c('span', {
      staticClass: "glyphicon glyphicon-chevron-right"
    })])
  }), 0), _vm._v(" "), _c('ul', {
    staticClass: "user-group"
  }, [_vm._l((_vm.groups), function(category) {
    return _vm._l((category.groups), function(group) {
      return _c('li', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (category.slug === _vm.shownCategory),
          expression: "category.slug === shownCategory"
        }],
        class: {
          'selected': _vm.isSelected(category, group)
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.toggle(category, group)
          }
        }
      }, [_vm._v("\n            " + _vm._s(group.name) + "\n            "), _c('span', {
        staticClass: "glyphicon glyphicon-ok-circle"
      })])
    })
  })], 2)])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 1034 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "marker-map",
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "min-height": "300px",
      "min-width": "300px"
    },
    attrs: {
      "id": ("marker-map-" + _vm.id)
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 1035 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.consumerName) ? [(!_vm.isLmrConsumer) ? _c('Details') : _vm._e(), _vm._v(" "), (_vm.$store.state.consumerGroup == 'ebra') ? _c('div', [_c('div', {
    staticClass: "marker-details"
  }, [(_vm.showVideos) ? _c('h3', {
    staticClass: "highlight"
  }, [_vm._v(_vm._s(_vm.$tc('records.video', 2)))]) : _vm._e(), _vm._v(" "), (_vm.showImages) ? _c('h3', {
    staticClass: "highlight"
  }, [_vm._v("Images")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "records-information row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.records.length && !_vm.isLmrConsumer) ? _c('p', [_c('span', {
    staticClass: "highlight"
  }, [_vm._v("\n              " + _vm._s(_vm.records.length) + " " + _vm._s(_vm.$tc('records.video', _vm.records.length >= 2 ? 2 : 1)) + "\n            ")]), _vm._v("\n            " + _vm._s(_vm.$tc('records.has_been_recorded', _vm.records.length >= 2 ? 2 : 1)) + "\n            "), (_vm.diversityTree) ? _c('span', [_c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#",
      "title": "show dendrogram"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showTree = !_vm.showTree
      }
    }
  }, [_c('img', {
    staticStyle: {
      "height": "16px",
      "cursor": "pointer",
      "opacity": "0.7"
    },
    attrs: {
      "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAALuSURBVHhe7dw9aFRBFMXx1SiCiAgiCBpBUPGrtBA7G5s0NqlsLG2tg42VlY32NlZ+YGNjY2GjYGkhWAiCEBC/RRBJ1HPhFctyJmPeuzOTvHt+8K/cLOQmuW72Td5ERERERERERERk5ObRA/Qd/R2YPcdDdBTJfziIPiE2zCHZc9pzS8Z9xAbo0T0kGT8QG55H35BksMF5JhlsaJ5JBhuaZ5LBhuaZZLCheSZr2I3Y0DyThNPoDWJD80yIy+gnYgPzTqbsRHcQG1SppHMcvUJsSCUTuIRKvuWwVqHtQLcRG0ytwjqMXiI2lJqFdBF9QWwgtQtlO7qJ/iA2jBaFYZcVnyM2hFQ1fhcI4QL6gNgAUr1G9tuwx3XgVKO/IDOHrqNVxAaQ6i7ahYxdQGeP8cgu9I/WfvQUsU881S90BU07hj4j9vgh2XMeQaN0Hi0j9omneovOIOYAsgvotjLYx66nr8i+86sO3/tcjQ2DHenYgpbQCmIfm+oR2oNGqdS5mo9o+ouwFz1G7LGpfqOryL5wo1XyXI09tzmL3iH2mFTv0Tk0eiXf5LJ1ZN/B9p3M/j3VE7QPhcAG0Cr7v+Ea2orCYINokb0qsldH4bBh1O4ZspeSIbGB1MredLuBtqGw2GBqZC9TF1B4bDile4EOIQE2oJLdQnapUTpsSCWy92kWkcxgwyqRXTyxA1Uygw2rZHawyg5YSYcNqXR2wOoEEmADqpFWUocNp2bhVxIbSu1CryQ2kBaFXUlsGC0Lt5JKn6vp88cUtpJOohBqnKuxA1TrPdsfZiXVOlfT969bQqykmudq+q6kU0iceK8k3S+oB6+VpPsFDdR3JdlPkdH9ghwMWUm6X5CTviupdOH0WUklC6nPSipVWBtlJYXXeiUJtFxJ0mm1kmRG7ZUkRM2VJAm1VpJksKF5JhlsaJ5JBhuaZ5LBhuaZZLCheSYZbGieSUbpc02SofsFNab7BW0Am/5+QSIiIiIiIiIistlMJv8AOUZozSTDIV4AAAAASUVORK5CYII=",
      "alt": "dendrogram"
    }
  })])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showTree) ? _c('dendrogram', {
    staticClass: "dendrogram",
    attrs: {
      "root": _vm.diversityTree
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "records"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.newVideosCount > 0) ? _c('div', {
    staticClass: "alert new-record-avaible"
  }, [_c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.newVideosCount))]), _vm._v("\n            " + _vm._s(_vm.$tc('records.new_available', _vm.newVideosCount >= 2 ? 2 : 1)) + "\n            "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.swapInNewRecords()
      }
    }
  }, [_vm._v(_vm._s(_vm.$tc('records.click_here_to_refresh')))])]) : _vm._e()]), _vm._v(" "), (_vm.$root.$children[0].$data.clientId != 'digiteka') ? _c('div', {
    staticClass: "row"
  }, [(!_vm.$store.state.editorConsumers[0]) ? _c('lmr-city-report-filter', {
    staticClass: "col-md-6",
    on: {
      "change": _vm.handleLmrCitySelected
    },
    model: {
      value: (_vm.recordFilters.lmr_cities),
      callback: function($$v) {
        _vm.$set(_vm.recordFilters, "lmr_cities", $$v)
      },
      expression: "recordFilters.lmr_cities"
    }
  }) : _c('editor-consumer-filter', {
    staticClass: "col-md-6",
    on: {
      "change": _vm.handleEditorConsumerSelected
    },
    model: {
      value: (_vm.recordFilters.editor_consumers),
      callback: function($$v) {
        _vm.$set(_vm.recordFilters, "editor_consumers", $$v)
      },
      expression: "recordFilters.editor_consumers"
    }
  }), _vm._v(" "), _c('marker-tags-selector', {
    ref: "tagsFilter",
    staticClass: "col-md-6",
    attrs: {
      "markerId": _vm.markerId
    },
    on: {
      "tags-selected": _vm.handleTagsSelected
    }
  })], 1) : _c('div', {
    staticClass: "row"
  }, [_c('lmr-city-report-filter', {
    staticClass: "col-md-12",
    on: {
      "change": _vm.handleLmrCitySelected
    },
    model: {
      value: (_vm.recordFilters.lmr_cities),
      callback: function($$v) {
        _vm.$set(_vm.recordFilters, "lmr_cities", $$v)
      },
      expression: "recordFilters.lmr_cities"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('v-autocomplete', {
    ref: "filterByAuthor",
    staticClass: "col-md-6 order_list",
    attrs: {
      "items": _vm.filtersAuthors,
      "rules": [function () { return !!_vm.recordFilters.user || _vm.$t('upload_video.field_is_required'); }],
      "loading": _vm.isLoadingAuthors,
      "search-input": _vm.searchFilteredUser,
      "hide-no-data": "",
      "hide-selected": "",
      "item-text": "autocomplete_full_name",
      "item-value": "pk",
      "placeholder": _vm.$t('user.filter.filter_by_user'),
      "return-object": "",
      "outline": "",
      "clearable": "",
      "single-line": ""
    },
    on: {
      "update:searchInput": function($event) {
        _vm.searchFilteredUser = $event
      },
      "update:search-input": function($event) {
        _vm.searchFilteredUser = $event
      },
      "input": _vm.fetchRecords
    },
    model: {
      value: (_vm.recordFilters.user),
      callback: function($$v) {
        _vm.$set(_vm.recordFilters, "user", $$v)
      },
      expression: "recordFilters.user"
    }
  }), _vm._v(" "), _c('v-select', {
    staticClass: "col-md-6 right order_list",
    attrs: {
      "placeholder": _vm.$t('Ordering'),
      "items": _vm.itemsOrdering,
      "flat": "",
      "outline": "",
      "single-line": ""
    },
    on: {
      "input": _vm.fetchRecords
    },
    model: {
      value: (_vm.recordOrdering),
      callback: function($$v) {
        _vm.recordOrdering = $$v
      },
      expression: "recordOrdering"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.isLmrConsumer) ? _c('lmr-category-filter', {
    staticClass: "col-md-6",
    on: {
      "change": _vm.fetchRecords
    },
    model: {
      value: (_vm.recordFilters.lmr_category),
      callback: function($$v) {
        _vm.$set(_vm.recordFilters, "lmr_category", $$v)
      },
      expression: "recordFilters.lmr_category"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.consumer_group === 'ebra') ? _c('v-select', {
    staticClass: "col-md-6 right order_list",
    attrs: {
      "placeholder": _vm.$t('departments.filter_by_department'),
      "items": _vm.departments,
      "flat": "",
      "outline": "",
      "single-line": ""
    },
    on: {
      "input": _vm.fetchRecords
    },
    model: {
      value: (_vm.department),
      callback: function($$v) {
        _vm.department = $$v
      },
      expression: "department"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.consumer_group === 'rossel') ? _c('sdk-filter', {
    on: {
      "change": _vm.fetchRecords
    },
    model: {
      value: (_vm.recordFilters.sdk_record),
      callback: function($$v) {
        _vm.$set(_vm.recordFilters, "sdk_record", $$v)
      },
      expression: "recordFilters.sdk_record"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-tabs', {
    attrs: {
      "fixed-tabs": "",
      "slider-color": "#ff2d55"
    },
    model: {
      value: (_vm.activeTabIndex),
      callback: function($$v) {
        _vm.activeTabIndex = $$v
      },
      expression: "activeTabIndex"
    }
  }, [_c('v-tab', [_vm._v("\n            " + _vm._s(_vm.$t('new')) + " "), (_vm.newTabRecordsCount) ? _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.newTabRecordsCount))]) : _vm._e()]), _vm._v(" "), _c('v-tab', {
    attrs: {
      "id": "approved_tab"
    }
  }, [_vm._v(_vm._s(_vm.$t('approved')))]), _vm._v(" "), _c('v-tab', [_vm._v(_vm._s(_vm.$t('deleted')))])], 1), _vm._v(" "), (_vm.activeTabIndex === _vm.recordTabs.new && _vm.isLmrConsumer) ? _c('div', {
    attrs: {
      "id": "select-mode-btn-wrapper"
    }
  }, [(_vm.records.length) ? _c('button', {
    staticClass: "btn btn-default highlight mr-1",
    class: {
      active: _vm.approveMode
    },
    attrs: {
      "id": "select-mode-btn",
      "department": ""
    },
    on: {
      "click": _vm.toggleApproveMode
    }
  }, [_vm._v(_vm._s(_vm.$t('approve').toUpperCase()))]) : _vm._e(), _vm._v(" "), (_vm.showVideos && _vm.records.length > 1) ? _c('button', {
    staticClass: "btn btn-default highlight",
    class: {
      active: _vm.mergeMode
    },
    attrs: {
      "id": "merge-mode-btn"
    },
    on: {
      "click": _vm.toggleMergeMode
    }
  }, [_vm._v(_vm._s(_vm.$t('merge').toUpperCase()))]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), [(!_vm.videoFileUploading && !_vm.showImages) ? _c('button', {
    staticClass: "btn btn-default highlight right",
    attrs: {
      "id": "add-video-mode-btn"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.dialog = true
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t('upload_video.upload_video_title').toUpperCase()) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "600px"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.$t('upload_video.upload_video_title')))])]), _vm._v(" "), (_vm.videoFileUploading) ? _c('v-card-text', [_c('v-container', {
    staticStyle: {
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "subtitle-1 text-center",
    attrs: {
      "cols": "12"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('upload_video.upload_progress')) + " (" + _vm._s(_vm.bufferVideoUploading) + "%)\n          ")]), _vm._v(" "), _c('v-progress-linear', {
    attrs: {
      "buffer-value": 100,
      "color": "#ff2d55",
      "bufferVideoUploading": "",
      "height": "6"
    },
    model: {
      value: (_vm.bufferVideoUploading),
      callback: function($$v) {
        _vm.bufferVideoUploading = $$v
      },
      expression: "bufferVideoUploading"
    }
  })], 1)], 1) : _c('v-card-text', [(!_vm.uploadingVideoFile) ? _c('div', [_c('div', {
    class: ['dropZone', _vm.dragging ? 'dropZone-over' : ''],
    on: {
      "dragenter": function($event) {
        _vm.dragging = true
      },
      "dragleave": function($event) {
        _vm.dragging = false
      }
    }
  }, [_c('div', {
    staticClass: "dropZone-info",
    on: {
      "drag": _vm.onChange
    }
  }, [_c('span', {
    staticClass: "fa fa-cloud-upload dropZone-title"
  }), _vm._v(" "), _c('span', {
    staticClass: "dropZone-title"
  }, [_vm._v(_vm._s(_vm.$t('upload_video.drop_file_or_click')))]), _vm._v(" "), _c('div', {
    staticClass: "dropZone-upload-limit-info"
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('upload_video.support_file')))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('upload_video.max_file_size')) + ": 500 MB")]), _vm._v(" "), (_vm.uploadVideoFormHasErrors) ? _c('div', [_vm._v(_vm._s(_vm.$t('upload_video.you_must_add_video_file')))]) : _vm._e()])]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.onChange
    }
  })])]) : _c('div', {
    staticClass: "dropZone-uploaded"
  }, [_c('div', {
    staticClass: "dropZone-uploaded-info"
  }, [_c('span', {
    staticClass: "dropZone-title"
  }, [_vm._v(_vm._s(_vm.$t('upload_video.checked')))]), _vm._v(" "), _c('div', {
    staticClass: "uploadedFile-info"
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('upload_video.file_name')) + ": " + _vm._s(_vm.uploadingVideoFile.name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('upload_video.file_size')) + ": " + _vm._s((_vm.uploadingVideoFile.size / 1000000).toFixed(2)) + " MB")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('upload_video.extension')) + ": " + _vm._s(_vm.extension))])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary removeFile",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.removeFile
    }
  }, [_vm._v(_vm._s(_vm.$t('upload_video.remove_file')))])])]), _vm._v(" "), _c('div', [_c('v-radio-group', {
    ref: "typeVideoUpload",
    attrs: {
      "row": "",
      "rules": [function () { return !!_vm.typeVideoUpload || _vm.$t('upload_video.field_is_required'); }]
    },
    model: {
      value: (_vm.typeVideoUpload),
      callback: function($$v) {
        _vm.typeVideoUpload = $$v
      },
      expression: "typeVideoUpload"
    }
  }, _vm._l((_vm.videoUploadTypes), function(item) {
    return _c('v-radio', {
      key: item.id,
      attrs: {
        "color": "rgb(255, 45, 85)",
        "label": item.name,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('v-autocomplete', {
    ref: "uploadVideoAuthor",
    attrs: {
      "items": _vm.entriesAuthors,
      "rules": [function () { return !!_vm.uploadVideoAuthor || _vm.$t('upload_video.field_is_required'); }],
      "loading": _vm.isLoadingAuthors,
      "search-input": _vm.search,
      "color": "#ff2d55",
      "hide-no-data": "",
      "hide-selected": "",
      "item-text": "autocomplete_full_name",
      "item-value": "pk",
      "placeholder": _vm.$t('upload_video.start_typing'),
      "return-object": ""
    },
    on: {
      "update:searchInput": function($event) {
        _vm.search = $event
      },
      "update:search-input": function($event) {
        _vm.search = $event
      }
    },
    model: {
      value: (_vm.uploadVideoAuthor),
      callback: function($$v) {
        _vm.uploadVideoAuthor = $$v
      },
      expression: "uploadVideoAuthor"
    }
  }), _vm._v(" "), _c('v-text-field', {
    ref: "titleVideoUpload",
    attrs: {
      "rules": [function () { return !!_vm.titleVideoUpload || _vm.$t('upload_video.field_is_required'); }],
      "color": "#ff2d55",
      "counter": 100,
      "label": _vm.$t('upload_video.title'),
      "required": ""
    },
    model: {
      value: (_vm.titleVideoUpload),
      callback: function($$v) {
        _vm.titleVideoUpload = $$v
      },
      expression: "titleVideoUpload"
    }
  }), _vm._v(" "), (_vm.consumerHasDescriptionField) ? _c('v-textarea', {
    ref: "descriptionVideoUpload",
    attrs: {
      "rules": [function () { return !!_vm.descriptionVideoUpload || _vm.$t('upload_video.field_is_required'); }],
      "color": "#ff2d55",
      "name": "input-7-1",
      "label": _vm.$t('upload_video.description'),
      "value": "",
      "hint": "Hint text"
    },
    model: {
      value: (_vm.descriptionVideoUpload),
      callback: function($$v) {
        _vm.descriptionVideoUpload = $$v
      },
      expression: "descriptionVideoUpload"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('v-card-actions', {
    staticStyle: {
      "padding": "16px"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "#ff2d55",
      "outline": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('upload_video.close')))]), _vm._v(" "), (!_vm.videoFileUploading) ? _c('v-btn', {
    attrs: {
      "color": "#ff2d55",
      "outline": ""
    },
    on: {
      "click": _vm.uploadData
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('upload_video.upload')))]) : _vm._e()], 1)], 1)], 1)]], 2) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading && !_vm.records.length),
      expression: "loading && !records.length"
    }],
    staticClass: "loading-indicator center-block"
  }), _vm._v(" "), (!_vm.records.length && !_vm.loading) ? _c('p', {
    staticClass: "empty"
  }, [_vm._v("\n          " + _vm._s(_vm.$t("records.none_available")) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('records-list', {
    attrs: {
      "records": _vm.records,
      "marker-id": _vm.markerId,
      "selectedRecords": _vm.selectedRecords,
      "showSelectIndex": _vm.mergeMode,
      "isChoosingMode": _vm.approveMode || _vm.mergeMode || _vm.downloadMode
    },
    on: {
      "delete-record": _vm.handleRecordDelete,
      "restore-record": _vm.handleRecordRestore,
      "mark-record-relevance": _vm.markRecordRelevance,
      "clicked-record": _vm.recordClicked
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.amountOfPages > 1),
      expression: "amountOfPages > 1"
    }]
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.amountOfPages,
      "total-visible": 10
    },
    on: {
      "input": function($event) {
        _vm.records = [];
        _vm.fetchRecords()
      }
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1), _vm._v(" "), (_vm.mergeMode || _vm.approveMode || _vm.downloadMode) ? _c('div', {
    staticStyle: {
      "margin-bottom": "100px"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.approveMode) ? _c('div', {
    staticClass: "select-mode-bar"
  }, [_c('div', {
    staticClass: "container"
  }, [(!_vm.showImages) ? _c('button', {
    staticClass: "btn btn-info left",
    attrs: {
      "disabled": !_vm.selectedRecords.length
    },
    on: {
      "click": _vm.downloadRecords
    }
  }, [_vm._v(_vm._s(_vm.$t('download').toUpperCase()) + " (" + _vm._s(_vm.selectedRecords.length) + ")")]) : _vm._e(), _vm._v(" "), (_vm.showImages) ? _c('button', {
    staticClass: "btn btn-info left",
    attrs: {
      "disabled": !_vm.selectedRecords.length
    },
    on: {
      "click": _vm.downloadRecordsZip
    }
  }, [_vm._v(_vm._s(_vm.$t('download').toUpperCase()) + " (" + _vm._s(_vm.selectedRecords.length) + ")")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger left",
    attrs: {
      "disabled": false
    },
    on: {
      "click": _vm.toggleApproveMode
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel').toUpperCase()))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "disabled": !_vm.selectedRecords.length
    },
    on: {
      "click": _vm.rejectRecords
    }
  }, [_vm._v(_vm._s(_vm.$t('reject').toUpperCase()) + " (" + _vm._s(_vm.selectedRecords.length) + ")")]), _vm._v(" "), (!_vm.showImages) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": !_vm.selectedRecords.length
    },
    on: {
      "click": _vm.approveRecords
    }
  }, [_vm._v(_vm._s(_vm.$t('records.approve').toUpperCase()) + " (" + _vm._s(_vm.selectedRecords.length) + ")")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.mergeMode) ? _c('div', {
    staticClass: "select-mode-bar"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('button', {
    staticClass: "btn btn-danger left",
    on: {
      "click": _vm.toggleMergeMode
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel').toUpperCase()))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": !(_vm.selectedRecords.length > 1)
    },
    on: {
      "click": function($event) {
        return _vm.setMergeRecordTitle(false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('merge').toUpperCase()) + " (" + _vm._s(_vm.selectedRecords.length) + ")")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": !(_vm.selectedRecords.length > 1)
    },
    on: {
      "click": function($event) {
        return _vm.setMergeRecordTitle(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('merge_abd_approve').toUpperCase()) + " (" + _vm._s(_vm.selectedRecords.length) + ")")])])]) : _vm._e(), _vm._v(" "), (_vm.selectedRecord) ? _c('record-details', {
    attrs: {
      "record": _vm.selectedRecord
    },
    on: {
      "clicked-similar-record": _vm.showRecordDetails,
      "close": function($event) {
        _vm.selectedRecord = null
      },
      "cut-started": _vm.setCutIcon
    }
  }) : _vm._e(), _vm._v(" "), (_vm.relatedRecords.length > 0) ? [_c('div', {
    staticClass: "records-information related-records row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$tc('records.related_streams_title')))]), _vm._v(" "), _c('p', {
    staticClass: "help-block"
  }, [_c('em', [_vm._v("\n                " + _vm._s(_vm.$tc('records.related_streams_help')) + "\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "records related-records row"
  }, [_c('records-list', {
    attrs: {
      "records": _vm.relatedRecords,
      "read-only": true
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.showPremergeModal) ? _c('modal', {
    attrs: {
      "show": _vm.showPremergeModal,
      "okBtnText": _vm.$t('records.start_merge')
    },
    on: {
      "ok": _vm.mergeRecords,
      "hide": _vm.toggleMergeMode
    }
  }, [_c('template', {
    slot: "body"
  }, [_c('div', {
    staticClass: "edit-record-notes form-group"
  }, [(_vm.consumerHasDescriptionField) ? _c('div', {
    staticClass: "form-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mergeData.title),
      expression: "mergeData.title"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "record-title",
      "rows": "8",
      "cols": "80"
    },
    domProps: {
      "value": (_vm.mergeData.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.mergeData, "title", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mergeData.description),
      expression: "mergeData.description"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "record-description",
      "rows": "8",
      "cols": "80"
    },
    domProps: {
      "value": (_vm.mergeData.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.mergeData, "description", $event.target.value)
      }
    }
  })]) : _c('div', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mergeData.title),
      expression: "mergeData.title"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "record-comment",
      "rows": "8",
      "cols": "80"
    },
    domProps: {
      "value": (_vm.mergeData.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.mergeData, "title", $event.target.value)
      }
    }
  })])])])], 2) : _vm._e()], 2)] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 1036 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "users"
  }, [_c('div', [_c('v-btn', {
    on: {
      "click": _vm.exportUserData
    }
  }, [_vm._v("Export Users")])], 1), _vm._v(" "), _c('div', {
    staticClass: "users-filter-set"
  }, [_c('user-search-input', {
    on: {
      "query-updated": _vm.handleNameQueryUpdated
    }
  }), _vm._v(" "), _c('user-group-selector', {
    on: {
      "groups-selected": _vm.handleGroupsSelected
    }
  })], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.users,
      "rows-per-page-items": [10, 5, {
        text: "Test",
        value: -1
      }]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.first_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.last_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.user_groups))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.valid_records_amt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.all_records_amt))]), _vm._v(" "), _c('td', [_c('router-link', {
          attrs: {
            "to": {
              path: _vm.buildDetailsLink(props.item.id)
            }
          }
        }, [_vm._v("\n          " + _vm._s(_vm.$t('user.view')) + "\n        ")])], 1)]
      }
    }])
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1037 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.show && _vm.isConnectionError) ? _c('div', {
    staticClass: "connection-error",
    attrs: {
      "transition": "fade"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-flash blink"
  }), _vm._v("\n      " + _vm._s(_vm.$t('error.connection')) + "\n      "), _c('a', {
    staticClass: "close",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.show = false
      }
    }
  }, [_vm._v("×")])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.show && !_vm.isConnectionError) ? _c('div', {
    staticClass: "error-mask",
    class: {
      'modal-mask': _vm.modal, 'banner-mask': !_vm.modal
    }
  }, [_c('a', {
    staticClass: "close",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.show = false
      }
    }
  }, [_vm._v("❌")]), _vm._v(" "), _c('div', {
    class: {
      'modal-wrapper': _vm.modal, 'banner-wrapper': !_vm.modal
    }
  }, [_c('div', {
    class: {
      'modal-container': _vm.modal, 'banner-container': !_vm.modal
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isServerError),
      expression: "isServerError"
    }]
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('error.generic')))]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('error.server'))
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('error.apologies'))
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('error.help'))
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isForbidden),
      expression: "isForbidden"
    }]
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('error.access_denied')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('error.forbidden')))]), _vm._v(" "), _c('p', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('error.contact_us'))
    }
  })])])])])]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 1038 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.duration >= 0 && _vm.endToNow >= 0) ? _c('p', {
    staticClass: "help-block"
  }, [(_vm.startToNow >= 0) ? _c('span', [_vm._v("\n      " + _vm._s(_vm.$t('marker.activation_time_help', {
    at: _vm.start.locale(_vm.locale).fromNow(),
    duration: _vm.readableDuration(_vm.duration, _vm.locale)
  })) + "\n    ")]) : _c('span', [_vm._v("\n      " + _vm._s(_vm.$t('marker.activation_immediate_help', {
    duration: _vm.readableDuration(_vm.endToNow, _vm.locale)
  })) + "\n    ")])]) : (_vm.duration < 0) ? _c('p', {
    staticClass: "help-block error"
  }, [_vm._v("\n    " + _vm._s(_vm.$t('marker.invalid_duration')) + "\n  ")]) : (_vm.endToNow < 0) ? _c('p', {
    staticClass: "help-block error"
  }, [_vm._v("\n    " + _vm._s(_vm.$t('marker.invalid_end_time')) + "\n  ")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1039 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "records-information row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.recordCount) ? _c('p', [_c('span', {
    staticClass: "highlight"
  }, [_vm._v("\n          " + _vm._s(_vm.recordCount) + " " + _vm._s(_vm.$tc('records.video', _vm.records.length >= 2 ? 2 : 1)) + "\n        ")]), _vm._v("\n        " + _vm._s(_vm.$tc('records.has_been_recorded', _vm.records.length >= 2 ? 2 : 1)) + "\n        "), (_vm.diversityTree) ? _c('span', [_c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#",
      "title": "show dendrogram"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showTree = !_vm.showTree
      }
    }
  }, [_c('img', {
    staticStyle: {
      "height": "16px",
      "cursor": "pointer",
      "opacity": "0.7"
    },
    attrs: {
      "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAALuSURBVHhe7dw9aFRBFMXx1SiCiAgiCBpBUPGrtBA7G5s0NqlsLG2tg42VlY32NlZ+YGNjY2GjYGkhWAiCEBC/RRBJ1HPhFctyJmPeuzOTvHt+8K/cLOQmuW72Td5ERERERERERERk5ObRA/Qd/R2YPcdDdBTJfziIPiE2zCHZc9pzS8Z9xAbo0T0kGT8QG55H35BksMF5JhlsaJ5JBhuaZ5LBhuaZZLCheSZr2I3Y0DyThNPoDWJD80yIy+gnYgPzTqbsRHcQG1SppHMcvUJsSCUTuIRKvuWwVqHtQLcRG0ytwjqMXiI2lJqFdBF9QWwgtQtlO7qJ/iA2jBaFYZcVnyM2hFQ1fhcI4QL6gNgAUr1G9tuwx3XgVKO/IDOHrqNVxAaQ6i7ahYxdQGeP8cgu9I/WfvQUsU881S90BU07hj4j9vgh2XMeQaN0Hi0j9omneovOIOYAsgvotjLYx66nr8i+86sO3/tcjQ2DHenYgpbQCmIfm+oR2oNGqdS5mo9o+ouwFz1G7LGpfqOryL5wo1XyXI09tzmL3iH2mFTv0Tk0eiXf5LJ1ZN/B9p3M/j3VE7QPhcAG0Cr7v+Ea2orCYINokb0qsldH4bBh1O4ZspeSIbGB1MredLuBtqGw2GBqZC9TF1B4bDile4EOIQE2oJLdQnapUTpsSCWy92kWkcxgwyqRXTyxA1Uygw2rZHawyg5YSYcNqXR2wOoEEmADqpFWUocNp2bhVxIbSu1CryQ2kBaFXUlsGC0Lt5JKn6vp88cUtpJOohBqnKuxA1TrPdsfZiXVOlfT969bQqykmudq+q6kU0iceK8k3S+oB6+VpPsFDdR3JdlPkdH9ghwMWUm6X5CTviupdOH0WUklC6nPSipVWBtlJYXXeiUJtFxJ0mm1kmRG7ZUkRM2VJAm1VpJksKF5JhlsaJ5JBhuaZ5LBhuaZZLCheSYZbGieSUbpc02SofsFNab7BW0Am/5+QSIiIiIiIiIistlMJv8AOUZozSTDIV4AAAAASUVORK5CYII=",
      "alt": "dendrogram"
    }
  })])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showTree) ? _c('dendrogram', {
    staticClass: "dendrogram",
    attrs: {
      "root": _vm.diversityTree
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "records row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading && !_vm.records.length),
      expression: "loading && !records.length"
    }],
    staticClass: "loading-indicator center-block"
  }), _vm._v(" "), (_vm.records.length === 0 && !_vm.loading) ? _c('p', {
    staticClass: "empty"
  }, [_vm._v(_vm._s(_vm.$t("records.none_available")))]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.newRecordsCount > 0) ? _c('div', {
    staticClass: "alert new-record-avaible"
  }, [_c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.newRecordsCount))]), _vm._v("\n        " + _vm._s(_vm.$tc('records.new_available', _vm.newRecordsCount >= 2 ? 2 : 1)) + "\n        "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.swapInNewRecords()
      }
    }
  }, [_vm._v(_vm._s(_vm.$tc('records.click_here_to_refresh')))])]) : _vm._e()]), _vm._v(" "), _c('marker-tags-selector', {
    attrs: {
      "markerId": _vm.markerId
    },
    on: {
      "tags-selected": _vm.handleTagsSelected
    }
  }), _vm._v(" "), (_vm.isLmrConsumer) ? _c('lmr-city-report-filter', {
    on: {
      "change": _vm.handleLmrCitySelected
    },
    model: {
      value: (_vm.recordFilters.lmr_cities),
      callback: function($$v) {
        _vm.$set(_vm.recordFilters, "lmr_cities", $$v)
      },
      expression: "recordFilters.lmr_cities"
    }
  }) : _vm._e(), _vm._v(" "), _c('inappropriate-filter', {
    on: {
      "change": function($event) {
        return _vm.fetchRecordCoords(true)
      }
    },
    model: {
      value: (_vm.recordFilters.inappropriate),
      callback: function($$v) {
        _vm.$set(_vm.recordFilters, "inappropriate", $$v)
      },
      expression: "recordFilters.inappropriate"
    }
  }), _vm._v(" "), (_vm.isLmrConsumer) ? _c('lmr-category-filter', {
    on: {
      "change": function($event) {
        return _vm.fetchRecordCoords(true)
      }
    },
    model: {
      value: (_vm.recordFilters.lmr_category),
      callback: function($$v) {
        _vm.$set(_vm.recordFilters, "lmr_category", $$v)
      },
      expression: "recordFilters.lmr_category"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-tabs', {
    attrs: {
      "fixed-tabs": "",
      "slider-color": "#ff2d55"
    },
    on: {
      "change": _vm.tabSelected
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-tab', [_vm._v("Approved")]), _vm._v(" "), _c('v-tab', [_vm._v("Deleted")])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.markerId) ? [_c('div', {
    staticClass: "col-md-12 flex-container flex-stretch",
    staticStyle: {
      "padding-top": "15px"
    },
    attrs: {
      "id": "marker-map-container"
    }
  }, [_c('marker-map', {
    staticStyle: {
      "flex": "1",
      "position": "relative",
      "z-index": "1"
    },
    attrs: {
      "image_coords": _vm.image_coords,
      "video_coords": _vm.video_coords
    },
    on: {
      "clicked-marker": _vm.handleClickedMarker,
      "map-moved": _vm.handleMapMoved
    }
  })], 1)] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.marker) ? _c('v-radio-group', {
    model: {
      value: (_vm.ordering),
      callback: function($$v) {
        _vm.ordering = $$v
      },
      expression: "ordering"
    }
  }, _vm._l((_vm.orderingItems), function(item) {
    return _c('v-radio', {
      key: item.key,
      attrs: {
        "label": item.label,
        "value": item.key
      },
      on: {
        "change": _vm.changeOrdering
      }
    })
  }), 1) : _vm._e()], 1), _vm._v(" "), _c('records-list', {
    attrs: {
      "records": _vm.records,
      "marker": _vm.marker
    },
    on: {
      "delete-record": _vm.handleRecordDelete,
      "restore-record": _vm.handleRecordRestore,
      "mark-record-relevance": _vm.markRecordRelevance,
      "clicked-record": _vm.showRecordDetails
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row record-details"
  }, [(_vm.selectedRecord) ? _c('record-details', {
    attrs: {
      "record": _vm.selectedRecord,
      "marker-id": _vm.markerId
    },
    on: {
      "clicked-similar-record": _vm.showRecordDetails,
      "close": function($event) {
        _vm.selectedRecord = null
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading && _vm.records.length),
      expression: "!loading && records.length"
    }]
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.calculateAmountPages('VIDEO'),
      "total-visible": 10
    },
    on: {
      "input": function($event) {
        return _vm.fetchRecords('VIDEO')
      }
    },
    model: {
      value: (_vm.recordsPage),
      callback: function($$v) {
        _vm.recordsPage = $$v
      },
      expression: "recordsPage"
    }
  })], 1)], 1), _vm._v(" "), (_vm.imageRecords.length > 0) ? _c('div', [_c('div', [_c('h2', [_vm._v("Images")]), _vm._v(" "), _c('div', {
    staticClass: "row record-details"
  }, [_c('records-list', {
    attrs: {
      "records": _vm.imageRecords,
      "marker": _vm.marker
    },
    on: {
      "delete-record": _vm.handleRecordDelete,
      "restore-record": _vm.handleRecordRestore,
      "mark-record-relevance": _vm.markRecordRelevance,
      "clicked-record": _vm.showRecordDetails
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.image_loading),
      expression: "!image_loading"
    }]
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.calculateAmountPages('IMAGE'),
      "total-visible": 10
    },
    on: {
      "input": function($event) {
        return _vm.fetchRecords('IMAGE')
      }
    },
    model: {
      value: (_vm.imagesPage),
      callback: function($$v) {
        _vm.imagesPage = $$v
      },
      expression: "imagesPage"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "records-information related-records row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.relatedRecords.length > 0) ? _c('div', [_c('h3', [_vm._v(_vm._s(_vm.$tc('records.related_streams_title')))]), _vm._v(" "), _c('p', {
    staticClass: "help-block"
  }, [_c('em', [_vm._v("\n            " + _vm._s(_vm.$tc('records.related_streams_help')) + "\n          ")])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "records related-records row"
  }, [_c('records-list', {
    attrs: {
      "records": _vm.relatedRecords,
      "read-only": true
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1040 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('video-modal', {
    staticClass: "video-modal",
    attrs: {
      "show": _vm.showPlayer
    },
    on: {
      "hide": _vm.stop
    }
  }, [(!_vm.playerReady) ? _c('div', {
    staticClass: "loading-container vjs-waiting",
    attrs: {
      "slot": "loading"
    },
    slot: "loading"
  }, [_c('div', {
    staticClass: "vjs-loading-spinner",
    attrs: {
      "dir": "ltr"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.playerReady),
      expression: "playerReady"
    }],
    staticClass: "videojs-player",
    attrs: {
      "slot": "body"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    },
    slot: "body"
  }, [_c('video', {
    staticClass: "video-js vjs-big-play-centered",
    attrs: {
      "id": _vm.playerElement
    }
  }, [(_vm.record.url) ? _c('source', {
    attrs: {
      "src": _vm.record.url,
      "type": _vm.record.mimetype
    }
  }) : _vm._e()])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['record-item', {
      'selected': _vm.selected,
      'lmr-design': _vm.isLmrConsumer
    }]
  }, [_c('div', {
    staticClass: "record-header"
  }, [_c('div', {
    staticClass: "record-tags"
  }, [_c('m-l-tags', {
    attrs: {
      "record": _vm.record
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "controls"
  }, [_vm._l((_vm.processStatusesSorted), function(proc) {
    return (_vm.record.mldata.approved) ? _c('div', {
      key: proc.process + proc.status
    }, [(proc.process === 'intro' && ['done', 'error'].includes(proc.status)) ? _c('span', {
      staticClass: "download-action glyphicon glyphicon-download-alt clickable",
      class: {
        highlight: _vm.record.mldata.notes
      },
      attrs: {
        "title": _vm.$t('records.download')
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.downloadRecord(_vm.record)
        }
      }
    }) : _vm._e(), _vm._v(" "), (proc.process === 'intro' && proc.status === 'waiting') ? _c('span', {
      staticClass: "download-waiting-action glyphicon glyphicon-download-alt waving",
      attrs: {
        "title": _vm.$t('process_status.download_waiting')
      }
    }) : _vm._e(), _vm._v(" "), (proc.process === 'intro' && proc.status === 'running') ? _c('span', {
      staticClass: "download-waiting-action glyphicon glyphicon-download-alt waving",
      attrs: {
        "title": _vm.$t('process_status.download_waiting')
      }
    }) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), (_vm.record.mldata.approved && !_vm.getProcessList.includes('intro') && !_vm.getProcessList.includes('cut')) ? _c('div', [_c('span', {
    staticClass: "download-action glyphicon glyphicon-download-alt clickable",
    class: {
      highlight: _vm.record.mldata.notes
    },
    attrs: {
      "title": _vm.$t('records.download')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.downloadRecord(_vm.record)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.record.mldata.approved) ? _c('div', {
    staticClass: "notes"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-edit clickable",
    class: {
      highlight: _vm.record.mldata.notes
    },
    attrs: {
      "title": _vm.$t('records.edit_comment')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.editRecordNotes(_vm.record)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.record.mldata.approved && !_vm.record.ghost) ? _c('div', {
    staticClass: "download-action"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-download-alt clickable",
    class: {
      highlight: _vm.record.mldata.notes
    },
    attrs: {
      "title": _vm.$t('records.download')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.downloadRecord(_vm.record)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.record.ghost) ? _c('div', {
    staticClass: "download-waiting-action"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-download-alt waving",
    class: {
      highlight: _vm.record.mldata.notes
    },
    attrs: {
      "title": _vm.$t('process_status.download_waiting')
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.hideDeleteIcon) ? _c('div', {
    staticClass: "delete-record",
    attrs: {
      "title": ""
    }
  }, [(_vm.record.mldata.deleted_at) ? _c('span', {
    staticClass: "glyphicon clickable glyphicon-repeat",
    attrs: {
      "title": _vm.$t('records.restore')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.restoreRecord()
      }
    }
  }) : (_vm.record.record_type == 'VIDEO') ? _c('span', {
    staticClass: "glyphicon clickable glyphicon-trash",
    attrs: {
      "title": _vm.$t('records.delete')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.deleteRecord()
      }
    }
  }) : (_vm.record.record_type == 'IMAGE') ? _c('span', {
    staticClass: "glyphicon clickable glyphicon-trash",
    attrs: {
      "title": _vm.$t('records.delete_image')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.deleteRecord()
      }
    }
  }) : _vm._e()]) : _vm._e()], 2), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "process-checkmarks"
  }, [_vm._l((_vm.processStatusesSorted), function(proc) {
    return _c('span', {
      key: proc.process + proc.status,
      staticClass: "process-status",
      attrs: {
        "title": _vm.$t(("process_status." + (proc.process) + "_" + (proc.status)))
      }
    }, [(proc.process === 'cut' && proc.status === 'running') ? _c('img', {
      staticClass: "waving",
      attrs: {
        "src": __webpack_require__(962),
        "alt": "Trimming"
      }
    }) : _vm._e(), _vm._v(" "), (proc.process === 'cut' && proc.status === 'done') ? _c('img', {
      attrs: {
        "src": __webpack_require__(963),
        "alt": "Trimming done"
      }
    }) : _vm._e(), _vm._v(" "), (_vm.$route.path !== '/videos') ? [(proc.process === 'intro' && proc.status === 'waiting') ? _c('img', {
      attrs: {
        "src": __webpack_require__(959),
        "alt": "Process"
      }
    }) : _vm._e(), _vm._v(" "), (proc.process === 'intro' && proc.status === 'running') ? _c('img', {
      staticClass: "waving",
      attrs: {
        "src": __webpack_require__(957),
        "alt": "Processing"
      }
    }) : _vm._e(), _vm._v(" "), (proc.process === 'intro' && proc.status === 'done') ? _c('img', {
      attrs: {
        "src": __webpack_require__(958),
        "alt": "Processed"
      }
    }) : _vm._e()] : _vm._e(), _vm._v(" "), (proc.process === 'ftpupload' && proc.status === 'waiting') ? _c('v-icon', {
      staticClass: "waiting-link"
    }, [_vm._v("link")]) : _vm._e(), _vm._v(" "), (proc.process === 'ftpupload' && (
      proc.status === 'running' || (proc.status === 'done' && !_vm.record.digiteka_id)
    )) ? _c('v-icon', {
      staticClass: "waving-45"
    }, [_vm._v("link")]) : _vm._e()], 2)
  }), _vm._v(" "), (_vm.digitekaLink) ? _c('v-btn', {
    staticClass: "dg-link",
    attrs: {
      "fab": "",
      "small": "",
      "flat": "",
      "title": _vm.$t('digiteka_copy_link_title'),
      "href": _vm.digitekaLink,
      "target": "_blank"
    }
  }, [_c('v-icon', [_vm._v("link")])], 1) : _vm._e()], 2)], 1), _vm._v(" "), _c('div', {
    class: ['inner-record', 'center-block', {
      'clickable': _vm.isChoosingMode
    }],
    style: ([_vm.record.consumer == 'lng_sdk' ? {
      'background-color': '#eef5f9'
    } : {}]),
    on: {
      "click": function($event) {
        return _vm.clickedRecordCardHandler(_vm.record)
      }
    }
  }, [(!_vm.record.ghost) ? _c('thumbnail', {
    staticClass: "thumbnail clickable center-block",
    attrs: {
      "media": _vm.record.media,
      "default": _vm.record.thumbnail_link
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.clickedRecordHandler(_vm.record)
      }
    }
  }) : _c('div', {
    staticClass: "thumbnail ghost center-block"
  }, [_c('div', {
    staticClass: "loading-indicator"
  }), _vm._v(" "), _c('p', [_vm._v("Processing...")])]), _vm._v(" "), (_vm.isLmrConsumer) ? _c('div', [_c('div', {
    staticClass: "lmr-user-cat"
  }, [_c('div', {
    staticClass: "category"
  }, [_vm._v(_vm._s(_vm.record.lmr_category))]), _vm._v(" "), (!_vm.record.mldata.approved && !_vm.record.mldata.deleted_at) ? _c('v-select', {
    staticClass: "record_group",
    attrs: {
      "disabled": _vm.isChoosingMode,
      "items": _vm.record.available_groups.map(function (data) { return ({
        value: data.id,
        text: data.localized_name[0].translation
      }); }),
      "label": "Edition",
      "value": _vm.record.groups[0].id,
      "dense": "",
      "outlined": "",
      "solo": "",
      "flat": "",
      "hide-details": "",
      "color": "red",
      "background-color": "#dcdbdb"
    },
    on: {
      "input": function($event) {
        return _vm.changeEdition(_vm.record.id, _vm.selected_group)
      }
    },
    model: {
      value: (_vm.selected_group),
      callback: function($$v) {
        _vm.selected_group = $$v
      },
      expression: "selected_group"
    }
  }) : (_vm.record.groups.length > 0 && _vm.record.mldata.approved && !_vm.record.mldata.deleted_at) ? _c('div', {
    staticClass: "edition"
  }, [_vm._v(_vm._s(_vm.record.groups[0].group_name))]) : (_vm.record.groups.length > 0 && !_vm.record.mldata.approved && _vm.record.mldata.deleted_at) ? _c('div', {
    staticClass: "edition"
  }, [_vm._v(_vm._s(_vm.record.groups[0].group_name))]) : _c('div')], 1), _vm._v(" "), (!_vm.record.title && _vm.record.comment && _vm.record.consumer != 'lavoix') ? _c('p', {
    staticClass: "comment"
  }, [_vm._v("\n          " + _vm._s(_vm.record.comment) + "\n        ")]) : _c('p', {
    staticClass: "comment"
  }, [_vm._v("\n          " + _vm._s(_vm.record.title) + "\n        ")]), _vm._v(" "), _c('p', [_c('small', [_vm._v(_vm._s(_vm.$t('records.recorded')) + "\n            "), _c('time-ago', {
    attrs: {
      "value": _vm.record.shooting_date
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('records.ago'))
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('records.by'))
    }
  }), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "highlight"
  }, [_vm._v(_vm._s(_vm.record.user_full_name))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": 'tel:' + _vm.record.contact_phone
    }
  }, [_c('br'), _vm._v(_vm._s(_vm.record.contact_phone))])], 1)])]) : _c('p', [_c('small', [_vm._v(_vm._s(_vm.$t('records.recorded')) + "\n          "), _c('time-ago', {
    staticClass: "highlight",
    attrs: {
      "value": _vm.record.shooting_date
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('records.ago'))
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('records.by'))
    }
  }), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "highlight"
  }, [_vm._v(_vm._s(_vm.record.user))])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "highlight"
  }, [(_vm.record.mldata.relevance) ? _c('span', [_vm._v(" Relevance: " + _vm._s(_vm.record.mldata.relevance))]) : _vm._e(), _vm._v(" "), (_vm.record.mldata.consistency) ? _c('span', [_vm._v(" Consistency: " + _vm._s(_vm.record.mldata.consistency))]) : _vm._e(), _vm._v(" "), (_vm.record.mldata.diversity) ? _c('span', [_vm._v(" Diversity: " + _vm._s(_vm.record.mldata.diversity))]) : _vm._e()]), _vm._v(" "), (_vm.selected) ? [(_vm.showSelectIndex) ? _c('div', {
    staticClass: "record-selected-marker",
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.selectIndex) + "\n        ")]) : _c('v-icon', {
    staticClass: "record-selected-marker",
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("\n          check_circle\n        ")])] : _vm._e(), _vm._v(" "), (_vm.record.merged) ? _c('div', {
    staticClass: "merged-icon",
    attrs: {
      "title": "This record was produced by merge of other records"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(955),
      "alt": "merged"
    }
  })]) : _vm._e()], 2), _vm._v(" "), _c('input', {
    ref: "copyText",
    staticClass: "copy-text",
    attrs: {
      "type": "text"
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 1042 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message-container"
  }, [_c('div', {
    attrs: {
      "name": "messages-list"
    }
  }, _vm._l((_vm.messages), function(message) {
    return _c('div', {
      key: message.id,
      staticClass: "message",
      attrs: {
        "title": _vm.title(message)
      }
    }, [_c('div', {
      class: ['status', _vm.statusClass(message)]
    }), _vm._v(" "), _c('div', {
      staticClass: "username"
    }, [_vm._v(_vm._s(message.username))])])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 1043 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tag-filter"
  }, [_c('multiselect', {
    attrs: {
      "placeholder": _vm.$tc('user.filter.usergroup'),
      "label": "name",
      "track-by": "name",
      "options": _vm.options,
      "searchable": false,
      "multiple": ""
    },
    on: {
      "input": _vm.inputHandler
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('div', {
          staticClass: "option__desc"
        }, [_c('span', {
          staticClass: "option__title"
        }, [_vm._v(_vm._s(props.option.name))])])]
      }
    }]),
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1044 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition-group', {
    attrs: {
      "tag": "div",
      "name": "fade"
    }
  }, _vm._l((_vm.records), function(record) {
    return _c('div', {
      key: record.id,
      staticClass: "record"
    }, [_c('record-item', {
      attrs: {
        "record": record,
        "read-only": _vm.readOnly,
        "selectedRecords": _vm.selectedRecords,
        "showSelectIndex": _vm.showSelectIndex,
        "isChoosingMode": _vm.isChoosingMode
      },
      on: {
        "delete-record-item": _vm.deleteRecord,
        "restore-record-item": _vm.restoreRecord,
        "edit-record-notes": _vm.editRecordNotes,
        "clicked-record-item": _vm.clickedRecordHandler,
        "mark-record-relevance-item": _vm.markRecord
      }
    })], 1)
  }), 0), _vm._v(" "), _c('div', [(_vm.recordPendingDeletion) ? _c('confirm-modal-2', {
    on: {
      "cancel": function($event) {
        _vm.recordPendingDeletion = null
      },
      "ok": _vm.confirmDeleteRecord
    }
  }, [_c('template', {
    slot: "content"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('records.delete_confirmation')))])]), _vm._v(" "), _c('template', {
    slot: "ok"
  }, [_vm._v(_vm._s(_vm.$t('delete')))])], 2) : _vm._e(), _vm._v(" "), (_vm.recordNotesBeingEdited) ? _c('modal', {
    attrs: {
      "show": !!_vm.recordNotesBeingEdited,
      "okBtnText": _vm.$t('save'),
      "disableOkBtn": _vm.disableCommentModalBtn
    },
    on: {
      "ok": _vm.saveRecordComment,
      "hide": _vm.closeCommentModal
    }
  }, [_c('template', {
    slot: "body"
  }, [_c('div', {
    staticClass: "edit-record-notes form-group"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordTitleEdited),
      expression: "recordTitleEdited"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "record-title",
      "rows": "8",
      "cols": "80"
    },
    domProps: {
      "value": (_vm.recordTitleEdited)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.recordTitleEdited = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.recordHasDescriptionField) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordDescriptionEdited),
      expression: "recordDescriptionEdited"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "record-description",
      "rows": "8",
      "cols": "80"
    },
    domProps: {
      "value": (_vm.recordDescriptionEdited)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.recordDescriptionEdited = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.recordHasComment) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordCommentEdited),
      expression: "recordCommentEdited"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "record-description",
      "rows": "8",
      "cols": "80"
    },
    domProps: {
      "value": (_vm.recordCommentEdited)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.recordCommentEdited = $event.target.value
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.recordNotesSaveInProgress),
      expression: "recordNotesSaveInProgress"
    }],
    staticClass: "loading-indicator"
  })])])], 2) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1045 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "radio",
      "name": "revealAtChoice"
    },
    domProps: {
      "checked": _vm.value === 'immediate'
    },
    on: {
      "click": function($event) {
        return _vm.setValueTo('immediate')
      }
    }
  }), _vm._v("\n      " + _vm._s(_vm.$t("marker.reveal_immediate")) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "radio",
      "name": "revealAtChoice"
    },
    domProps: {
      "checked": _vm.value === 'eventstart'
    },
    on: {
      "click": function($event) {
        return _vm.setValueTo('eventstart')
      }
    }
  }), _vm._v("\n      " + _vm._s(_vm.$t("marker.reveal_event_start")) + "\n    ")])])])
},staticRenderFns: []}

/***/ }),
/* 1046 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "marker-edit"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.$route.meta.existingMarker) ? _c('h2', {
    staticClass: "feature"
  }, [_vm._v(_vm._s(_vm.$t("marker.edit")))]) : _c('h2', {
    staticClass: "feature"
  }, [_vm._v(_vm._s(_vm.$t("marker.create")))])])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.stopPropagation();
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t("marker.name")))]), _vm._v(" "), _c('input-localized-textarea', {
    attrs: {
      "locales": _vm.locales,
      "current-locale": _vm.currentEditLocale,
      "attrs": {
        placeholder: _vm.$t('marker.placeholder.name'),
        maxlength: 32,
        name: 'name',
        required: true,
        rows: 1,
        autofocus: true,
        disabled: _vm.disabled
      }
    },
    model: {
      value: (_vm.marker.name),
      callback: function($$v) {
        _vm.$set(_vm.marker, "name", $$v)
      },
      expression: "marker.name"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t("marker.description")))]), _vm._v(" "), _c('input-localized-textarea', {
    attrs: {
      "locales": _vm.locales,
      "current-locale": _vm.currentEditLocale,
      "attrs": {
        placeholder: _vm.$t('marker.placeholder.description'),
        maxlength: 55,
        name: 'description',
        required: true,
        rows: 2,
        autofocus: false,
        disabled: _vm.disabled
      }
    },
    model: {
      value: (_vm.marker.description),
      callback: function($$v) {
        _vm.$set(_vm.marker, "description", $$v)
      },
      expression: "marker.description"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t("marker.long_description")))]), _vm._v(" "), _c('input-localized-textarea', {
    attrs: {
      "locales": _vm.locales,
      "current-locale": _vm.currentEditLocale,
      "attrs": {
        placeholder: _vm.$t('marker.placeholder.long_description'),
        maxlength: 600,
        name: 'long_description',
        required: true,
        rows: 3,
        autofocus: false,
        disabled: _vm.disabled
      }
    },
    model: {
      value: (_vm.marker.long_description),
      callback: function($$v) {
        _vm.$set(_vm.marker, "long_description", $$v)
      },
      expression: "marker.long_description"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "locale-selection"
  }, _vm._l((_vm.locales), function(l) {
    return _c('a', {
      class: {
        'selected': l === _vm.currentEditLocale
      },
      attrs: {
        "href": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          _vm.currentEditLocale = l
        }
      }
    }, [(l == "en") ? _c('span', [_vm._v(_vm._s(l) + " (default)")]) : _c('span', [_vm._v(_vm._s(l))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "ml_keyword"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('marker.placeholder.ml_keyword')) + "\n          ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.marker.ml_keyword),
      expression: "marker.ml_keyword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "ml_keyword",
      "id": "ml_keyword",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.marker.ml_keyword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.marker, "ml_keyword", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "ml_keyword"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('marker.targeted_user_groups')) + "\n          ")]), _vm._v(" "), (_vm.groups) ? _c('group-selector', {
    attrs: {
      "groups": _vm.groups
    },
    model: {
      value: (_vm.marker.targeted_groups),
      callback: function($$v) {
        _vm.$set(_vm.marker, "targeted_groups", $$v)
      },
      expression: "marker.targeted_groups"
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.brands.length > 1),
      expression: "brands.length > 1"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('brand-selector', {
    staticClass: "brand-selection",
    attrs: {
      "brands": _vm.brands
    },
    model: {
      value: (_vm.marker.brand),
      callback: function($$v) {
        _vm.$set(_vm.marker, "brand", $$v)
      },
      expression: "marker.brand"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row flex-container flex-stretch flex-reverse-wrap"
  }, [_c('div', {
    staticClass: "col-md-7 col-xs-12",
    attrs: {
      "id": "location-time-container"
    }
  }, [_c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('marker.location')) + " "), _c('small', {
    staticClass: "smaller"
  }, [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.edit = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('marker.edit_on_map')))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('input-places', {
    attrs: {
      "position": _vm.position,
      "attrs": {
        id: 'input-places',
        placeholder: _vm.$t('marker.placeholder.address'),
        disabled: _vm.disabled
      }
    },
    on: {
      "place-selected": _vm.updateMarkerPosition
    }
  }, [_c('label', {
    attrs: {
      "slot": "before",
      "for": "input-places"
    },
    slot: "before"
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('marker.address')) + " "), _c('small', {
    staticClass: "optional"
  }, [_vm._v(_vm._s(_vm.$t("optional")))])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-4"
  }, [_c('label', {
    attrs: {
      "for": "radius"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t("marker.radius")) + " "), _c('small', [_vm._v("(" + _vm._s(_vm.$t("marker.meters")) + ")")])]), _vm._v(" "), _c('input-number', {
    attrs: {
      "id": "radius",
      "increment-by": "100",
      "max-value": _vm.maxRadius,
      "min-value": "50",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.marker.radius),
      callback: function($$v) {
        _vm.$set(_vm.marker, "radius", $$v)
      },
      expression: "marker.radius"
    }
  })], 1)])]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t("marker.time")))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "startsat"
    }
  }, [_vm._v(_vm._s(_vm.$t("marker.start_date")))]), _vm._v(" "), _c('input-datetime', {
    attrs: {
      "attrs": {
        id: 'startsat',
        placeholder: 'Starts on',
        disabled: _vm.disabled
      }
    },
    model: {
      value: (_vm.marker.starts_at),
      callback: function($$v) {
        _vm.$set(_vm.marker, "starts_at", $$v)
      },
      expression: "marker.starts_at"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "endsat"
    }
  }, [_vm._v(_vm._s(_vm.$t("marker.end_date")))]), _vm._v(" "), _c('input-datetime', {
    attrs: {
      "attrs": {
        id: 'endsat',
        placeholder: 'Ends on',
        disabled: _vm.disabled
      }
    },
    model: {
      value: (_vm.marker.ends_at),
      callback: function($$v) {
        _vm.$set(_vm.marker, "ends_at", $$v)
      },
      expression: "marker.ends_at"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 flex-container flex-stretch",
    attrs: {
      "id": "map-preview-container"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.edit = true
      }
    }
  }, [_c('map-preview', {
    staticStyle: {
      "flex": "1",
      "position": "relative"
    },
    attrs: {
      "position": _vm.position
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.startsInTheFuture),
      expression: "startsInTheFuture"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    attrs: {
      "for": "revealAtChoice"
    }
  }, [_vm._v(_vm._s(_vm.$t("marker.reveal_at")))]), _vm._v(" "), _c('input-reveal-at', {
    model: {
      value: (_vm.revealAtChoice),
      callback: function($$v) {
        _vm.revealAtChoice = $$v
      },
      expression: "revealAtChoice"
    }
  })], 1)]), _vm._v(" "), (!_vm.existingMarker) ? _c('div', {
    staticClass: "row"
  }, [_c('duration-helper', {
    attrs: {
      "start": _vm.marker.starts_at,
      "end": _vm.marker.ends_at
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t("marker.additional_settings")))]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.marker.is_push_forced),
      expression: "marker.is_push_forced"
    }],
    attrs: {
      "type": "checkbox",
      "id": "force-push",
      "name": "force-push"
    },
    domProps: {
      "checked": Array.isArray(_vm.marker.is_push_forced) ? _vm._i(_vm.marker.is_push_forced, null) > -1 : (_vm.marker.is_push_forced)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.marker.is_push_forced,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.marker, "is_push_forced", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.marker, "is_push_forced", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.marker, "is_push_forced", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "force-push"
    }
  }, [_vm._v("Send notifications to all users in selected groups")]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('span', {
    staticClass: " glyphicon glyphicon-info-sign",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }), _vm._v(" "), _c('span', [_vm._v("indepent of location - if no group is selected, all users will be notified")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-full-width",
    attrs: {
      "type": "submit",
      "disabled": _vm.disabled || _vm.loading
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading-indicator",
    staticStyle: {
      "margin-top": "16px"
    }
  })])])]), _vm._v(" "), (_vm.edit) ? _c('map-editor', {
    attrs: {
      "transition": "modal",
      "position": _vm.position,
      "max-radius": _vm.maxRadius,
      "attrs": {
        'placeholder': _vm.$t('marker.placeholder.address_search')
      }
    },
    on: {
      "position-changed": _vm.updateMarkerPosition,
      "close": function($event) {
        _vm.edit = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "record-details-container",
    on: {
      "click": _vm.close
    }
  }, [(_vm.recordCutEnabled) ? _c('RecordCut', {
    attrs: {
      "record": _vm.record,
      "processing": _vm.cutProcessing
    },
    on: {
      "cut-started": _vm.showCutSpinner,
      "cancel": function($event) {
        _vm.recordCutEnabled = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "close close-detail-video",
    staticStyle: {
      "position": "absolute",
      "top": "10px",
      "right": "40px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.close($event)
      }
    }
  }, [_vm._v("x")]), _vm._v(" "), _c('v-item-group', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [(_vm.record.title && _vm.$root.$children[0].$data.clientId != 'digiteka') ? _c('h2', {
    staticClass: "align-center"
  }, [_vm._v(_vm._s(_vm.record.title))]) : _vm._e(), _vm._v(" "), (_vm.record.description && _vm.$root.$children[0].$data.clientId != 'digiteka') ? _c('h2', {
    directives: [{
      name: "else",
      rawName: "v-else",
      value: (_vm.record.description),
      expression: "record.description"
    }]
  }, [_vm._v(_vm._s(_vm.record.description))]) : _vm._e(), _vm._v(" "), (_vm.record.title && _vm.$root.$children[0].$data.clientId === 'digiteka') ? _c('h2', {
    ref: "testRef",
    staticClass: "align-center record-detail-title"
  }, [_vm._v(_vm._s(_vm.record.title) + "\n      "), (_vm.record.description) ? _c('span', {
    directives: [{
      name: "else",
      rawName: "v-else",
      value: (_vm.record.description),
      expression: "record.description"
    }]
  }, [_vm._v(" (" + _vm._s(_vm.record.description) + ")")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs": "12",
      "md": "12"
    }
  }, [_c('v-item', [(_vm.record.record_type === 'VIDEO') ? _c('div', [_c('record-player', {
    ref: "playerComponent",
    attrs: {
      "options": _vm.getRecordPlayerOptions(_vm.record)
    }
  }), _vm._v(" "), (!(_vm.record.mldata.approved || _vm.record.mldata.deleted_at || _vm.cutCacheUpdateLock) && _vm.$root.$children[0].$data.clientId != 'digiteka') ? _c('v-btn', {
    staticClass: "btn btn-primary",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.showRecordCut()
      }
    }
  }, [(_vm.cutProcessing) ? [_c('span', [_vm._v("Cutting")]), _vm._v(" "), _c('span', {
    staticClass: "loading-indicator"
  })] : _c('span', [_vm._v("Cut")])], 2) : _vm._e(), _vm._v(" "), (_vm.$root.$children[0].$data.clientId != 'digiteka') ? _c('v-btn', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.close($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel')))]) : _vm._e()], 1) : (_vm.record.record_type === 'IMAGE') ? _c('div', [_c('a', {
    attrs: {
      "href": _vm.record.play_link,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.record.thumbnail_link
    }
  })])]) : _vm._e()])], 1), _vm._v(" "), (_vm.$root.$children[0].$data.clientId != 'digiteka') ? _c('v-flex', {
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('ul', [(_vm.record.title) ? _c('li', [_c('span', {
    staticClass: "record-attribute"
  }, [_vm._v(_vm._s(_vm.$t('detail_video.title').toUpperCase()))]), _vm._v(_vm._s(_vm.record.title))]) : _vm._e(), _vm._v(" "), (_vm.record.description) ? _c('li', [_c('span', {
    staticClass: "record-attribute"
  }, [_vm._v(_vm._s(_vm.$t('detail_video.description').toUpperCase()))]), _vm._v(_vm._s(_vm.record.description))]) : _vm._e(), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "record-attribute"
  }, [_vm._v(_vm._s(_vm.$t('detail_video.user').toUpperCase()))]), _vm._v(_vm._s(_vm.record.user_full_name))]), _vm._v(" "), (_vm.record.contact_phone) ? _c('li', [_c('span', {
    staticClass: "record-attribute"
  }, [_vm._v("Contact phone")]), _c('a', {
    attrs: {
      "href": 'tel:' + _vm.record.contact_phone
    }
  }, [_vm._v(_vm._s(_vm.record.contact_phone))])]) : _vm._e(), _vm._v(" "), (_vm.record.email) ? _c('li', [_c('span', {
    staticClass: "record-attribute"
  }, [_vm._v("Email")]), _c('a', {
    attrs: {
      "href": 'email:' + _vm.record.email
    }
  }, [_vm._v(_vm._s(_vm.record.email))])]) : _vm._e(), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "record-attribute"
  }, [_vm._v(_vm._s(_vm.$t('detail_video.user_group').toUpperCase()))]), _vm._v(" "), _vm._l((_vm.record.groups), function(group) {
    return _c('span', {
      staticClass: "user-group tag"
    }, [_vm._v(_vm._s(group.group_name))])
  })], 2), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "record-attribute"
  }, [_vm._v(_vm._s(_vm.$t('detail_video.date').toUpperCase()))]), _vm._v(_vm._s(_vm.recordDate))]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "record-attribute"
  }, [_vm._v(_vm._s(_vm.$t('detail_video.time').toUpperCase()))]), _vm._v(_vm._s(_vm.recordTime) + " " + _vm._s(_vm.recordTz))]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "record-attribute"
  }, [_vm._v(_vm._s(_vm.$t('detail_video.gps').toUpperCase()))]), _vm._v(_vm._s(_vm.recordCoordinates))]), _vm._v(" "), (_vm.vod) ? _c('li', [_c('span', {
    staticClass: "record-attribute"
  }, [_vm._v(_vm._s(_vm.$t('detail_video.duration').toUpperCase()))]), _vm._v(_vm._s(_vm._f("round")(_vm.vod.duration)) + "s")]) : _vm._e(), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "record-attribute"
  }, [_vm._v(_vm._s(_vm.$t('detail_video.device').toUpperCase()))]), _vm._v(_vm._s(_vm.record.device.mobile_type) + " " + _vm._s(_vm.record.device.os_version))]), _vm._v(" "), (_vm.vod) ? _c('li', [_c('span', {
    staticClass: "record-attribute"
  }, [_vm._v(_vm._s(_vm.$t('detail_video.resolution').toUpperCase()))]), _vm._v(" " + _vm._s(_vm.vod.width) + " x " + _vm._s(_vm.vod.height))]) : _vm._e(), _vm._v(" "), (_vm.vod) ? _c('li', [_c('span', {
    staticClass: "record-attribute"
  }, [_vm._v(_vm._s(_vm.$t('detail_video.size').toUpperCase()))]), _vm._v(_vm._s(_vm._f("filesize")(_vm.vod.size)) + _vm._s(_vm.$t('MB')))]) : _vm._e(), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "record-attribute"
  }, [_vm._v(_vm._s(_vm.$t('detail_video.full_address').toUpperCase()))]), _vm._v(_vm._s(_vm.record.vod_full_address) + " ")]), _vm._v(" "), (_vm.record.comment) ? _c('li', [_c('span', {
    staticClass: "record-attribute"
  }, [_vm._v(_vm._s(_vm.$t('detail_video.comment').toUpperCase()))]), _vm._v(_vm._s(_vm.record.comment))]) : _vm._e(), _vm._v(" "), (_vm.isLmrConsumer) ? _c('li', [_c('span', {
    staticClass: "record-attribute"
  }, [_vm._v(_vm._s(_vm.$t('detail_video.category').toUpperCase()))]), _vm._v(_vm._s(_vm.record.lmr_category) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('li', [_vm._v(" ")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "display": "flex",
      "justify-content": "flex-start",
      "align-items": "center"
    }
  }, [_c('span', {
    staticClass: "record-attribute",
    staticStyle: {
      "flex": "0 0 200px"
    }
  }, [_vm._v(_vm._s(_vm.$t('detail_video.detected_tags').toUpperCase()))]), _vm._v(" "), (!_vm.editTagsActive) ? _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._l((_vm.tags), function(tag) {
    return _c('span', {
      staticClass: "ml tag"
    }, [_vm._v(_vm._s(tag))])
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "fab": "",
      "small": "",
      "color": "primary",
      "title": "Edit tags"
    },
    on: {
      "click": _vm.toggleEditTagsMode
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(961),
      "alt": "Edit"
    }
  })])], 2) : _c('div', {
    staticClass: "text-right",
    staticStyle: {
      "flex-grow": "1"
    }
  }, [_c('Multiselect', {
    attrs: {
      "multiple": true,
      "taggable": true,
      "options": _vm.tagsSelectOptions,
      "track-by": "name",
      "label": "name"
    },
    on: {
      "tag": _vm.addTag
    },
    model: {
      value: (_vm.editableTags),
      callback: function($$v) {
        _vm.editableTags = $$v
      },
      expression: "editableTags"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "font-weight-bold",
    attrs: {
      "small": "",
      "color": "primary"
    },
    on: {
      "click": _vm.saveTags
    }
  }, [_vm._v("SAVE")]), _vm._v(" "), _c('v-btn', {
    staticClass: "font-weight-bold",
    attrs: {
      "small": "",
      "color": "primary"
    },
    on: {
      "click": _vm.toggleEditTagsMode
    }
  }, [_vm._v("CANCEL")])], 1)])])]) : _vm._e()], 1), _vm._v(" "), (_vm.similarRecords.length) ? _c('div', {
    staticClass: "record-details-similar"
  }, [_c('h4', [_vm._v("Other videos")]), _vm._v(" "), _c('transition-group', {
    staticClass: "record-details-similar-thumbs",
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, _vm._l((_vm.similarRecords), function(record) {
    return _c('thumbnail', {
      key: record.id,
      staticClass: "thumbnail clickable center-block",
      attrs: {
        "media": record.media,
        "default": record.thumbnail_link
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.clickedRecordHandler(record)
        }
      }
    })
  }), 1)], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1048 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "videoPlayer"
  }, [(!_vm.playerReady) ? _c('div', {
    staticClass: "loading-container vjs-waiting",
    attrs: {
      "slot": "loading"
    },
    slot: "loading"
  }, [_c('div', {
    staticClass: "vjs-loading-spinner",
    attrs: {
      "dir": "ltr"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.playerReady),
      expression: "playerReady"
    }],
    staticClass: "videojs-player",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('video', {
    staticClass: "video-js vjs-big-play-centered",
    attrs: {
      "id": _vm.playerElement
    },
    on: {
      "seeked": _vm.seekedEvent,
      "timeupdate": _vm.timeUpdateEvent,
      "playing": _vm.playingEvent,
      "pause": _vm.pauseEvent,
      "ended": _vm.endedEvent
    }
  }, [(_vm.record.url) ? _c('source', {
    attrs: {
      "src": _vm.record.url,
      "type": _vm.record.mimetype
    }
  }) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 1049 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group film_something_now_enabled"
  }), _vm._v(" "), _c('fieldset', {
    staticStyle: {
      "border": "10px"
    }
  }, [_c('legend', [_vm._v(_vm._s(_vm.$t("settings.ftp")))]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Host",
      "required": ""
    },
    model: {
      value: (_vm.settings.ftp.host),
      callback: function($$v) {
        _vm.$set(_vm.settings.ftp, "host", $$v)
      },
      expression: "settings.ftp.host"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Path",
      "required": ""
    },
    model: {
      value: (_vm.settings.ftp.path),
      callback: function($$v) {
        _vm.$set(_vm.settings.ftp, "path", $$v)
      },
      expression: "settings.ftp.path"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "User",
      "required": ""
    },
    model: {
      value: (_vm.settings.ftp.user),
      callback: function($$v) {
        _vm.$set(_vm.settings.ftp, "user", $$v)
      },
      expression: "settings.ftp.user"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--focused",
    attrs: {
      "append-icon": _vm.showPwd ? 'visibility' : 'visibility_off',
      "type": _vm.showPwd ? 'text' : 'password',
      "label": "Password",
      "required": ""
    },
    on: {
      "click:append": function($event) {
        _vm.showPwd = !_vm.showPwd
      }
    },
    model: {
      value: (_vm.settings.ftp.password),
      callback: function($$v) {
        _vm.$set(_vm.settings.ftp, "password", $$v)
      },
      expression: "settings.ftp.password"
    }
  })], 1), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t("settings.push_localization")))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t("settings.push_thank_you")))]), _vm._v(" "), _c('input-localized-textarea', {
    attrs: {
      "locales": _vm.locales,
      "current-locale": _vm.currentEditLocale,
      "attrs": {
        placeholder: _vm.$t('settings.push_thank_you'),
        maxlength: 100,
        name: 'push_thank_you',
        required: true,
        rows: 1,
        autofocus: false,
      }
    },
    model: {
      value: (_vm.settings.localized_thank_you),
      callback: function($$v) {
        _vm.$set(_vm.settings, "localized_thank_you", $$v)
      },
      expression: "settings.localized_thank_you"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t("settings.push_marker_request")))]), _vm._v(" "), _c('input-localized-textarea', {
    attrs: {
      "locales": _vm.locales,
      "current-locale": _vm.currentEditLocale,
      "attrs": {
        placeholder: _vm.$t('settings.push_marker_request'),
        maxlength: 100,
        name: 'push_marker_request',
        required: true,
        rows: 1,
        autofocus: false,
      }
    },
    model: {
      value: (_vm.settings.localized_marker_request),
      callback: function($$v) {
        _vm.$set(_vm.settings, "localized_marker_request", $$v)
      },
      expression: "settings.localized_marker_request"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "locale-selection"
  }, _vm._l((_vm.locales), function(l) {
    return _c('a', {
      key: l,
      class: {
        'selected': l === _vm.currentEditLocale
      },
      attrs: {
        "href": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          _vm.currentEditLocale = l
        }
      }
    }, [(l == "en") ? _c('span', [_vm._v(_vm._s(l) + " (default)")]) : _c('span', [_vm._v(_vm._s(l))])])
  }), 0), _vm._v(" "), _c('br')]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t("settings.choose_export")))]), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": "Export type",
      "items": _vm.exportTypes,
      "single-line": "",
      "attach": ""
    },
    model: {
      value: (_vm.settings.export_type),
      callback: function($$v) {
        _vm.$set(_vm.settings, "export_type", $$v)
      },
      expression: "settings.export_type"
    }
  })], 1), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t("settings.choose_export_individual_format")))]), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": "Export individual format",
      "items": _vm.exportIndividualFormats,
      "item-value": "value",
      "item-text": "text",
      "single-line": "",
      "attach": ""
    },
    model: {
      value: (_vm.settings.export_individual_format),
      callback: function($$v) {
        _vm.$set(_vm.settings, "export_individual_format", $$v)
      },
      expression: "settings.export_individual_format"
    }
  })], 1), _vm._v(" "), _c('fieldset', [_c('v-checkbox', {
    attrs: {
      "label": "Should the 'Film something now' button be enabled?"
    },
    model: {
      value: (_vm.settings.film_something_now_enabled),
      callback: function($$v) {
        _vm.$set(_vm.settings, "film_something_now_enabled", $$v)
      },
      expression: "settings.film_something_now_enabled"
    }
  })], 1), _vm._v(" "), _c('fieldset', {
    staticStyle: {
      "border": "10px"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "iOS app version"
    },
    model: {
      value: (_vm.settings.ios_app_version),
      callback: function($$v) {
        _vm.$set(_vm.settings, "ios_app_version", $$v)
      },
      expression: "settings.ios_app_version"
    }
  })], 1), _vm._v(" "), _c('fieldset', {
    staticStyle: {
      "border": "10px"
    }
  }, [_c('legend', [_vm._v("Video quality")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('v-select', {
    attrs: {
      "label": "WiFi",
      "items": _vm.videoQualityVariants,
      "attach": ""
    },
    model: {
      value: (_vm.settings.video_quality.wifi),
      callback: function($$v) {
        _vm.$set(_vm.settings.video_quality, "wifi", $$v)
      },
      expression: "settings.video_quality.wifi"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('v-select', {
    attrs: {
      "label": "4G",
      "items": _vm.videoQualityVariants,
      "attach": ""
    },
    model: {
      value: (_vm.settings.video_quality.mobile_4g),
      callback: function($$v) {
        _vm.$set(_vm.settings.video_quality, "mobile_4g", $$v)
      },
      expression: "settings.video_quality.mobile_4g"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('v-select', {
    attrs: {
      "label": "3G",
      "items": _vm.videoQualityVariants,
      "attach": ""
    },
    model: {
      value: (_vm.settings.video_quality.mobile_3g),
      callback: function($$v) {
        _vm.$set(_vm.settings.video_quality, "mobile_3g", $$v)
      },
      expression: "settings.video_quality.mobile_3g"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('v-flex', {
    attrs: {
      "md3": ""
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-full-width",
    attrs: {
      "type": "submit",
      "disabled": _vm.loading
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1050 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "center-block loading-indicator"
  }), _vm._v(" "), (_vm.marker) ? _c('marker-details', {
    attrs: {
      "marker": _vm.marker
    }
  }) : _vm._e(), _vm._v(" "), (_vm.marker) ? _c('marker-messages', {
    attrs: {
      "marker-id": _vm.marker.id
    }
  }) : _vm._e(), _vm._v(" "), (_vm.marker) ? _c('marker-records', {
    attrs: {
      "marker": _vm.marker
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1051 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$store.client_id))]), _vm._v(" "), _c('div', {
    staticClass: "login-form col-md-8 center-block",
    staticStyle: {
      "float": "none"
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.clientId),
      expression: "credentials.clientId"
    }],
    staticClass: "form-control btn-full-width",
    attrs: {
      "placeholder": "Client ID",
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.credentials.clientId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "clientId", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.email),
      expression: "credentials.email"
    }],
    staticClass: "form-control btn-full-width",
    attrs: {
      "placeholder": "Email",
      "type": "email",
      "required": "",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.credentials.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.password),
      expression: "credentials.password"
    }],
    staticClass: "form-control btn-full-width",
    attrs: {
      "placeholder": "Password",
      "type": "password",
      "required": ""
    },
    domProps: {
      "value": (_vm.credentials.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors),
      expression: "errors"
    }],
    staticClass: "errors"
  }, [_vm._v("\n          ⚠\n          " + _vm._s(_vm.errors) + "\n        ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Log in")])])
}]}

/***/ }),
/* 1052 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('link', {
    attrs: {
      "rel": "stylesheet",
      "href": "/static/css/digiteka.css",
      "type": "text/css",
      "media": "all"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "login-form col-md-8 center-block",
    staticStyle: {
      "float": "none"
    }
  }, [_c('h1', [_vm._v("Login on Media Platform")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.email),
      expression: "credentials.email"
    }],
    staticClass: "form-control btn-full-width",
    attrs: {
      "placeholder": "Email",
      "type": "email",
      "required": "",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.credentials.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.password),
      expression: "credentials.password"
    }],
    staticClass: "form-control btn-full-width",
    attrs: {
      "placeholder": "Password",
      "type": "password",
      "required": ""
    },
    domProps: {
      "value": (_vm.credentials.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors),
      expression: "errors"
    }],
    staticClass: "errors"
  }, [_vm._v("\n          ⚠\n          " + _vm._s(_vm.errors) + "\n        ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Log in")])])
}]}

/***/ }),
/* 1053 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dropdown', {
    staticClass: "event-options"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-option-horizontal clickable options-trigger",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu show",
    attrs: {
      "slot": "options"
    },
    slot: "options"
  }, [_c('li', [_c('ftp-sync-button')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1054 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', [_vm._v("Inappropriate")]), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "row": true
    },
    on: {
      "change": _vm.changeValue
    },
    model: {
      value: (_vm.val),
      callback: function($$v) {
        _vm.val = $$v
      },
      expression: "val"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Hide",
      "value": "hide"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Show",
      "value": "show"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Only",
      "value": "only"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1055 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v(_vm._s(_vm.formatted))])
},staticRenderFns: []}

/***/ }),
/* 1056 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-details-container"
  }, [_c('h1', [_vm._v("User Details")]), _vm._v(" "), _c('div', {
    staticClass: "full-name"
  }, [_c('div', [_vm._v(_vm._s(_vm.fullName))])]), _vm._v(" "), _c('div', {
    staticClass: "user-data-container"
  }, [_c('div', {
    staticClass: "avatar"
  }, [_c('img', {
    attrs: {
      "src": _vm.avatar,
      "width": "200",
      "height": "200"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "user-data-1"
  }, [_c('div', [_vm._v(" FIRST NAME - " + _vm._s(_vm.profile.first_name))]), _vm._v(" "), _c('div', [_vm._v(" LAST NAME - " + _vm._s(_vm.profile.last_name))]), _vm._v(" "), _c('div', [_vm._v(" EMAIL - " + _vm._s(_vm.profile.email))]), _vm._v(" "), _c('div', [_vm._v(" BIRTHDATE - " + _vm._s(_vm.profile.birthdate))])]), _vm._v(" "), _c('div', {
    staticClass: "user-data-2"
  }, [_c('div', [_vm._v(" CITY - " + _vm._s(_vm.profile.place))]), _vm._v(" "), _c('div', [_vm._v(" DATE CREATED - " + _vm._s(_vm.profile.date_joined))]), _vm._v(" "), _c('div', [_vm._v(" USER GROUPS - " + _vm._s(_vm.profile.user_groups))])])]), _vm._v(" "), _c('div', {
    staticClass: "user-records-title"
  }, [_c('h1', [_vm._v("Recorded videos (" + _vm._s(_vm.profile.valid_records_amt) + " (" + _vm._s(_vm.profile.all_records_amt) + ")) - Missions (" + _vm._s(_vm.profile.events_amt) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "user-records"
  }, [_c('user-records', {
    attrs: {
      "userId": _vm.userId
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1057 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.locales), function(l) {
    return _c('div', {
      staticClass: "locale-textarea"
    }, [_c('textarea', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (l === _vm.currentLocale),
        expression: "l === currentLocale"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "id": ("input-locale-" + _vm.id + "-" + l),
        "maxlength": _vm.attrs.maxlength,
        "placeholder": ((_vm.attrs.placeholder) + " (" + l + ")"),
        "disabled": _vm.attrs.disabled,
        "rows": _vm.attrs.rows,
        "autofocus": _vm.attrs.autofocus
      },
      domProps: {
        "value": _vm.value[l]
      },
      on: {
        "blur": _vm.validate,
        "input": function($event) {
          return _vm.setValue(l, $event)
        }
      }
    })])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 1058 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.playerOptions) ? _c('RecordPlayer', {
    ref: "playerComponent",
    attrs: {
      "options": _vm.playerOptions,
      "size-styles": {
        width: '100%',
        height: '400px'
      }
    },
    on: {
      "timeupdate": _vm.playerTimeUpdateHandler,
      "pause": function($event) {
        _vm.playing = false
      },
      "ended": function($event) {
        _vm.playing = false
      },
      "playing": function($event) {
        _vm.playing = true
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "slider",
    staticClass: "cut-slider"
  }, [_c('div', {
    staticClass: "frames"
  }, _vm._l((_vm.frames), function(frame, index) {
    return _c('div', {
      key: index,
      style: ([_vm.frameStyle, frame])
    })
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "mask left",
    style: (_vm.leftMaskStyle)
  }), _vm._v(" "), _c('div', {
    ref: "leftControl",
    staticClass: "controller left",
    style: (_vm.leftControlStyle),
    on: {
      "mousedown": _vm.dragLeftControlStart,
      "touchstart": _vm.dragTouchLeftControlStart
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "active-section",
    on: {
      "click": _vm.setRunnerPos
    }
  }, [(_vm.showControlTime) ? _c('div', {
    staticClass: "left"
  }, [_vm._v("\n        " + _vm._s(_vm.leftControlVideoPositionFormatted) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "video-duration"
  }, [_vm._v(_vm._s(_vm.videoSectionDurationFormatted))]), _vm._v(" "), (_vm.showControlTime) ? _c('div', {
    staticClass: "right"
  }, [_vm._v("\n        " + _vm._s(_vm.rightControlVideoPositionFormatted) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    ref: "rightControl",
    staticClass: "controller right",
    style: (_vm.rightControlStyle),
    on: {
      "mousedown": _vm.dragRightControlStart,
      "touchstart": _vm.dragTouchRightControlStart
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mask right",
    style: (_vm.rightMaskStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "runner",
    style: (_vm.runnerStyle)
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('v-btn', {
    staticClass: "btn-primary play-btn",
    attrs: {
      "flat": "",
      "fab": ""
    },
    on: {
      "click": _vm.playRange
    }
  }, [(_vm.playing) ? _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("pause")]) : _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("play_arrow")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1059 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dendrogram-container"
  })
},staticRenderFns: []}

/***/ }),
/* 1060 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map-editor-modal-wrapper",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "map-editor-modal-container row",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    attrs: {
      "id": "map-editor"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "address-input"
  }, [_c('input-places', {
    staticClass: "col-md-6 col-md-offset-3",
    attrs: {
      "attrs": {
        id: 'input-places-map-editor',
        placeholder: _vm.attrs.placeholder
      }
    },
    on: {
      "place-selected": _vm.setPositionFromAddress
    }
  })], 1), _vm._v(" "), (_vm.showHelp) ? _c('div', {
    staticClass: "map-help col-md-3",
    attrs: {
      "transition": "fade"
    }
  }, [_c('a', {
    staticClass: "close clickable",
    on: {
      "click": function($event) {
        _vm.showHelp = false
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('map.help')))])]) : _vm._e(), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('ok')) + "\n      ")])])])])
},staticRenderFns: []}

/***/ }),
/* 1061 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', [_vm._v(_vm._s(_vm.$t("brand.label")))]), _vm._v(" "), _c('p', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.$t("brand.help")))]), _vm._v(" "), (_vm.brands.length) ? _c('div', {
    staticClass: "brand-selector"
  }, [_c('div', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showDropdown = true
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.selectedBrand.logo,
      "alt": ((_vm.selectedBrand.name) + " logo")
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.selectedBrand.name))]), _vm._v(" "), _c('span', {
    staticClass: "glyphicon glyphicon-menu-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu-container"
  }, [_c('ul', {
    staticClass: "dropdown-menu",
    class: {
      'show': _vm.showDropdown
    }
  }, _vm._l((_vm.brands), function(brand) {
    return _c('li', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.selectBrand(brand)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": brand.logo,
        "alt": ((brand.name) + " logo")
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "brand-name"
    }, [_vm._v(_vm._s(brand.name))])])
  }), 0)])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1062 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "record-cut-wrapper"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "h2 mb-3"
  }, [_vm._v("Video cutting")]), _vm._v(" "), _c('v-btn', {
    staticClass: "close-btn",
    attrs: {
      "flat": "",
      "fab": ""
    },
    on: {
      "click": _vm.closeCutWindow
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('RecordCutSlider', {
    attrs: {
      "record": _vm.record,
      "processing": _vm.processing
    },
    on: {
      "range-update": _vm.updateRange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "op-messages text-center"
  }, [(_vm.processing) ? _c('div', [_c('div', {
    staticClass: "loading-indicator center-block"
  }), _vm._v(" "), _c('div', [_vm._v("Video is being processed. Please wait for the operation to complete.")])]) : _vm._e()]), _vm._v(" "), (!_vm.processing) ? _c('div', {
    staticClass: "text-right mt-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.cut_btn_disabled
    },
    on: {
      "click": _vm.cutRecord
    }
  }, [_vm._v("Cut Record")])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1063 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-snackbar', {
    attrs: {
      "timeout": _vm.timeout,
      "color": _vm.color
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [(_vm.href) ? _c('a', {
    attrs: {
      "href": _vm.href,
      "target": "_blank"
    },
    on: {
      "click": _vm.hide
    }
  }, [_vm._v(_vm._s(_vm.message))]) : [_vm._v("\n    " + _vm._s(_vm.message) + "\n  ")], _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent",
      "timeout": 0
    },
    nativeOn: {
      "click": function($event) {
        return _vm.hide($event)
      }
    }
  }, [_vm._v("Close")])], 2)
},staticRenderFns: []}

/***/ }),
/* 1064 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "15px 35px"
    }
  }, [(_vm.messages.length > 0) ? _c('div', {
    staticClass: "message-tabs"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t("notifications.notifications")))]), _vm._v(" "), _vm._l((_vm.message_groups), function(mGroup) {
    return _c('div', {
      key: mGroup.key,
      attrs: {
        "title": mGroup.title
      },
      on: {
        "click": function($event) {
          return _vm.showMessages(mGroup)
        }
      }
    }, [_c('div', {
      class: mGroup.status_class
    }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.groupMessages(mGroup.key).length))])])
  })], 2) : _vm._e(), _vm._v(" "), _c('Modal', {
    attrs: {
      "show": _vm.messages_modal
    },
    on: {
      "hide": function($event) {
        _vm.messages_modal = false
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "message-tabs"
  }, [_vm._l((_vm.messageGroupStatuses(_vm.selectedGroupMessages)), function(status) {
    return _c('div', [_c('div', {
      class: ['status', status]
    }), _vm._v(" " + _vm._s(_vm.MESSAGE_STATUSES[status]) + "\n        ")])
  }), _vm._v(" "), _vm._l((_vm.messageGroupFailures(_vm.selectedGroupMessages)), function(failure) {
    return _c('div', [_c('div', {
      class: _vm.failureStatusClass(failure)
    }), _vm._v(" "), (failure in _vm.FAILURE_STATUSES) ? _c('div', [_vm._v("\n            " + _vm._s(_vm.FAILURE_STATUSES[failure].title) + "\n          ")]) : _c('div', [_vm._v(_vm._s(failure))])])
  })], 2), _vm._v(" "), _c('MessageGroupList', {
    attrs: {
      "messages": _vm.selectedGroupMessages,
      "failure_statuses": _vm.FAILURE_STATUSES
    }
  })], 1)]), _vm._v(" "), _c('div')], 1)
},staticRenderFns: []}

/***/ }),
/* 1065 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group places-input-group"
  }, [_vm._t("before"), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "id": _vm.attrs.id,
      "placeholder": _vm.attrs.placeholder,
      "disabled": _vm.attrs.disabled
    },
    domProps: {
      "value": _vm.inputValue
    },
    on: {
      "input": _vm.input,
      "focus": _vm.focus,
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        return _vm.up($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        return _vm.down($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.enter($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.triggerBlur($event)
      }],
      "blur": _vm.blur
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu-container"
  }, [_c('ul', {
    staticClass: "dropdown-menu",
    class: {
      'show': _vm.showDropdown
    }
  }, _vm._l((_vm.places), function(p, index) {
    return _c('li', {
      class: {
        'selected': index === _vm.selectedPlace
      },
      on: {
        "mousemove": function($event) {
          return _vm.setSelected(index)
        },
        "mousedown": function($event) {
          $event.preventDefault();
          return _vm.fetchPlace(p)
        }
      }
    }, [_vm._v(_vm._s(p.description) + "\n      ")])
  }), 0)]), _vm._v(" "), _vm._t("after")], 2)
},staticRenderFns: []}

/***/ }),
/* 1066 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v(_vm._s(_vm.formatted))])
},staticRenderFns: []}

/***/ }),
/* 1067 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("Authentification")])
},staticRenderFns: []}

/***/ }),
/* 1068 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "modal-mask",
    attrs: {
      "transition": "modal"
    },
    on: {
      "click": _vm.hide
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container modal-transition-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header")], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body")], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", [_c('button', {
    staticClass: "btn btn-full-width btn-primary modal-default-button",
    attrs: {
      "disabled": _vm.disableOkBtn
    },
    on: {
      "click": _vm.ok
    }
  }, [(_vm.okBtnText) ? [_vm._v(_vm._s(_vm.okBtnText))] : [_vm._v(_vm._s(_vm.$t('ok')) + " | " + _vm._s(_vm.okBtnText))]], 2), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])], 2)])])])
},staticRenderFns: []}

/***/ }),
/* 1069 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-radio-group', {
    staticClass: "lmr_category",
    attrs: {
      "row": true
    },
    on: {
      "change": _vm.changeValue
    },
    model: {
      value: (_vm.val),
      callback: function($$v) {
        _vm.val = $$v
      },
      expression: "val"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Infos locales",
      "value": "general"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Sports",
      "value": "sport"
    }
  }), _vm._v(" "), (this.$parent.consumer_group == 'ebra') ? _c('v-radio', {
    attrs: {
      "label": "Magazine",
      "value": "magazine"
    }
  }) : _vm._e(), _vm._v(" "), (this.$store.state.consumerName == 'lng') ? _c('v-radio', {
    attrs: {
      "label": "Faits Divers",
      "value": "faits_divers"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": _vm.$t('all'),
      "value": ""
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1070 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "markers-table"
  }, [_c('div', {
    staticClass: "row header hidden-xs hidden-sm"
  }, [_c('div', {
    staticClass: "col-md-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_vm._v(_vm._s(_vm.$t('marker.targeted_groups')))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_vm._v(_vm._s(_vm.$t('marker.start_date')))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_vm._v(_vm._s(_vm.$t('marker.end_date')))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_vm._v(_vm._s(_vm.$t('marker.records_count')))])]), _vm._v(" "), _vm._l((_vm.markers), function(marker) {
    return _c('marker-row', {
      key: marker.id,
      staticClass: "row",
      attrs: {
        "marker": marker
      },
      on: {
        "trash": _vm.deleteMarker
      }
    })
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 1071 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tag-filter"
  }, [_c('multiselect', {
    attrs: {
      "placeholder": _vm.$tc('marker.tags.placeholder'),
      "label": "name",
      "track-by": "name",
      "options": _vm.options,
      "multiple": "",
      "close-on-select": false,
      "loading": _vm.loading,
      "hide-selected": ""
    },
    on: {
      "input": _vm.inputHandler
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('div', {
          staticClass: "option__desc"
        }, [_c('span', {
          staticClass: "option__title"
        }, [_vm._v("\n                    " + _vm._s(props.option.name) + "\n                ")]), _vm._v(" "), _c('span', {
          staticClass: "option__small"
        }, [_vm._v("\n                    Records: " + _vm._s(props.option.records) + "\n                ")])])]
      }
    }]),
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1072 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default btn-number",
    attrs: {
      "type": "button",
      "disabled": _vm.$attrs.disabled
    },
    on: {
      "click": function($event) {
        return _vm.decrement()
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-minus"
  })])]), _vm._v(" "), _c('input', _vm._b({
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "pattern": "[0-9]*",
      "number": "",
      "required": ""
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.updateValue,
      "blur": _vm.updateValueWithBoundaries
    }
  }, 'input', _vm.$attrs, false)), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default btn-number",
    attrs: {
      "type": "button",
      "disabled": _vm.$attrs.disabled
    },
    on: {
      "click": function($event) {
        return _vm.increment()
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-plus"
  })])])])
},staticRenderFns: []}

/***/ }),
/* 1073 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "markers"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading-indicator center-block"
  }), _vm._v(" "), (_vm.sortedActiveMarkers.length) ? _c('div', {
    staticClass: "row marker-list"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t("marker.active")))]), _vm._v(" "), _c('markers-table', {
    attrs: {
      "markers": _vm.sortedActiveMarkers
    },
    on: {
      "trash": _vm.deleteMarker
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-md-offset-4"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-full-width",
    attrs: {
      "tag": "button",
      "to": {
        path: '/marker/edit'
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t("marker.add")) + "\n      ")])], 1)]), _vm._v(" "), (_vm.sortedFutureMarkers.length) ? _c('div', {
    staticClass: "row marker-list"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t("marker.future")))]), _vm._v(" "), _c('markers-table', {
    attrs: {
      "markers": _vm.sortedFutureMarkers
    },
    on: {
      "trash": _vm.deleteMarker
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.sortedPastMarkers.length) ? _c('div', {
    staticClass: "row marker-list"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('marker.past')))]), _vm._v(" "), _c('markers-table', {
    attrs: {
      "markers": _vm.sortedPastMarkers
    },
    on: {
      "trash": _vm.deleteMarker
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.amountPages,
      "total-visible": 10
    },
    on: {
      "input": function($event) {
        return _vm.fetchMarkersData()
      }
    },
    model: {
      value: (_vm.page),
      callback: function($$v) {
        _vm.page = $$v
      },
      expression: "page"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1074 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.messages.length) ? _c('div', {
    attrs: {
      "id": "service-msg"
    }
  }, _vm._l((_vm.openedMessages), function(msg) {
    return _c('div', {
      key: msg.text,
      staticClass: "msg-item"
    }, [_vm._v("\n    " + _vm._s(msg.text) + "\n    "), _c('a', {
      staticClass: "close",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.close(msg)
        }
      }
    }, [_vm._v("×")])])
  }), 0) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1075 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-indicator"
  })
},staticRenderFns: []}

/***/ }),
/* 1076 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tag-filter"
  }, [_c('multiselect', {
    attrs: {
      "placeholder": _vm.$tc('user.filter.usergroup'),
      "label": "name",
      "track-by": "name",
      "options": _vm.options,
      "searchable": false
    },
    on: {
      "input": _vm.inputHandler
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('div', {
          staticClass: "option__desc"
        }, [_c('span', {
          staticClass: "option__title"
        }, [_vm._v("\n                    " + _vm._s(props.option.name) + "\n                ")])])]
      }
    }]),
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */
/***/ (function(module, exports) {

module.exports = {"login":"Log in","logout":"Log out","ok":"OK","all":"All","Pro Apps":"Pro Apps","cancel":"Cancel","delete":"Delete","Ordering":"Ordering","confirmation":"Confirmation","save":"Save","optional":"Optional","time_ago":"{time} ago","spacing":"&zwnj;","language_input_required":"Please fill out this field in at least one language","update_available":"A new version of the Media Platform is available","update_prompt":"Please update to the latest version","update":"Update","individual_records":"Individual Records","digiteka_copy_link_title":"Digiteka link available - click to copy","new":"new","approved":"approved","deleted":"deleted","approve":"approve","approve_msg":"Your video has been approved","merge":"merge","merge_abd_approve":"merge and approve","merge_msg":"Records have been sent for merge","merge_and_approve_msg_pm":"Records have been sent for merge and will be approved after merging","merge_and_approve_msg_iframe_digiteka":"Records have been sent for merge and will be approved after merging - please find it in \"my videos\" tab","reject":"reject","error":{"generic":"Service temporarily unavailable","access_denied":"Access denied","connection":"Could not connect to the Veriflix servers","forbidden":"Your account lacks the necessary permissions for this action.","contact_us":"Please <a href=\"mailto:media-platform@look-app.net\">contact us</a> to verify your access to the Media Platform.","server":"Oh no! An error has occurred while processing your request.","apologies":"We apologize for the trouble. Our team has been notified and will resolve the issue as soon as possible!","help":"You may <a href=\"javascript:window.location.reload(true)\">refresh the page and try again</a>, go back to the <a href=\"/\">home page</a>, or <a href=\"mailto:media-platform@look-app.net\">contact us</a> if the issue persists."},"brand":{"label":"Branding","help":"Select the brand to use for this marker:"},"user":{"users":"Users","view":"View","filter":{"name":"Search by name","usergroup":"Filter by Edition","filter_by_user":"Filter by User","consumer":"Filter by Consumer"}},"ordering":{"by_shooting_date_new_old":"Order by shooting date: newest - oldest","by_shooting_date_old_new":"Order by shooting date: oldest - newest","by_approve_date_new_old":"Order by approved date: newest - oldest","by_approve_date_old_new":"Order by approved date: oldest - newest"},"departments":{"all":"All","filter_by_department":"Filter by department"},"marker":{"add":"Add a new event","past":"Archives","future":"Future events","active":"Active events","event":"Event","events":"Events","targeted_groups":"Targeted groups","start_date":"Starts on","end_date":"Ends on","create":"Create a new event","edit":"Edit the event details","download_csv":"Export event data as .csv","delete_confirmation":"Do you want to delete this event?","address":"Address","latitude":"latitude","longitude":"longitude","radius":"radius","meters":"meters","location":"Location","time":"Time","additional_settings":"Additional Settings","name":"Event title","description":"Event short description","long_description":"Event long description","info_link":"Event information URL","thanks_link":"Post-video redirect URL","reveal_at":"Reveal the event to the app users","reveal_immediate":"Immediately","reveal_event_start":"When the event starts","tags":{"title":"Tag filtering","placeholder":"Search for a tag"},"placeholder":{"name":"The name of this event","description":"The event description","long_description":"A longer description of the event","ml_keyword":"Keyword (Machine learning beta)","address":"Type an address here or use the map to pick a place","address_search":"Type here to search for an address","info_link":"(optional) Enter an URL here to direct users towards more information about the event (must start in http:// or https://)","thanks_link":"(optional) An URL to redirect users to after they record a video (must start in http:// or https://)","push_comment":"Send a personalized comment"},"ftp":{"synchronize":"Synchronize records over FTP","records_link":"Click here to see your records","sync_error":"Couldn't synchronize records"},"records_count":"# Records","edit_on_map":"edit on map","invalid_duration":"The event start time must precede the end time.","invalid_end_time":"Please make sure to set an end time in the future.","activation_time_help":"This event will activate {at} and last for {duration}.","activation_immediate_help":"This event will activate immediately and last for {duration}.","targeted_user_groups":"Targeted User groups","selected_user_groups_count":"Users in {count} group will be notified. | Users in {count} groups will be notified.","user_group_categories":"Categories","user_groups":"Groups","all_users_will_be_notified":"All users in the event's area will be notified.","user_group_click_here":"Click here","user_group_to_change_selection":"to change your selection.","user_group_you_may":"You may","user_group_specify":"specify","user_group_which_groups_to_target":"which groups of users will be able to see the event."},"notifications":{"notifications":"Notification delivery status"},"records":{"none_available":"No records are available at this time.","video":"video | videos","has_been_recorded":"has been recorded for you! | have been recorded for you!","recorded":"Recorded","ago":"ago","by":"by","download":"Download","link":"link","source_url":"Source URL","delete_confirmation":"Are you sure you want to delete this record?","new_available":"new record is available. | new records are available.","click_here_to_refresh":"Click here to refresh.","related_streams_title":"Related streams","related_streams_help":"Other videos recorded by nearby users while this marker was active","edit_comment":"Edit comment","delete":"Delete video","delete_image":"Delete photo","restore":"Restore video","start_merge":"Start merge","approve":"approve"},"map":{"help":"Double-click any location on the map or drag the marker to move its position.","coordinates":"Coordinates"},"settings":{"settings":"Settings","ftp":"FTP Settings","push_localization":"Push Localization Settings","push_thank_you":"Thank you message","push_marker_request":"Marker Request message","choose_export":"Choose the export format of your events","choose_export_individual_format":"Choose the export individual format of your events"},"menu":{"videos":"Videos","images":"Images","missions":"Missions","users":"Users","settings":"Settings","logout":"Log out"},"process_status":{"cut_waiting":"Cutting - waiting","cut_running":"Cutting - in progress","cut_done":"Cutting - finished!","intro_waiting":"Adding intro/outro - waiting","intro_running":"Adding intro/outro - in progress","intro_error":"","intro_done":"Adding intro/outro - finished!","ftpupload_waiting":"Uploading to Digiteka - waiting","ftpupload_running":"Uploading to Digiteka - in progress","ftpupload_done":"Sent to Digiteka - waiting for link...","download_waiting":"File is processing"},"upload_video":{"drop_file_or_click":"Drop file or click to upload","support_file":"Video files only","max_file_size":"Maximum file size","type":"Category","start_typing":"Your name (start typing to search)","title":"Title","description":"Description","you_must_add_video_file":"Please add a video to upload","field_is_required":"This field is required","please_select_video_file":"Please select video file","please_check_file":"Please check the file is not over 500MB","checked":"Checked","file_name":"File Name","file_size":"File Size","extension":"Extension","remove_file":"Remove file","upload_video_title":"Upload Video","download_video_title":"Download Videos","close":"Close","upload":"Upload","upload_progress":"Upload in progress"},"detail_video":{"title":"title","description":"description","user":"user","user_group":"user group","date":"date","time":"time","gps":"gps","duration":"duration","device":"device","resolution":"resolution","size":"size","full_address":"full address","category":"category","detected_tags":"tags","comment":"comment"}}

/***/ }),
/* 1083 */
/***/ (function(module, exports) {

module.exports = {"login":"Se Connecter","logout":"Se déconnecter","ok":"OK","all":"Toutes","Pro Apps":"Appli Pro","cancel":"Annuler","delete":"Supprimer","Ordering":"Trier par...","confirmation":"Confirmation","save":"Enregistrer","optional":"Optionnel","time_ago":"il y a {time}","spacing":"&nbsp;","language_input_required":"Veuillez compléter ce champ en une langue au minimum.","update_available":"Une nouvelle version de la Media Platform est disponible","update_prompt":"Veuillez actualiser la page pour effectuer la mise à jour","update":"Actualiser","individual_records":"Vidéos Individuelles","digiteka_copy_link_title":"Lien Digiteka disponible - cliquez pour copier","new":"new","approved":"validees","deleted":"supprimees","approve":"selectionner","approve_msg":"Les vidéos en cours seront disponibles dans quelques minutes dans l'onglet \"Mes Vidéos”","merge":"fusionner","merge_abd_approve":"fusionner & valider","merge_msg":"Fusion des vidéos en cours","merge_and_approve_msg_pm":"Fusion des vidéos en cours - elles seront disponibles dans quelques minutes dans l’onglet des vidéos “Validées”","merge_and_approve_msg_iframe_digiteka":"Fusion des vidéos en cours - elles seront disponibles dans quelques minutes dans l’onglet “Mes Vidéos”","reject":"supprimer","error":{"generic":"Temporairement indisponible","access_denied":"Accès refusé","connection":"Impossible de se connecter au serveur","forbidden":"Votre compte utilisateur ne dispose pas des permissions nécessaires.","contact_us":"<a href=\"mailto:media-platform@look-app.net\">Contactez-nous</a> pour vérifier votre accès à la Media Platform.","server":"Aïe aïe aïe ! Une erreur s’est produite lors du traitement de votre requête.","apologies":"Notre équipe a été automatiquement notifiée et nous allons réparer cela au plus vite !","help":"Vous pouvez <a href=\"javascript:window.location.reload(true)\">rafraichir la page et réessayer</a>, retourner à la <a href=\"/\">page d'accueil</a>, ou <a href=\"mailto:media-platform@look-app.net\">nous contacter</a> si le problème persiste."},"brand":{"label":"Branding","help":"Sélectionnez la marque à utiliser pour cet événement :"},"user":{"users":"Usagers","view":"View","filter":{"name":"Search by name","usergroup":"Filtrer par édition","filter_by_user":"Filtrer par utilisateur","consumer":"Filtrer par édition"}},"ordering":{"by_shooting_date_new_old":"Trier par date d’enregistrement: récent - ancien","by_shooting_date_old_new":"Trier par date d’enregistrement: ancien - récent","by_approve_date_new_old":"Trier par date de validation: récent - ancien","by_approve_date_old_new":"Trier par date de validation: ancien - récent"},"departments":{"all":"Tous les départements","filter_by_department":"Filtrer par département"},"marker":{"add":"Ajouter un nouvel événement","past":"Archives","future":"Événements futurs","active":"Événements actifs","event":"Événement","events":"Événements","start_date":"Début","end_date":"Fin","create":"Créer un nouvel événement","edit":"Modifier l’événement","download_csv":"Exporter en .csv","delete_confirmation":"Voulez-vous supprimer cet événement ?","address":"Adresse","latitude":"latitude","longitude":"longitude","radius":"rayon","meters":"mètres","location":"Lieu","time":"Date","name":"Titre de l’événement","description":"Courte description","long_description":"Longue description","info_link":"Lien vers informations supplémentaires","thanks_link":"Lien de redirection","reveal_at":"Révéler l’événement dans l’app","reveal_immediate":"Immédiatement","reveal_event_start":"Quand l’événement commence","tags":{"title":"Filtrage des tags","placeholder":"Rechercher un tag"},"placeholder":{"name":"Nom de l’événement","description":"La description de l’événement","long_description":"Une description plus longue de l’événement","ml_keyword":"Mot-clé (machine learning beta)","address":"Entrez une adresse ici ou choisissez un lieu sur la carte","address_search":"Entrez une adresse ici pour chercher un lieu","info_link":"(facultatif) Lien vers une page d’informations supplémentaires sur l’événement (doit commencer par http:// ou https://)","thanks_link":"(facultatif) Lien de redirection des utilisateurs après l’enregistrement d'une vidéo (doit commencer par http:// or https://)","push_comment":"Envoyer un commentaire personnalisé"},"ftp":{"synchronize":"Synchroniser les enregistrements via FTP","records_link":"Cliquez ici pour voir vos archives","sync_error":"Impossible de synchroniser les enregistrements"},"records_count":"# vidéos","edit_on_map":"choisir sur la carte","invalid_duration":"Veuillez indiquer une heure de fin de l’événement qui précède son début.","invalid_end_time":"Veuillez indiquer une heure (future) valide pour la fin de l’événement.","activation_time_help":"Cet événement commencera {at} et durera {duration}.","activation_immediate_help":"Cet événement va commencer immédiatement et durera {duration}.","targeted_user_groups":"Groupes utilisateurs","selected_user_groups_count":"Les utilisateurs d’un groupe sélectionné seront avertis. | Les utilisateurs de {count} groupes seront avertis.","user_group_categories":"Catégories","user_groups":"Groupes","all_users_will_be_notified":"Tous les utilisateurs présents dans la surface définie seront avertis.","user_group_click_here":"Cliquez ici","user_group_to_change_selection":"pour changer votre sélection.","user_group_you_may":"Vous pouvez","user_group_specify":"cibler","user_group_which_groups_to_target":"certains groupes d’utilisateurs."},"notifications":{"notifications":"Suivi des notifications"},"records":{"none_available":"Aucune vidéo n'est disponible pour le moment.","video":"vidéo | vidéos","has_been_recorded":"a été enregistrée pour vous ! | ont été enregistrées pour vous !","recorded":"Enregistré il y a","ago":" ","by":"par","download":"Télécharger","link":"Lien","source_url":"Source URL","delete_confirmation":"Êtes-vous sûr de vouloir supprimer cette vidéo ?","new_available":"nouvelle vidéo est disponible. | nouvelles vidéos sont disponibles.","click_here_to_refresh":"Cliquez ici pour rafraichir la liste.","related_streams_title":"Streams similaires","related_streams_help":"Autres vidéos réalisées par les utilisateurs aux alentours de l'événement","edit_comment":"Editer le titre et/ou la description","delete":"Supprimer la vidéo","delete_image":"Supprimer la photo","restore":"Restaurer la vidéo","start_merge":"Démarrer la fusiEditer le titre et/ou la descriptionon","approve":"valider"},"map":{"help":"Double-cliquez sur la carte ou glissez-déposez le marqueur pour modifier sa position.","coordinates":"Coordonnées"},"settings":{"settings":"Paramètres","ftp":"FTP Settings","push_localization":"Push Localization Settings","push_thank_you":"Thank you message","push_marker_request":"Marker Request message","choose_export":"Choose the export format of your events","choose_export_individual_format":"Choose the export individual format of your events"},"menu":{"videos":"Vidéos","images":"Images","missions":"Missions","users":"Utilisateurs","settings":"Réglages","logout":"Se déconnecter"},"process_status":{"cut_waiting":"'Cut Cut' - attendre","cut_running":"'Cut Cut' - en cours...","cut_done":"'Cut cut' - Terminé!","intro_waiting":"Ajout de l’intro/outro - attendre","intro_running":"Ajout de l’intro/outro - en cours...","intro_error":"","intro_done":"Ajout de l’intro/outro - Terminé","ftpupload_waiting":"Envoyé chez Digiteka - attendre","ftpupload_running":"Envoyé chez Digiteka - en attente du lien...","ftpupload_done":"Vidéo envoyée chez Digiteka - en attente du lien...","download_waiting":"Le fichier est en cours de traitement"},"upload_video":{"drop_file_or_click":"Glissez un fichier ou cliquez ici","support_file":"Format vidéo uniquement","max_file_size":"Taille max","type":"Categorie","start_typing":"Votre nom (entrez les premières lettres pour l'auto-suggestion)","title":"Titre de la vidéo","description":"Description","you_must_add_video_file":"Veuillez ajouter une vidéo à envoyer","field_is_required":"Ce champ est requis","please_select_video_file":"Veuillez séléctionner une vidéo","please_check_file":"La taille maximale de fichier est de 500MB","checked":"Checked","file_name":"Nom du fichier","file_size":"Taille du fichier","extension":"Extension","remove_file":"Supprimer le fichier","upload_video_title":"Téléchargez une vidéo","download_video_title":"Download Videos","close":"Annuler","upload":"Envoyer","upload_progress":"Téléchargement en cours"},"detail_video":{"title":"titre","description":"description","user":"utilisateur","user_group":"edition","date":"date","time":"temps","gps":"gps","duration":"duree","device":"appareil","resolution":"resolution","size":"taille","full_address":"adresse","category":"categorie","detected_tags":"tags","comment":"commentaire"}}

/***/ }),
/* 1084 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[422]);


// WEBPACK FOOTER //
// static/js/app.36dca35cbd4b95775797.js